
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire292e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire292e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2XWkz", function(module, exports) {
module.exports = {
    "application/andrew-inset": [
        "ez"
    ],
    "application/applixware": [
        "aw"
    ],
    "application/atom+xml": [
        "atom"
    ],
    "application/atomcat+xml": [
        "atomcat"
    ],
    "application/atomdeleted+xml": [
        "atomdeleted"
    ],
    "application/atomsvc+xml": [
        "atomsvc"
    ],
    "application/atsc-dwd+xml": [
        "dwd"
    ],
    "application/atsc-held+xml": [
        "held"
    ],
    "application/atsc-rsat+xml": [
        "rsat"
    ],
    "application/bdoc": [
        "bdoc"
    ],
    "application/calendar+xml": [
        "xcs"
    ],
    "application/ccxml+xml": [
        "ccxml"
    ],
    "application/cdfx+xml": [
        "cdfx"
    ],
    "application/cdmi-capability": [
        "cdmia"
    ],
    "application/cdmi-container": [
        "cdmic"
    ],
    "application/cdmi-domain": [
        "cdmid"
    ],
    "application/cdmi-object": [
        "cdmio"
    ],
    "application/cdmi-queue": [
        "cdmiq"
    ],
    "application/cu-seeme": [
        "cu"
    ],
    "application/dash+xml": [
        "mpd"
    ],
    "application/davmount+xml": [
        "davmount"
    ],
    "application/docbook+xml": [
        "dbk"
    ],
    "application/dssc+der": [
        "dssc"
    ],
    "application/dssc+xml": [
        "xdssc"
    ],
    "application/ecmascript": [
        "es",
        "ecma"
    ],
    "application/emma+xml": [
        "emma"
    ],
    "application/emotionml+xml": [
        "emotionml"
    ],
    "application/epub+zip": [
        "epub"
    ],
    "application/exi": [
        "exi"
    ],
    "application/express": [
        "exp"
    ],
    "application/fdt+xml": [
        "fdt"
    ],
    "application/font-tdpfr": [
        "pfr"
    ],
    "application/geo+json": [
        "geojson"
    ],
    "application/gml+xml": [
        "gml"
    ],
    "application/gpx+xml": [
        "gpx"
    ],
    "application/gxf": [
        "gxf"
    ],
    "application/gzip": [
        "gz"
    ],
    "application/hjson": [
        "hjson"
    ],
    "application/hyperstudio": [
        "stk"
    ],
    "application/inkml+xml": [
        "ink",
        "inkml"
    ],
    "application/ipfix": [
        "ipfix"
    ],
    "application/its+xml": [
        "its"
    ],
    "application/java-archive": [
        "jar",
        "war",
        "ear"
    ],
    "application/java-serialized-object": [
        "ser"
    ],
    "application/java-vm": [
        "class"
    ],
    "application/javascript": [
        "js",
        "mjs"
    ],
    "application/json": [
        "json",
        "map"
    ],
    "application/json5": [
        "json5"
    ],
    "application/jsonml+json": [
        "jsonml"
    ],
    "application/ld+json": [
        "jsonld"
    ],
    "application/lgr+xml": [
        "lgr"
    ],
    "application/lost+xml": [
        "lostxml"
    ],
    "application/mac-binhex40": [
        "hqx"
    ],
    "application/mac-compactpro": [
        "cpt"
    ],
    "application/mads+xml": [
        "mads"
    ],
    "application/manifest+json": [
        "webmanifest"
    ],
    "application/marc": [
        "mrc"
    ],
    "application/marcxml+xml": [
        "mrcx"
    ],
    "application/mathematica": [
        "ma",
        "nb",
        "mb"
    ],
    "application/mathml+xml": [
        "mathml"
    ],
    "application/mbox": [
        "mbox"
    ],
    "application/mediaservercontrol+xml": [
        "mscml"
    ],
    "application/metalink+xml": [
        "metalink"
    ],
    "application/metalink4+xml": [
        "meta4"
    ],
    "application/mets+xml": [
        "mets"
    ],
    "application/mmt-aei+xml": [
        "maei"
    ],
    "application/mmt-usd+xml": [
        "musd"
    ],
    "application/mods+xml": [
        "mods"
    ],
    "application/mp21": [
        "m21",
        "mp21"
    ],
    "application/mp4": [
        "mp4s",
        "m4p"
    ],
    "application/msword": [
        "doc",
        "dot"
    ],
    "application/mxf": [
        "mxf"
    ],
    "application/n-quads": [
        "nq"
    ],
    "application/n-triples": [
        "nt"
    ],
    "application/node": [
        "cjs"
    ],
    "application/octet-stream": [
        "bin",
        "dms",
        "lrf",
        "mar",
        "so",
        "dist",
        "distz",
        "pkg",
        "bpk",
        "dump",
        "elc",
        "deploy",
        "exe",
        "dll",
        "deb",
        "dmg",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "buffer"
    ],
    "application/oda": [
        "oda"
    ],
    "application/oebps-package+xml": [
        "opf"
    ],
    "application/ogg": [
        "ogx"
    ],
    "application/omdoc+xml": [
        "omdoc"
    ],
    "application/onenote": [
        "onetoc",
        "onetoc2",
        "onetmp",
        "onepkg"
    ],
    "application/oxps": [
        "oxps"
    ],
    "application/p2p-overlay+xml": [
        "relo"
    ],
    "application/patch-ops-error+xml": [
        "xer"
    ],
    "application/pdf": [
        "pdf"
    ],
    "application/pgp-encrypted": [
        "pgp"
    ],
    "application/pgp-signature": [
        "asc",
        "sig"
    ],
    "application/pics-rules": [
        "prf"
    ],
    "application/pkcs10": [
        "p10"
    ],
    "application/pkcs7-mime": [
        "p7m",
        "p7c"
    ],
    "application/pkcs7-signature": [
        "p7s"
    ],
    "application/pkcs8": [
        "p8"
    ],
    "application/pkix-attr-cert": [
        "ac"
    ],
    "application/pkix-cert": [
        "cer"
    ],
    "application/pkix-crl": [
        "crl"
    ],
    "application/pkix-pkipath": [
        "pkipath"
    ],
    "application/pkixcmp": [
        "pki"
    ],
    "application/pls+xml": [
        "pls"
    ],
    "application/postscript": [
        "ai",
        "eps",
        "ps"
    ],
    "application/provenance+xml": [
        "provx"
    ],
    "application/pskc+xml": [
        "pskcxml"
    ],
    "application/raml+yaml": [
        "raml"
    ],
    "application/rdf+xml": [
        "rdf",
        "owl"
    ],
    "application/reginfo+xml": [
        "rif"
    ],
    "application/relax-ng-compact-syntax": [
        "rnc"
    ],
    "application/resource-lists+xml": [
        "rl"
    ],
    "application/resource-lists-diff+xml": [
        "rld"
    ],
    "application/rls-services+xml": [
        "rs"
    ],
    "application/route-apd+xml": [
        "rapd"
    ],
    "application/route-s-tsid+xml": [
        "sls"
    ],
    "application/route-usd+xml": [
        "rusd"
    ],
    "application/rpki-ghostbusters": [
        "gbr"
    ],
    "application/rpki-manifest": [
        "mft"
    ],
    "application/rpki-roa": [
        "roa"
    ],
    "application/rsd+xml": [
        "rsd"
    ],
    "application/rss+xml": [
        "rss"
    ],
    "application/rtf": [
        "rtf"
    ],
    "application/sbml+xml": [
        "sbml"
    ],
    "application/scvp-cv-request": [
        "scq"
    ],
    "application/scvp-cv-response": [
        "scs"
    ],
    "application/scvp-vp-request": [
        "spq"
    ],
    "application/scvp-vp-response": [
        "spp"
    ],
    "application/sdp": [
        "sdp"
    ],
    "application/senml+xml": [
        "senmlx"
    ],
    "application/sensml+xml": [
        "sensmlx"
    ],
    "application/set-payment-initiation": [
        "setpay"
    ],
    "application/set-registration-initiation": [
        "setreg"
    ],
    "application/shf+xml": [
        "shf"
    ],
    "application/sieve": [
        "siv",
        "sieve"
    ],
    "application/smil+xml": [
        "smi",
        "smil"
    ],
    "application/sparql-query": [
        "rq"
    ],
    "application/sparql-results+xml": [
        "srx"
    ],
    "application/srgs": [
        "gram"
    ],
    "application/srgs+xml": [
        "grxml"
    ],
    "application/sru+xml": [
        "sru"
    ],
    "application/ssdl+xml": [
        "ssdl"
    ],
    "application/ssml+xml": [
        "ssml"
    ],
    "application/swid+xml": [
        "swidtag"
    ],
    "application/tei+xml": [
        "tei",
        "teicorpus"
    ],
    "application/thraud+xml": [
        "tfi"
    ],
    "application/timestamped-data": [
        "tsd"
    ],
    "application/toml": [
        "toml"
    ],
    "application/trig": [
        "trig"
    ],
    "application/ttml+xml": [
        "ttml"
    ],
    "application/ubjson": [
        "ubj"
    ],
    "application/urc-ressheet+xml": [
        "rsheet"
    ],
    "application/urc-targetdesc+xml": [
        "td"
    ],
    "application/voicexml+xml": [
        "vxml"
    ],
    "application/wasm": [
        "wasm"
    ],
    "application/widget": [
        "wgt"
    ],
    "application/winhlp": [
        "hlp"
    ],
    "application/wsdl+xml": [
        "wsdl"
    ],
    "application/wspolicy+xml": [
        "wspolicy"
    ],
    "application/xaml+xml": [
        "xaml"
    ],
    "application/xcap-att+xml": [
        "xav"
    ],
    "application/xcap-caps+xml": [
        "xca"
    ],
    "application/xcap-diff+xml": [
        "xdf"
    ],
    "application/xcap-el+xml": [
        "xel"
    ],
    "application/xcap-ns+xml": [
        "xns"
    ],
    "application/xenc+xml": [
        "xenc"
    ],
    "application/xhtml+xml": [
        "xhtml",
        "xht"
    ],
    "application/xliff+xml": [
        "xlf"
    ],
    "application/xml": [
        "xml",
        "xsl",
        "xsd",
        "rng"
    ],
    "application/xml-dtd": [
        "dtd"
    ],
    "application/xop+xml": [
        "xop"
    ],
    "application/xproc+xml": [
        "xpl"
    ],
    "application/xslt+xml": [
        "*xsl",
        "xslt"
    ],
    "application/xspf+xml": [
        "xspf"
    ],
    "application/xv+xml": [
        "mxml",
        "xhvml",
        "xvml",
        "xvm"
    ],
    "application/yang": [
        "yang"
    ],
    "application/yin+xml": [
        "yin"
    ],
    "application/zip": [
        "zip"
    ],
    "audio/3gpp": [
        "*3gpp"
    ],
    "audio/adpcm": [
        "adp"
    ],
    "audio/amr": [
        "amr"
    ],
    "audio/basic": [
        "au",
        "snd"
    ],
    "audio/midi": [
        "mid",
        "midi",
        "kar",
        "rmi"
    ],
    "audio/mobile-xmf": [
        "mxmf"
    ],
    "audio/mp3": [
        "*mp3"
    ],
    "audio/mp4": [
        "m4a",
        "mp4a"
    ],
    "audio/mpeg": [
        "mpga",
        "mp2",
        "mp2a",
        "mp3",
        "m2a",
        "m3a"
    ],
    "audio/ogg": [
        "oga",
        "ogg",
        "spx",
        "opus"
    ],
    "audio/s3m": [
        "s3m"
    ],
    "audio/silk": [
        "sil"
    ],
    "audio/wav": [
        "wav"
    ],
    "audio/wave": [
        "*wav"
    ],
    "audio/webm": [
        "weba"
    ],
    "audio/xm": [
        "xm"
    ],
    "font/collection": [
        "ttc"
    ],
    "font/otf": [
        "otf"
    ],
    "font/ttf": [
        "ttf"
    ],
    "font/woff": [
        "woff"
    ],
    "font/woff2": [
        "woff2"
    ],
    "image/aces": [
        "exr"
    ],
    "image/apng": [
        "apng"
    ],
    "image/avif": [
        "avif"
    ],
    "image/bmp": [
        "bmp"
    ],
    "image/cgm": [
        "cgm"
    ],
    "image/dicom-rle": [
        "drle"
    ],
    "image/emf": [
        "emf"
    ],
    "image/fits": [
        "fits"
    ],
    "image/g3fax": [
        "g3"
    ],
    "image/gif": [
        "gif"
    ],
    "image/heic": [
        "heic"
    ],
    "image/heic-sequence": [
        "heics"
    ],
    "image/heif": [
        "heif"
    ],
    "image/heif-sequence": [
        "heifs"
    ],
    "image/hej2k": [
        "hej2"
    ],
    "image/hsj2": [
        "hsj2"
    ],
    "image/ief": [
        "ief"
    ],
    "image/jls": [
        "jls"
    ],
    "image/jp2": [
        "jp2",
        "jpg2"
    ],
    "image/jpeg": [
        "jpeg",
        "jpg",
        "jpe"
    ],
    "image/jph": [
        "jph"
    ],
    "image/jphc": [
        "jhc"
    ],
    "image/jpm": [
        "jpm"
    ],
    "image/jpx": [
        "jpx",
        "jpf"
    ],
    "image/jxr": [
        "jxr"
    ],
    "image/jxra": [
        "jxra"
    ],
    "image/jxrs": [
        "jxrs"
    ],
    "image/jxs": [
        "jxs"
    ],
    "image/jxsc": [
        "jxsc"
    ],
    "image/jxsi": [
        "jxsi"
    ],
    "image/jxss": [
        "jxss"
    ],
    "image/ktx": [
        "ktx"
    ],
    "image/ktx2": [
        "ktx2"
    ],
    "image/png": [
        "png"
    ],
    "image/sgi": [
        "sgi"
    ],
    "image/svg+xml": [
        "svg",
        "svgz"
    ],
    "image/t38": [
        "t38"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/tiff-fx": [
        "tfx"
    ],
    "image/webp": [
        "webp"
    ],
    "image/wmf": [
        "wmf"
    ],
    "message/disposition-notification": [
        "disposition-notification"
    ],
    "message/global": [
        "u8msg"
    ],
    "message/global-delivery-status": [
        "u8dsn"
    ],
    "message/global-disposition-notification": [
        "u8mdn"
    ],
    "message/global-headers": [
        "u8hdr"
    ],
    "message/rfc822": [
        "eml",
        "mime"
    ],
    "model/3mf": [
        "3mf"
    ],
    "model/gltf+json": [
        "gltf"
    ],
    "model/gltf-binary": [
        "glb"
    ],
    "model/iges": [
        "igs",
        "iges"
    ],
    "model/mesh": [
        "msh",
        "mesh",
        "silo"
    ],
    "model/mtl": [
        "mtl"
    ],
    "model/obj": [
        "obj"
    ],
    "model/step+xml": [
        "stpx"
    ],
    "model/step+zip": [
        "stpz"
    ],
    "model/step-xml+zip": [
        "stpxz"
    ],
    "model/stl": [
        "stl"
    ],
    "model/vrml": [
        "wrl",
        "vrml"
    ],
    "model/x3d+binary": [
        "*x3db",
        "x3dbz"
    ],
    "model/x3d+fastinfoset": [
        "x3db"
    ],
    "model/x3d+vrml": [
        "*x3dv",
        "x3dvz"
    ],
    "model/x3d+xml": [
        "x3d",
        "x3dz"
    ],
    "model/x3d-vrml": [
        "x3dv"
    ],
    "text/cache-manifest": [
        "appcache",
        "manifest"
    ],
    "text/calendar": [
        "ics",
        "ifb"
    ],
    "text/coffeescript": [
        "coffee",
        "litcoffee"
    ],
    "text/css": [
        "css"
    ],
    "text/csv": [
        "csv"
    ],
    "text/html": [
        "html",
        "htm",
        "shtml"
    ],
    "text/jade": [
        "jade"
    ],
    "text/jsx": [
        "jsx"
    ],
    "text/less": [
        "less"
    ],
    "text/markdown": [
        "markdown",
        "md"
    ],
    "text/mathml": [
        "mml"
    ],
    "text/mdx": [
        "mdx"
    ],
    "text/n3": [
        "n3"
    ],
    "text/plain": [
        "txt",
        "text",
        "conf",
        "def",
        "list",
        "log",
        "in",
        "ini"
    ],
    "text/richtext": [
        "rtx"
    ],
    "text/rtf": [
        "*rtf"
    ],
    "text/sgml": [
        "sgml",
        "sgm"
    ],
    "text/shex": [
        "shex"
    ],
    "text/slim": [
        "slim",
        "slm"
    ],
    "text/spdx": [
        "spdx"
    ],
    "text/stylus": [
        "stylus",
        "styl"
    ],
    "text/tab-separated-values": [
        "tsv"
    ],
    "text/troff": [
        "t",
        "tr",
        "roff",
        "man",
        "me",
        "ms"
    ],
    "text/turtle": [
        "ttl"
    ],
    "text/uri-list": [
        "uri",
        "uris",
        "urls"
    ],
    "text/vcard": [
        "vcard"
    ],
    "text/vtt": [
        "vtt"
    ],
    "text/xml": [
        "*xml"
    ],
    "text/yaml": [
        "yaml",
        "yml"
    ],
    "video/3gpp": [
        "3gp",
        "3gpp"
    ],
    "video/3gpp2": [
        "3g2"
    ],
    "video/h261": [
        "h261"
    ],
    "video/h263": [
        "h263"
    ],
    "video/h264": [
        "h264"
    ],
    "video/iso.segment": [
        "m4s"
    ],
    "video/jpeg": [
        "jpgv"
    ],
    "video/jpm": [
        "*jpm",
        "jpgm"
    ],
    "video/mj2": [
        "mj2",
        "mjp2"
    ],
    "video/mp2t": [
        "ts"
    ],
    "video/mp4": [
        "mp4",
        "mp4v",
        "mpg4"
    ],
    "video/mpeg": [
        "mpeg",
        "mpg",
        "mpe",
        "m1v",
        "m2v"
    ],
    "video/ogg": [
        "ogv"
    ],
    "video/quicktime": [
        "qt",
        "mov"
    ],
    "video/webm": [
        "webm"
    ]
};

});

parcelRegister("lMmGq", function(module, exports) {
module.exports = {
    "application/prs.cww": [
        "cww"
    ],
    "application/vnd.1000minds.decision-model+xml": [
        "1km"
    ],
    "application/vnd.3gpp.pic-bw-large": [
        "plb"
    ],
    "application/vnd.3gpp.pic-bw-small": [
        "psb"
    ],
    "application/vnd.3gpp.pic-bw-var": [
        "pvb"
    ],
    "application/vnd.3gpp2.tcap": [
        "tcap"
    ],
    "application/vnd.3m.post-it-notes": [
        "pwn"
    ],
    "application/vnd.accpac.simply.aso": [
        "aso"
    ],
    "application/vnd.accpac.simply.imp": [
        "imp"
    ],
    "application/vnd.acucobol": [
        "acu"
    ],
    "application/vnd.acucorp": [
        "atc",
        "acutc"
    ],
    "application/vnd.adobe.air-application-installer-package+zip": [
        "air"
    ],
    "application/vnd.adobe.formscentral.fcdt": [
        "fcdt"
    ],
    "application/vnd.adobe.fxp": [
        "fxp",
        "fxpl"
    ],
    "application/vnd.adobe.xdp+xml": [
        "xdp"
    ],
    "application/vnd.adobe.xfdf": [
        "xfdf"
    ],
    "application/vnd.ahead.space": [
        "ahead"
    ],
    "application/vnd.airzip.filesecure.azf": [
        "azf"
    ],
    "application/vnd.airzip.filesecure.azs": [
        "azs"
    ],
    "application/vnd.amazon.ebook": [
        "azw"
    ],
    "application/vnd.americandynamics.acc": [
        "acc"
    ],
    "application/vnd.amiga.ami": [
        "ami"
    ],
    "application/vnd.android.package-archive": [
        "apk"
    ],
    "application/vnd.anser-web-certificate-issue-initiation": [
        "cii"
    ],
    "application/vnd.anser-web-funds-transfer-initiation": [
        "fti"
    ],
    "application/vnd.antix.game-component": [
        "atx"
    ],
    "application/vnd.apple.installer+xml": [
        "mpkg"
    ],
    "application/vnd.apple.keynote": [
        "key"
    ],
    "application/vnd.apple.mpegurl": [
        "m3u8"
    ],
    "application/vnd.apple.numbers": [
        "numbers"
    ],
    "application/vnd.apple.pages": [
        "pages"
    ],
    "application/vnd.apple.pkpass": [
        "pkpass"
    ],
    "application/vnd.aristanetworks.swi": [
        "swi"
    ],
    "application/vnd.astraea-software.iota": [
        "iota"
    ],
    "application/vnd.audiograph": [
        "aep"
    ],
    "application/vnd.balsamiq.bmml+xml": [
        "bmml"
    ],
    "application/vnd.blueice.multipass": [
        "mpm"
    ],
    "application/vnd.bmi": [
        "bmi"
    ],
    "application/vnd.businessobjects": [
        "rep"
    ],
    "application/vnd.chemdraw+xml": [
        "cdxml"
    ],
    "application/vnd.chipnuts.karaoke-mmd": [
        "mmd"
    ],
    "application/vnd.cinderella": [
        "cdy"
    ],
    "application/vnd.citationstyles.style+xml": [
        "csl"
    ],
    "application/vnd.claymore": [
        "cla"
    ],
    "application/vnd.cloanto.rp9": [
        "rp9"
    ],
    "application/vnd.clonk.c4group": [
        "c4g",
        "c4d",
        "c4f",
        "c4p",
        "c4u"
    ],
    "application/vnd.cluetrust.cartomobile-config": [
        "c11amc"
    ],
    "application/vnd.cluetrust.cartomobile-config-pkg": [
        "c11amz"
    ],
    "application/vnd.commonspace": [
        "csp"
    ],
    "application/vnd.contact.cmsg": [
        "cdbcmsg"
    ],
    "application/vnd.cosmocaller": [
        "cmc"
    ],
    "application/vnd.crick.clicker": [
        "clkx"
    ],
    "application/vnd.crick.clicker.keyboard": [
        "clkk"
    ],
    "application/vnd.crick.clicker.palette": [
        "clkp"
    ],
    "application/vnd.crick.clicker.template": [
        "clkt"
    ],
    "application/vnd.crick.clicker.wordbank": [
        "clkw"
    ],
    "application/vnd.criticaltools.wbs+xml": [
        "wbs"
    ],
    "application/vnd.ctc-posml": [
        "pml"
    ],
    "application/vnd.cups-ppd": [
        "ppd"
    ],
    "application/vnd.curl.car": [
        "car"
    ],
    "application/vnd.curl.pcurl": [
        "pcurl"
    ],
    "application/vnd.dart": [
        "dart"
    ],
    "application/vnd.data-vision.rdz": [
        "rdz"
    ],
    "application/vnd.dbf": [
        "dbf"
    ],
    "application/vnd.dece.data": [
        "uvf",
        "uvvf",
        "uvd",
        "uvvd"
    ],
    "application/vnd.dece.ttml+xml": [
        "uvt",
        "uvvt"
    ],
    "application/vnd.dece.unspecified": [
        "uvx",
        "uvvx"
    ],
    "application/vnd.dece.zip": [
        "uvz",
        "uvvz"
    ],
    "application/vnd.denovo.fcselayout-link": [
        "fe_launch"
    ],
    "application/vnd.dna": [
        "dna"
    ],
    "application/vnd.dolby.mlp": [
        "mlp"
    ],
    "application/vnd.dpgraph": [
        "dpg"
    ],
    "application/vnd.dreamfactory": [
        "dfac"
    ],
    "application/vnd.ds-keypoint": [
        "kpxx"
    ],
    "application/vnd.dvb.ait": [
        "ait"
    ],
    "application/vnd.dvb.service": [
        "svc"
    ],
    "application/vnd.dynageo": [
        "geo"
    ],
    "application/vnd.ecowin.chart": [
        "mag"
    ],
    "application/vnd.enliven": [
        "nml"
    ],
    "application/vnd.epson.esf": [
        "esf"
    ],
    "application/vnd.epson.msf": [
        "msf"
    ],
    "application/vnd.epson.quickanime": [
        "qam"
    ],
    "application/vnd.epson.salt": [
        "slt"
    ],
    "application/vnd.epson.ssf": [
        "ssf"
    ],
    "application/vnd.eszigno3+xml": [
        "es3",
        "et3"
    ],
    "application/vnd.ezpix-album": [
        "ez2"
    ],
    "application/vnd.ezpix-package": [
        "ez3"
    ],
    "application/vnd.fdf": [
        "fdf"
    ],
    "application/vnd.fdsn.mseed": [
        "mseed"
    ],
    "application/vnd.fdsn.seed": [
        "seed",
        "dataless"
    ],
    "application/vnd.flographit": [
        "gph"
    ],
    "application/vnd.fluxtime.clip": [
        "ftc"
    ],
    "application/vnd.framemaker": [
        "fm",
        "frame",
        "maker",
        "book"
    ],
    "application/vnd.frogans.fnc": [
        "fnc"
    ],
    "application/vnd.frogans.ltf": [
        "ltf"
    ],
    "application/vnd.fsc.weblaunch": [
        "fsc"
    ],
    "application/vnd.fujitsu.oasys": [
        "oas"
    ],
    "application/vnd.fujitsu.oasys2": [
        "oa2"
    ],
    "application/vnd.fujitsu.oasys3": [
        "oa3"
    ],
    "application/vnd.fujitsu.oasysgp": [
        "fg5"
    ],
    "application/vnd.fujitsu.oasysprs": [
        "bh2"
    ],
    "application/vnd.fujixerox.ddd": [
        "ddd"
    ],
    "application/vnd.fujixerox.docuworks": [
        "xdw"
    ],
    "application/vnd.fujixerox.docuworks.binder": [
        "xbd"
    ],
    "application/vnd.fuzzysheet": [
        "fzs"
    ],
    "application/vnd.genomatix.tuxedo": [
        "txd"
    ],
    "application/vnd.geogebra.file": [
        "ggb"
    ],
    "application/vnd.geogebra.tool": [
        "ggt"
    ],
    "application/vnd.geometry-explorer": [
        "gex",
        "gre"
    ],
    "application/vnd.geonext": [
        "gxt"
    ],
    "application/vnd.geoplan": [
        "g2w"
    ],
    "application/vnd.geospace": [
        "g3w"
    ],
    "application/vnd.gmx": [
        "gmx"
    ],
    "application/vnd.google-apps.document": [
        "gdoc"
    ],
    "application/vnd.google-apps.presentation": [
        "gslides"
    ],
    "application/vnd.google-apps.spreadsheet": [
        "gsheet"
    ],
    "application/vnd.google-earth.kml+xml": [
        "kml"
    ],
    "application/vnd.google-earth.kmz": [
        "kmz"
    ],
    "application/vnd.grafeq": [
        "gqf",
        "gqs"
    ],
    "application/vnd.groove-account": [
        "gac"
    ],
    "application/vnd.groove-help": [
        "ghf"
    ],
    "application/vnd.groove-identity-message": [
        "gim"
    ],
    "application/vnd.groove-injector": [
        "grv"
    ],
    "application/vnd.groove-tool-message": [
        "gtm"
    ],
    "application/vnd.groove-tool-template": [
        "tpl"
    ],
    "application/vnd.groove-vcard": [
        "vcg"
    ],
    "application/vnd.hal+xml": [
        "hal"
    ],
    "application/vnd.handheld-entertainment+xml": [
        "zmm"
    ],
    "application/vnd.hbci": [
        "hbci"
    ],
    "application/vnd.hhe.lesson-player": [
        "les"
    ],
    "application/vnd.hp-hpgl": [
        "hpgl"
    ],
    "application/vnd.hp-hpid": [
        "hpid"
    ],
    "application/vnd.hp-hps": [
        "hps"
    ],
    "application/vnd.hp-jlyt": [
        "jlt"
    ],
    "application/vnd.hp-pcl": [
        "pcl"
    ],
    "application/vnd.hp-pclxl": [
        "pclxl"
    ],
    "application/vnd.hydrostatix.sof-data": [
        "sfd-hdstx"
    ],
    "application/vnd.ibm.minipay": [
        "mpy"
    ],
    "application/vnd.ibm.modcap": [
        "afp",
        "listafp",
        "list3820"
    ],
    "application/vnd.ibm.rights-management": [
        "irm"
    ],
    "application/vnd.ibm.secure-container": [
        "sc"
    ],
    "application/vnd.iccprofile": [
        "icc",
        "icm"
    ],
    "application/vnd.igloader": [
        "igl"
    ],
    "application/vnd.immervision-ivp": [
        "ivp"
    ],
    "application/vnd.immervision-ivu": [
        "ivu"
    ],
    "application/vnd.insors.igm": [
        "igm"
    ],
    "application/vnd.intercon.formnet": [
        "xpw",
        "xpx"
    ],
    "application/vnd.intergeo": [
        "i2g"
    ],
    "application/vnd.intu.qbo": [
        "qbo"
    ],
    "application/vnd.intu.qfx": [
        "qfx"
    ],
    "application/vnd.ipunplugged.rcprofile": [
        "rcprofile"
    ],
    "application/vnd.irepository.package+xml": [
        "irp"
    ],
    "application/vnd.is-xpr": [
        "xpr"
    ],
    "application/vnd.isac.fcs": [
        "fcs"
    ],
    "application/vnd.jam": [
        "jam"
    ],
    "application/vnd.jcp.javame.midlet-rms": [
        "rms"
    ],
    "application/vnd.jisp": [
        "jisp"
    ],
    "application/vnd.joost.joda-archive": [
        "joda"
    ],
    "application/vnd.kahootz": [
        "ktz",
        "ktr"
    ],
    "application/vnd.kde.karbon": [
        "karbon"
    ],
    "application/vnd.kde.kchart": [
        "chrt"
    ],
    "application/vnd.kde.kformula": [
        "kfo"
    ],
    "application/vnd.kde.kivio": [
        "flw"
    ],
    "application/vnd.kde.kontour": [
        "kon"
    ],
    "application/vnd.kde.kpresenter": [
        "kpr",
        "kpt"
    ],
    "application/vnd.kde.kspread": [
        "ksp"
    ],
    "application/vnd.kde.kword": [
        "kwd",
        "kwt"
    ],
    "application/vnd.kenameaapp": [
        "htke"
    ],
    "application/vnd.kidspiration": [
        "kia"
    ],
    "application/vnd.kinar": [
        "kne",
        "knp"
    ],
    "application/vnd.koan": [
        "skp",
        "skd",
        "skt",
        "skm"
    ],
    "application/vnd.kodak-descriptor": [
        "sse"
    ],
    "application/vnd.las.las+xml": [
        "lasxml"
    ],
    "application/vnd.llamagraphics.life-balance.desktop": [
        "lbd"
    ],
    "application/vnd.llamagraphics.life-balance.exchange+xml": [
        "lbe"
    ],
    "application/vnd.lotus-1-2-3": [
        "123"
    ],
    "application/vnd.lotus-approach": [
        "apr"
    ],
    "application/vnd.lotus-freelance": [
        "pre"
    ],
    "application/vnd.lotus-notes": [
        "nsf"
    ],
    "application/vnd.lotus-organizer": [
        "org"
    ],
    "application/vnd.lotus-screencam": [
        "scm"
    ],
    "application/vnd.lotus-wordpro": [
        "lwp"
    ],
    "application/vnd.macports.portpkg": [
        "portpkg"
    ],
    "application/vnd.mapbox-vector-tile": [
        "mvt"
    ],
    "application/vnd.mcd": [
        "mcd"
    ],
    "application/vnd.medcalcdata": [
        "mc1"
    ],
    "application/vnd.mediastation.cdkey": [
        "cdkey"
    ],
    "application/vnd.mfer": [
        "mwf"
    ],
    "application/vnd.mfmp": [
        "mfm"
    ],
    "application/vnd.micrografx.flo": [
        "flo"
    ],
    "application/vnd.micrografx.igx": [
        "igx"
    ],
    "application/vnd.mif": [
        "mif"
    ],
    "application/vnd.mobius.daf": [
        "daf"
    ],
    "application/vnd.mobius.dis": [
        "dis"
    ],
    "application/vnd.mobius.mbk": [
        "mbk"
    ],
    "application/vnd.mobius.mqy": [
        "mqy"
    ],
    "application/vnd.mobius.msl": [
        "msl"
    ],
    "application/vnd.mobius.plc": [
        "plc"
    ],
    "application/vnd.mobius.txf": [
        "txf"
    ],
    "application/vnd.mophun.application": [
        "mpn"
    ],
    "application/vnd.mophun.certificate": [
        "mpc"
    ],
    "application/vnd.mozilla.xul+xml": [
        "xul"
    ],
    "application/vnd.ms-artgalry": [
        "cil"
    ],
    "application/vnd.ms-cab-compressed": [
        "cab"
    ],
    "application/vnd.ms-excel": [
        "xls",
        "xlm",
        "xla",
        "xlc",
        "xlt",
        "xlw"
    ],
    "application/vnd.ms-excel.addin.macroenabled.12": [
        "xlam"
    ],
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
        "xlsb"
    ],
    "application/vnd.ms-excel.sheet.macroenabled.12": [
        "xlsm"
    ],
    "application/vnd.ms-excel.template.macroenabled.12": [
        "xltm"
    ],
    "application/vnd.ms-fontobject": [
        "eot"
    ],
    "application/vnd.ms-htmlhelp": [
        "chm"
    ],
    "application/vnd.ms-ims": [
        "ims"
    ],
    "application/vnd.ms-lrm": [
        "lrm"
    ],
    "application/vnd.ms-officetheme": [
        "thmx"
    ],
    "application/vnd.ms-outlook": [
        "msg"
    ],
    "application/vnd.ms-pki.seccat": [
        "cat"
    ],
    "application/vnd.ms-pki.stl": [
        "*stl"
    ],
    "application/vnd.ms-powerpoint": [
        "ppt",
        "pps",
        "pot"
    ],
    "application/vnd.ms-powerpoint.addin.macroenabled.12": [
        "ppam"
    ],
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
        "pptm"
    ],
    "application/vnd.ms-powerpoint.slide.macroenabled.12": [
        "sldm"
    ],
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
        "ppsm"
    ],
    "application/vnd.ms-powerpoint.template.macroenabled.12": [
        "potm"
    ],
    "application/vnd.ms-project": [
        "mpp",
        "mpt"
    ],
    "application/vnd.ms-word.document.macroenabled.12": [
        "docm"
    ],
    "application/vnd.ms-word.template.macroenabled.12": [
        "dotm"
    ],
    "application/vnd.ms-works": [
        "wps",
        "wks",
        "wcm",
        "wdb"
    ],
    "application/vnd.ms-wpl": [
        "wpl"
    ],
    "application/vnd.ms-xpsdocument": [
        "xps"
    ],
    "application/vnd.mseq": [
        "mseq"
    ],
    "application/vnd.musician": [
        "mus"
    ],
    "application/vnd.muvee.style": [
        "msty"
    ],
    "application/vnd.mynfc": [
        "taglet"
    ],
    "application/vnd.neurolanguage.nlu": [
        "nlu"
    ],
    "application/vnd.nitf": [
        "ntf",
        "nitf"
    ],
    "application/vnd.noblenet-directory": [
        "nnd"
    ],
    "application/vnd.noblenet-sealer": [
        "nns"
    ],
    "application/vnd.noblenet-web": [
        "nnw"
    ],
    "application/vnd.nokia.n-gage.ac+xml": [
        "*ac"
    ],
    "application/vnd.nokia.n-gage.data": [
        "ngdat"
    ],
    "application/vnd.nokia.n-gage.symbian.install": [
        "n-gage"
    ],
    "application/vnd.nokia.radio-preset": [
        "rpst"
    ],
    "application/vnd.nokia.radio-presets": [
        "rpss"
    ],
    "application/vnd.novadigm.edm": [
        "edm"
    ],
    "application/vnd.novadigm.edx": [
        "edx"
    ],
    "application/vnd.novadigm.ext": [
        "ext"
    ],
    "application/vnd.oasis.opendocument.chart": [
        "odc"
    ],
    "application/vnd.oasis.opendocument.chart-template": [
        "otc"
    ],
    "application/vnd.oasis.opendocument.database": [
        "odb"
    ],
    "application/vnd.oasis.opendocument.formula": [
        "odf"
    ],
    "application/vnd.oasis.opendocument.formula-template": [
        "odft"
    ],
    "application/vnd.oasis.opendocument.graphics": [
        "odg"
    ],
    "application/vnd.oasis.opendocument.graphics-template": [
        "otg"
    ],
    "application/vnd.oasis.opendocument.image": [
        "odi"
    ],
    "application/vnd.oasis.opendocument.image-template": [
        "oti"
    ],
    "application/vnd.oasis.opendocument.presentation": [
        "odp"
    ],
    "application/vnd.oasis.opendocument.presentation-template": [
        "otp"
    ],
    "application/vnd.oasis.opendocument.spreadsheet": [
        "ods"
    ],
    "application/vnd.oasis.opendocument.spreadsheet-template": [
        "ots"
    ],
    "application/vnd.oasis.opendocument.text": [
        "odt"
    ],
    "application/vnd.oasis.opendocument.text-master": [
        "odm"
    ],
    "application/vnd.oasis.opendocument.text-template": [
        "ott"
    ],
    "application/vnd.oasis.opendocument.text-web": [
        "oth"
    ],
    "application/vnd.olpc-sugar": [
        "xo"
    ],
    "application/vnd.oma.dd2+xml": [
        "dd2"
    ],
    "application/vnd.openblox.game+xml": [
        "obgx"
    ],
    "application/vnd.openofficeorg.extension": [
        "oxt"
    ],
    "application/vnd.openstreetmap.data+xml": [
        "osm"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
        "pptx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slide": [
        "sldx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
        "ppsx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.template": [
        "potx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        "xlsx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
        "xltx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        "docx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
        "dotx"
    ],
    "application/vnd.osgeo.mapguide.package": [
        "mgp"
    ],
    "application/vnd.osgi.dp": [
        "dp"
    ],
    "application/vnd.osgi.subsystem": [
        "esa"
    ],
    "application/vnd.palm": [
        "pdb",
        "pqa",
        "oprc"
    ],
    "application/vnd.pawaafile": [
        "paw"
    ],
    "application/vnd.pg.format": [
        "str"
    ],
    "application/vnd.pg.osasli": [
        "ei6"
    ],
    "application/vnd.picsel": [
        "efif"
    ],
    "application/vnd.pmi.widget": [
        "wg"
    ],
    "application/vnd.pocketlearn": [
        "plf"
    ],
    "application/vnd.powerbuilder6": [
        "pbd"
    ],
    "application/vnd.previewsystems.box": [
        "box"
    ],
    "application/vnd.proteus.magazine": [
        "mgz"
    ],
    "application/vnd.publishare-delta-tree": [
        "qps"
    ],
    "application/vnd.pvi.ptid1": [
        "ptid"
    ],
    "application/vnd.quark.quarkxpress": [
        "qxd",
        "qxt",
        "qwd",
        "qwt",
        "qxl",
        "qxb"
    ],
    "application/vnd.rar": [
        "rar"
    ],
    "application/vnd.realvnc.bed": [
        "bed"
    ],
    "application/vnd.recordare.musicxml": [
        "mxl"
    ],
    "application/vnd.recordare.musicxml+xml": [
        "musicxml"
    ],
    "application/vnd.rig.cryptonote": [
        "cryptonote"
    ],
    "application/vnd.rim.cod": [
        "cod"
    ],
    "application/vnd.rn-realmedia": [
        "rm"
    ],
    "application/vnd.rn-realmedia-vbr": [
        "rmvb"
    ],
    "application/vnd.route66.link66+xml": [
        "link66"
    ],
    "application/vnd.sailingtracker.track": [
        "st"
    ],
    "application/vnd.seemail": [
        "see"
    ],
    "application/vnd.sema": [
        "sema"
    ],
    "application/vnd.semd": [
        "semd"
    ],
    "application/vnd.semf": [
        "semf"
    ],
    "application/vnd.shana.informed.formdata": [
        "ifm"
    ],
    "application/vnd.shana.informed.formtemplate": [
        "itp"
    ],
    "application/vnd.shana.informed.interchange": [
        "iif"
    ],
    "application/vnd.shana.informed.package": [
        "ipk"
    ],
    "application/vnd.simtech-mindmapper": [
        "twd",
        "twds"
    ],
    "application/vnd.smaf": [
        "mmf"
    ],
    "application/vnd.smart.teacher": [
        "teacher"
    ],
    "application/vnd.software602.filler.form+xml": [
        "fo"
    ],
    "application/vnd.solent.sdkm+xml": [
        "sdkm",
        "sdkd"
    ],
    "application/vnd.spotfire.dxp": [
        "dxp"
    ],
    "application/vnd.spotfire.sfs": [
        "sfs"
    ],
    "application/vnd.stardivision.calc": [
        "sdc"
    ],
    "application/vnd.stardivision.draw": [
        "sda"
    ],
    "application/vnd.stardivision.impress": [
        "sdd"
    ],
    "application/vnd.stardivision.math": [
        "smf"
    ],
    "application/vnd.stardivision.writer": [
        "sdw",
        "vor"
    ],
    "application/vnd.stardivision.writer-global": [
        "sgl"
    ],
    "application/vnd.stepmania.package": [
        "smzip"
    ],
    "application/vnd.stepmania.stepchart": [
        "sm"
    ],
    "application/vnd.sun.wadl+xml": [
        "wadl"
    ],
    "application/vnd.sun.xml.calc": [
        "sxc"
    ],
    "application/vnd.sun.xml.calc.template": [
        "stc"
    ],
    "application/vnd.sun.xml.draw": [
        "sxd"
    ],
    "application/vnd.sun.xml.draw.template": [
        "std"
    ],
    "application/vnd.sun.xml.impress": [
        "sxi"
    ],
    "application/vnd.sun.xml.impress.template": [
        "sti"
    ],
    "application/vnd.sun.xml.math": [
        "sxm"
    ],
    "application/vnd.sun.xml.writer": [
        "sxw"
    ],
    "application/vnd.sun.xml.writer.global": [
        "sxg"
    ],
    "application/vnd.sun.xml.writer.template": [
        "stw"
    ],
    "application/vnd.sus-calendar": [
        "sus",
        "susp"
    ],
    "application/vnd.svd": [
        "svd"
    ],
    "application/vnd.symbian.install": [
        "sis",
        "sisx"
    ],
    "application/vnd.syncml+xml": [
        "xsm"
    ],
    "application/vnd.syncml.dm+wbxml": [
        "bdm"
    ],
    "application/vnd.syncml.dm+xml": [
        "xdm"
    ],
    "application/vnd.syncml.dmddf+xml": [
        "ddf"
    ],
    "application/vnd.tao.intent-module-archive": [
        "tao"
    ],
    "application/vnd.tcpdump.pcap": [
        "pcap",
        "cap",
        "dmp"
    ],
    "application/vnd.tmobile-livetv": [
        "tmo"
    ],
    "application/vnd.trid.tpt": [
        "tpt"
    ],
    "application/vnd.triscape.mxs": [
        "mxs"
    ],
    "application/vnd.trueapp": [
        "tra"
    ],
    "application/vnd.ufdl": [
        "ufd",
        "ufdl"
    ],
    "application/vnd.uiq.theme": [
        "utz"
    ],
    "application/vnd.umajin": [
        "umj"
    ],
    "application/vnd.unity": [
        "unityweb"
    ],
    "application/vnd.uoml+xml": [
        "uoml"
    ],
    "application/vnd.vcx": [
        "vcx"
    ],
    "application/vnd.visio": [
        "vsd",
        "vst",
        "vss",
        "vsw"
    ],
    "application/vnd.visionary": [
        "vis"
    ],
    "application/vnd.vsf": [
        "vsf"
    ],
    "application/vnd.wap.wbxml": [
        "wbxml"
    ],
    "application/vnd.wap.wmlc": [
        "wmlc"
    ],
    "application/vnd.wap.wmlscriptc": [
        "wmlsc"
    ],
    "application/vnd.webturbo": [
        "wtb"
    ],
    "application/vnd.wolfram.player": [
        "nbp"
    ],
    "application/vnd.wordperfect": [
        "wpd"
    ],
    "application/vnd.wqd": [
        "wqd"
    ],
    "application/vnd.wt.stf": [
        "stf"
    ],
    "application/vnd.xara": [
        "xar"
    ],
    "application/vnd.xfdl": [
        "xfdl"
    ],
    "application/vnd.yamaha.hv-dic": [
        "hvd"
    ],
    "application/vnd.yamaha.hv-script": [
        "hvs"
    ],
    "application/vnd.yamaha.hv-voice": [
        "hvp"
    ],
    "application/vnd.yamaha.openscoreformat": [
        "osf"
    ],
    "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
        "osfpvg"
    ],
    "application/vnd.yamaha.smaf-audio": [
        "saf"
    ],
    "application/vnd.yamaha.smaf-phrase": [
        "spf"
    ],
    "application/vnd.yellowriver-custom-menu": [
        "cmp"
    ],
    "application/vnd.zul": [
        "zir",
        "zirz"
    ],
    "application/vnd.zzazz.deck+xml": [
        "zaz"
    ],
    "application/x-7z-compressed": [
        "7z"
    ],
    "application/x-abiword": [
        "abw"
    ],
    "application/x-ace-compressed": [
        "ace"
    ],
    "application/x-apple-diskimage": [
        "*dmg"
    ],
    "application/x-arj": [
        "arj"
    ],
    "application/x-authorware-bin": [
        "aab",
        "x32",
        "u32",
        "vox"
    ],
    "application/x-authorware-map": [
        "aam"
    ],
    "application/x-authorware-seg": [
        "aas"
    ],
    "application/x-bcpio": [
        "bcpio"
    ],
    "application/x-bdoc": [
        "*bdoc"
    ],
    "application/x-bittorrent": [
        "torrent"
    ],
    "application/x-blorb": [
        "blb",
        "blorb"
    ],
    "application/x-bzip": [
        "bz"
    ],
    "application/x-bzip2": [
        "bz2",
        "boz"
    ],
    "application/x-cbr": [
        "cbr",
        "cba",
        "cbt",
        "cbz",
        "cb7"
    ],
    "application/x-cdlink": [
        "vcd"
    ],
    "application/x-cfs-compressed": [
        "cfs"
    ],
    "application/x-chat": [
        "chat"
    ],
    "application/x-chess-pgn": [
        "pgn"
    ],
    "application/x-chrome-extension": [
        "crx"
    ],
    "application/x-cocoa": [
        "cco"
    ],
    "application/x-conference": [
        "nsc"
    ],
    "application/x-cpio": [
        "cpio"
    ],
    "application/x-csh": [
        "csh"
    ],
    "application/x-debian-package": [
        "*deb",
        "udeb"
    ],
    "application/x-dgc-compressed": [
        "dgc"
    ],
    "application/x-director": [
        "dir",
        "dcr",
        "dxr",
        "cst",
        "cct",
        "cxt",
        "w3d",
        "fgd",
        "swa"
    ],
    "application/x-doom": [
        "wad"
    ],
    "application/x-dtbncx+xml": [
        "ncx"
    ],
    "application/x-dtbook+xml": [
        "dtb"
    ],
    "application/x-dtbresource+xml": [
        "res"
    ],
    "application/x-dvi": [
        "dvi"
    ],
    "application/x-envoy": [
        "evy"
    ],
    "application/x-eva": [
        "eva"
    ],
    "application/x-font-bdf": [
        "bdf"
    ],
    "application/x-font-ghostscript": [
        "gsf"
    ],
    "application/x-font-linux-psf": [
        "psf"
    ],
    "application/x-font-pcf": [
        "pcf"
    ],
    "application/x-font-snf": [
        "snf"
    ],
    "application/x-font-type1": [
        "pfa",
        "pfb",
        "pfm",
        "afm"
    ],
    "application/x-freearc": [
        "arc"
    ],
    "application/x-futuresplash": [
        "spl"
    ],
    "application/x-gca-compressed": [
        "gca"
    ],
    "application/x-glulx": [
        "ulx"
    ],
    "application/x-gnumeric": [
        "gnumeric"
    ],
    "application/x-gramps-xml": [
        "gramps"
    ],
    "application/x-gtar": [
        "gtar"
    ],
    "application/x-hdf": [
        "hdf"
    ],
    "application/x-httpd-php": [
        "php"
    ],
    "application/x-install-instructions": [
        "install"
    ],
    "application/x-iso9660-image": [
        "*iso"
    ],
    "application/x-iwork-keynote-sffkey": [
        "*key"
    ],
    "application/x-iwork-numbers-sffnumbers": [
        "*numbers"
    ],
    "application/x-iwork-pages-sffpages": [
        "*pages"
    ],
    "application/x-java-archive-diff": [
        "jardiff"
    ],
    "application/x-java-jnlp-file": [
        "jnlp"
    ],
    "application/x-keepass2": [
        "kdbx"
    ],
    "application/x-latex": [
        "latex"
    ],
    "application/x-lua-bytecode": [
        "luac"
    ],
    "application/x-lzh-compressed": [
        "lzh",
        "lha"
    ],
    "application/x-makeself": [
        "run"
    ],
    "application/x-mie": [
        "mie"
    ],
    "application/x-mobipocket-ebook": [
        "prc",
        "mobi"
    ],
    "application/x-ms-application": [
        "application"
    ],
    "application/x-ms-shortcut": [
        "lnk"
    ],
    "application/x-ms-wmd": [
        "wmd"
    ],
    "application/x-ms-wmz": [
        "wmz"
    ],
    "application/x-ms-xbap": [
        "xbap"
    ],
    "application/x-msaccess": [
        "mdb"
    ],
    "application/x-msbinder": [
        "obd"
    ],
    "application/x-mscardfile": [
        "crd"
    ],
    "application/x-msclip": [
        "clp"
    ],
    "application/x-msdos-program": [
        "*exe"
    ],
    "application/x-msdownload": [
        "*exe",
        "*dll",
        "com",
        "bat",
        "*msi"
    ],
    "application/x-msmediaview": [
        "mvb",
        "m13",
        "m14"
    ],
    "application/x-msmetafile": [
        "*wmf",
        "*wmz",
        "*emf",
        "emz"
    ],
    "application/x-msmoney": [
        "mny"
    ],
    "application/x-mspublisher": [
        "pub"
    ],
    "application/x-msschedule": [
        "scd"
    ],
    "application/x-msterminal": [
        "trm"
    ],
    "application/x-mswrite": [
        "wri"
    ],
    "application/x-netcdf": [
        "nc",
        "cdf"
    ],
    "application/x-ns-proxy-autoconfig": [
        "pac"
    ],
    "application/x-nzb": [
        "nzb"
    ],
    "application/x-perl": [
        "pl",
        "pm"
    ],
    "application/x-pilot": [
        "*prc",
        "*pdb"
    ],
    "application/x-pkcs12": [
        "p12",
        "pfx"
    ],
    "application/x-pkcs7-certificates": [
        "p7b",
        "spc"
    ],
    "application/x-pkcs7-certreqresp": [
        "p7r"
    ],
    "application/x-rar-compressed": [
        "*rar"
    ],
    "application/x-redhat-package-manager": [
        "rpm"
    ],
    "application/x-research-info-systems": [
        "ris"
    ],
    "application/x-sea": [
        "sea"
    ],
    "application/x-sh": [
        "sh"
    ],
    "application/x-shar": [
        "shar"
    ],
    "application/x-shockwave-flash": [
        "swf"
    ],
    "application/x-silverlight-app": [
        "xap"
    ],
    "application/x-sql": [
        "sql"
    ],
    "application/x-stuffit": [
        "sit"
    ],
    "application/x-stuffitx": [
        "sitx"
    ],
    "application/x-subrip": [
        "srt"
    ],
    "application/x-sv4cpio": [
        "sv4cpio"
    ],
    "application/x-sv4crc": [
        "sv4crc"
    ],
    "application/x-t3vm-image": [
        "t3"
    ],
    "application/x-tads": [
        "gam"
    ],
    "application/x-tar": [
        "tar"
    ],
    "application/x-tcl": [
        "tcl",
        "tk"
    ],
    "application/x-tex": [
        "tex"
    ],
    "application/x-tex-tfm": [
        "tfm"
    ],
    "application/x-texinfo": [
        "texinfo",
        "texi"
    ],
    "application/x-tgif": [
        "*obj"
    ],
    "application/x-ustar": [
        "ustar"
    ],
    "application/x-virtualbox-hdd": [
        "hdd"
    ],
    "application/x-virtualbox-ova": [
        "ova"
    ],
    "application/x-virtualbox-ovf": [
        "ovf"
    ],
    "application/x-virtualbox-vbox": [
        "vbox"
    ],
    "application/x-virtualbox-vbox-extpack": [
        "vbox-extpack"
    ],
    "application/x-virtualbox-vdi": [
        "vdi"
    ],
    "application/x-virtualbox-vhd": [
        "vhd"
    ],
    "application/x-virtualbox-vmdk": [
        "vmdk"
    ],
    "application/x-wais-source": [
        "src"
    ],
    "application/x-web-app-manifest+json": [
        "webapp"
    ],
    "application/x-x509-ca-cert": [
        "der",
        "crt",
        "pem"
    ],
    "application/x-xfig": [
        "fig"
    ],
    "application/x-xliff+xml": [
        "*xlf"
    ],
    "application/x-xpinstall": [
        "xpi"
    ],
    "application/x-xz": [
        "xz"
    ],
    "application/x-zmachine": [
        "z1",
        "z2",
        "z3",
        "z4",
        "z5",
        "z6",
        "z7",
        "z8"
    ],
    "audio/vnd.dece.audio": [
        "uva",
        "uvva"
    ],
    "audio/vnd.digital-winds": [
        "eol"
    ],
    "audio/vnd.dra": [
        "dra"
    ],
    "audio/vnd.dts": [
        "dts"
    ],
    "audio/vnd.dts.hd": [
        "dtshd"
    ],
    "audio/vnd.lucent.voice": [
        "lvp"
    ],
    "audio/vnd.ms-playready.media.pya": [
        "pya"
    ],
    "audio/vnd.nuera.ecelp4800": [
        "ecelp4800"
    ],
    "audio/vnd.nuera.ecelp7470": [
        "ecelp7470"
    ],
    "audio/vnd.nuera.ecelp9600": [
        "ecelp9600"
    ],
    "audio/vnd.rip": [
        "rip"
    ],
    "audio/x-aac": [
        "aac"
    ],
    "audio/x-aiff": [
        "aif",
        "aiff",
        "aifc"
    ],
    "audio/x-caf": [
        "caf"
    ],
    "audio/x-flac": [
        "flac"
    ],
    "audio/x-m4a": [
        "*m4a"
    ],
    "audio/x-matroska": [
        "mka"
    ],
    "audio/x-mpegurl": [
        "m3u"
    ],
    "audio/x-ms-wax": [
        "wax"
    ],
    "audio/x-ms-wma": [
        "wma"
    ],
    "audio/x-pn-realaudio": [
        "ram",
        "ra"
    ],
    "audio/x-pn-realaudio-plugin": [
        "rmp"
    ],
    "audio/x-realaudio": [
        "*ra"
    ],
    "audio/x-wav": [
        "*wav"
    ],
    "chemical/x-cdx": [
        "cdx"
    ],
    "chemical/x-cif": [
        "cif"
    ],
    "chemical/x-cmdf": [
        "cmdf"
    ],
    "chemical/x-cml": [
        "cml"
    ],
    "chemical/x-csml": [
        "csml"
    ],
    "chemical/x-xyz": [
        "xyz"
    ],
    "image/prs.btif": [
        "btif"
    ],
    "image/prs.pti": [
        "pti"
    ],
    "image/vnd.adobe.photoshop": [
        "psd"
    ],
    "image/vnd.airzip.accelerator.azv": [
        "azv"
    ],
    "image/vnd.dece.graphic": [
        "uvi",
        "uvvi",
        "uvg",
        "uvvg"
    ],
    "image/vnd.djvu": [
        "djvu",
        "djv"
    ],
    "image/vnd.dvb.subtitle": [
        "*sub"
    ],
    "image/vnd.dwg": [
        "dwg"
    ],
    "image/vnd.dxf": [
        "dxf"
    ],
    "image/vnd.fastbidsheet": [
        "fbs"
    ],
    "image/vnd.fpx": [
        "fpx"
    ],
    "image/vnd.fst": [
        "fst"
    ],
    "image/vnd.fujixerox.edmics-mmr": [
        "mmr"
    ],
    "image/vnd.fujixerox.edmics-rlc": [
        "rlc"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/vnd.ms-dds": [
        "dds"
    ],
    "image/vnd.ms-modi": [
        "mdi"
    ],
    "image/vnd.ms-photo": [
        "wdp"
    ],
    "image/vnd.net-fpx": [
        "npx"
    ],
    "image/vnd.pco.b16": [
        "b16"
    ],
    "image/vnd.tencent.tap": [
        "tap"
    ],
    "image/vnd.valve.source.texture": [
        "vtf"
    ],
    "image/vnd.wap.wbmp": [
        "wbmp"
    ],
    "image/vnd.xiff": [
        "xif"
    ],
    "image/vnd.zbrush.pcx": [
        "pcx"
    ],
    "image/x-3ds": [
        "3ds"
    ],
    "image/x-cmu-raster": [
        "ras"
    ],
    "image/x-cmx": [
        "cmx"
    ],
    "image/x-freehand": [
        "fh",
        "fhc",
        "fh4",
        "fh5",
        "fh7"
    ],
    "image/x-icon": [
        "*ico"
    ],
    "image/x-jng": [
        "jng"
    ],
    "image/x-mrsid-image": [
        "sid"
    ],
    "image/x-ms-bmp": [
        "*bmp"
    ],
    "image/x-pcx": [
        "*pcx"
    ],
    "image/x-pict": [
        "pic",
        "pct"
    ],
    "image/x-portable-anymap": [
        "pnm"
    ],
    "image/x-portable-bitmap": [
        "pbm"
    ],
    "image/x-portable-graymap": [
        "pgm"
    ],
    "image/x-portable-pixmap": [
        "ppm"
    ],
    "image/x-rgb": [
        "rgb"
    ],
    "image/x-tga": [
        "tga"
    ],
    "image/x-xbitmap": [
        "xbm"
    ],
    "image/x-xpixmap": [
        "xpm"
    ],
    "image/x-xwindowdump": [
        "xwd"
    ],
    "message/vnd.wfa.wsc": [
        "wsc"
    ],
    "model/vnd.collada+xml": [
        "dae"
    ],
    "model/vnd.dwf": [
        "dwf"
    ],
    "model/vnd.gdl": [
        "gdl"
    ],
    "model/vnd.gtw": [
        "gtw"
    ],
    "model/vnd.mts": [
        "mts"
    ],
    "model/vnd.opengex": [
        "ogex"
    ],
    "model/vnd.parasolid.transmit.binary": [
        "x_b"
    ],
    "model/vnd.parasolid.transmit.text": [
        "x_t"
    ],
    "model/vnd.sap.vds": [
        "vds"
    ],
    "model/vnd.usdz+zip": [
        "usdz"
    ],
    "model/vnd.valve.source.compiled-map": [
        "bsp"
    ],
    "model/vnd.vtu": [
        "vtu"
    ],
    "text/prs.lines.tag": [
        "dsc"
    ],
    "text/vnd.curl": [
        "curl"
    ],
    "text/vnd.curl.dcurl": [
        "dcurl"
    ],
    "text/vnd.curl.mcurl": [
        "mcurl"
    ],
    "text/vnd.curl.scurl": [
        "scurl"
    ],
    "text/vnd.dvb.subtitle": [
        "sub"
    ],
    "text/vnd.fly": [
        "fly"
    ],
    "text/vnd.fmi.flexstor": [
        "flx"
    ],
    "text/vnd.graphviz": [
        "gv"
    ],
    "text/vnd.in3d.3dml": [
        "3dml"
    ],
    "text/vnd.in3d.spot": [
        "spot"
    ],
    "text/vnd.sun.j2me.app-descriptor": [
        "jad"
    ],
    "text/vnd.wap.wml": [
        "wml"
    ],
    "text/vnd.wap.wmlscript": [
        "wmls"
    ],
    "text/x-asm": [
        "s",
        "asm"
    ],
    "text/x-c": [
        "c",
        "cc",
        "cxx",
        "cpp",
        "h",
        "hh",
        "dic"
    ],
    "text/x-component": [
        "htc"
    ],
    "text/x-fortran": [
        "f",
        "for",
        "f77",
        "f90"
    ],
    "text/x-handlebars-template": [
        "hbs"
    ],
    "text/x-java-source": [
        "java"
    ],
    "text/x-lua": [
        "lua"
    ],
    "text/x-markdown": [
        "mkd"
    ],
    "text/x-nfo": [
        "nfo"
    ],
    "text/x-opml": [
        "opml"
    ],
    "text/x-org": [
        "*org"
    ],
    "text/x-pascal": [
        "p",
        "pas"
    ],
    "text/x-processing": [
        "pde"
    ],
    "text/x-sass": [
        "sass"
    ],
    "text/x-scss": [
        "scss"
    ],
    "text/x-setext": [
        "etx"
    ],
    "text/x-sfv": [
        "sfv"
    ],
    "text/x-suse-ymp": [
        "ymp"
    ],
    "text/x-uuencode": [
        "uu"
    ],
    "text/x-vcalendar": [
        "vcs"
    ],
    "text/x-vcard": [
        "vcf"
    ],
    "video/vnd.dece.hd": [
        "uvh",
        "uvvh"
    ],
    "video/vnd.dece.mobile": [
        "uvm",
        "uvvm"
    ],
    "video/vnd.dece.pd": [
        "uvp",
        "uvvp"
    ],
    "video/vnd.dece.sd": [
        "uvs",
        "uvvs"
    ],
    "video/vnd.dece.video": [
        "uvv",
        "uvvv"
    ],
    "video/vnd.dvb.file": [
        "dvb"
    ],
    "video/vnd.fvt": [
        "fvt"
    ],
    "video/vnd.mpegurl": [
        "mxu",
        "m4u"
    ],
    "video/vnd.ms-playready.media.pyv": [
        "pyv"
    ],
    "video/vnd.uvvu.mp4": [
        "uvu",
        "uvvu"
    ],
    "video/vnd.vivo": [
        "viv"
    ],
    "video/x-f4v": [
        "f4v"
    ],
    "video/x-fli": [
        "fli"
    ],
    "video/x-flv": [
        "flv"
    ],
    "video/x-m4v": [
        "m4v"
    ],
    "video/x-matroska": [
        "mkv",
        "mk3d",
        "mks"
    ],
    "video/x-mng": [
        "mng"
    ],
    "video/x-ms-asf": [
        "asf",
        "asx"
    ],
    "video/x-ms-vob": [
        "vob"
    ],
    "video/x-ms-wm": [
        "wm"
    ],
    "video/x-ms-wmv": [
        "wmv"
    ],
    "video/x-ms-wmx": [
        "wmx"
    ],
    "video/x-ms-wvx": [
        "wvx"
    ],
    "video/x-msvideo": [
        "avi"
    ],
    "video/x-sgi-movie": [
        "movie"
    ],
    "video/x-smv": [
        "smv"
    ],
    "x-conference/x-cooltalk": [
        "ice"
    ]
};

});

function $816683f8c32a91e9$var$_slicedToArray(arr, i) {
    return $816683f8c32a91e9$var$_arrayWithHoles(arr) || $816683f8c32a91e9$var$_iterableToArrayLimit(arr, i) || $816683f8c32a91e9$var$_unsupportedIterableToArray(arr, i) || $816683f8c32a91e9$var$_nonIterableRest();
}
function $816683f8c32a91e9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $816683f8c32a91e9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $816683f8c32a91e9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $816683f8c32a91e9$var$_arrayLikeToArray(o, minLen);
}
function $816683f8c32a91e9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $816683f8c32a91e9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $816683f8c32a91e9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $816683f8c32a91e9$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $816683f8c32a91e9$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $816683f8c32a91e9$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $816683f8c32a91e9$var$defaultGetStoreFunc;
function $816683f8c32a91e9$var$defaultGetStore() {
    if (!$816683f8c32a91e9$var$defaultGetStoreFunc) $816683f8c32a91e9$var$defaultGetStoreFunc = $816683f8c32a91e9$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $816683f8c32a91e9$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $816683f8c32a91e9$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $816683f8c32a91e9$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($816683f8c32a91e9$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
    });
}
function $816683f8c32a91e9$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $816683f8c32a91e9$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $816683f8c32a91e9$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $816683f8c32a91e9$export$b327150396135fe7(store.getAll());
        var items = [];
        return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $816683f8c32a91e9$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $816683f8c32a91e9$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $816683f8c32a91e9$export$b327150396135fe7(store.getAllKeys()),
            $816683f8c32a91e9$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $816683f8c32a91e9$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $816683f8c32a91e9$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


var $fc31937ed0d84818$exports = {};
"use strict";
Object.defineProperty($fc31937ed0d84818$exports, "__esModule", {
    value: true
});
function $fc31937ed0d84818$var$natsort(options) {
    if (options === void 0) options = {};
    var ore = /^0/;
    var sre = /\s+/g;
    var tre = /^\s+|\s+$/g;
    // unicode
    var ure = /[^\x00-\x80]/;
    // hex
    var hre = /^0x[0-9a-f]+$/i;
    // numeric
    var nre = /(0x[\da-fA-F]+|(^[\+\-]?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?(?=\D|\s|$))|\d+)/g;
    // datetime
    var dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/; // tslint:disable-line
    var toLowerCase = String.prototype.toLocaleLowerCase || String.prototype.toLowerCase;
    var GREATER = options.desc ? -1 : 1;
    var SMALLER = -GREATER;
    var normalize = options.insensitive ? function(s) {
        return toLowerCase.call("" + s).replace(tre, "");
    } : function(s) {
        return ("" + s).replace(tre, "");
    };
    function tokenize(s) {
        return s.replace(nre, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0");
    }
    function parse(s, l) {
        // normalize spaces; find floats not starting with '0',
        // string or 0 if not defined (Clint Priest)
        return (!s.match(ore) || l === 1) && parseFloat(s) || s.replace(sre, " ").replace(tre, "") || 0;
    }
    return function(a, b) {
        // trim pre-post whitespace
        var aa = normalize(a);
        var bb = normalize(b);
        // return immediately if at least one of the values is empty.
        // empty string < any others
        if (!aa && !bb) return 0;
        if (!aa && bb) return SMALLER;
        if (aa && !bb) return GREATER;
        // tokenize: split numeric strings and default strings
        var aArr = tokenize(aa);
        var bArr = tokenize(bb);
        // hex or date detection
        var aHex = aa.match(hre);
        var bHex = bb.match(hre);
        var av = aHex && bHex ? parseInt(aHex[0], 16) : aArr.length !== 1 && Date.parse(aa);
        var bv = aHex && bHex ? parseInt(bHex[0], 16) : av && bb.match(dre) && Date.parse(bb) || null;
        // try and sort Hex codes or Dates
        if (bv) {
            if (av === bv) return 0;
            if (av < bv) return SMALLER;
            if (av > bv) return GREATER;
        }
        var al = aArr.length;
        var bl = bArr.length;
        // handle numeric strings and default strings
        for(var i = 0, l = Math.max(al, bl); i < l; i += 1){
            var af = parse(aArr[i] || "", al);
            var bf = parse(bArr[i] || "", bl);
            // handle numeric vs string comparison.
            // numeric < string
            if (isNaN(af) !== isNaN(bf)) return isNaN(af) ? GREATER : SMALLER;
            // if unicode use locale comparison
            if (ure.test(af + bf) && af.localeCompare) {
                var comp = af.localeCompare(bf);
                if (comp > 0) return GREATER;
                if (comp < 0) return SMALLER;
                if (i === l - 1) return 0;
            }
            if (af < bf) return SMALLER;
            if (af > bf) return GREATER;
            if ("" + af < "" + bf) return SMALLER;
            if ("" + af > "" + bf) return GREATER;
        }
        return 0;
    };
}
$fc31937ed0d84818$exports.default = $fc31937ed0d84818$var$natsort;


function $a6df9c40ba402dc9$export$f3bdc09b596b0e55(parentElement, tagName, text = null) {
    let child = document.createElement(tagName);
    parentElement.appendChild(child);
    if (text !== null) child.appendChild(document.createTextNode(text));
    return child;
}
function $a6df9c40ba402dc9$var$normalize(inputString) {
    if (typeof inputString !== "string") return inputString;
    let replacements = {
        "\uFF10": "0",
        "\uFF11": "1",
        "\uFF12": "2",
        "\uFF13": "3",
        "\uFF14": "4",
        "\uFF15": "5",
        "\uFF16": "6",
        "\uFF17": "7",
        "\uFF18": "8",
        "\uFF19": "9"
    };
    return inputString.replace(/[０１２３４５６７８９]/g, function(match) {
        return replacements[match];
    });
}
function $a6df9c40ba402dc9$export$3bf4e72ed1d44710(arr, property, ascending = true, natural = false) {
    let x;
    if (ascending) x = 1;
    else x = -1;
    if (natural) {
        let sorter = (0, (/*@__PURE__*/$parcel$interopDefault($fc31937ed0d84818$exports)))();
        return arr.sort((a, b)=>sorter($a6df9c40ba402dc9$var$normalize(a[property]), $a6df9c40ba402dc9$var$normalize(b[property])));
    }
    return arr.sort((a, b)=>$a6df9c40ba402dc9$var$normalize(a[property]) > $a6df9c40ba402dc9$var$normalize(b[property]) ? x : $a6df9c40ba402dc9$var$normalize(b[property]) > $a6df9c40ba402dc9$var$normalize(a[property]) ? -x : 0);
}
function $a6df9c40ba402dc9$export$e0b576e7a74416cd(x, min, max) {
    return Math.min(Math.max(x, min), max);
}
function $a6df9c40ba402dc9$export$1cbfa025cd3d026b() {
    let doc = window.document;
    let docEl = doc.documentElement;
    let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) requestFullScreen.call(docEl);
    else cancelFullScreen.call(doc);
}
function $a6df9c40ba402dc9$export$11e63f7b0f3d9900(key, getDefaultFn) {
    let state = getDefaultFn();
    let stateLoaded = localStorage.getItem(key);
    if (stateLoaded !== null) {
        stateLoaded = JSON.parse(stateLoaded);
        for (const k of Object.keys(state))if (k in stateLoaded) state[k] = stateLoaded[k];
    }
    return state;
}
function $a6df9c40ba402dc9$export$a1544dad697b423d(key, state) {
    localStorage.setItem(key, JSON.stringify(state));
}
async function $a6df9c40ba402dc9$export$ce30717759bc230c(file) {
    let text = await file.text();
    return JSON.parse(text);
}
function $a6df9c40ba402dc9$export$e1a3971de07c83b5(bytes, decimals = 2) {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
        "B",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
async function $a6df9c40ba402dc9$export$f565b71ad023b7df() {
    if (navigator.storage && navigator.storage.persist) {
        const isPersisted = await navigator.storage.persist();
        console.log(`Persisted storage granted: ${isPersisted}`);
    }
}



class $ce3de23872348272$var$GlobalState {
    constructor(){
        this.key = "mokuro/State/global";
        this.state = null;
        this.fields = Object.keys($ce3de23872348272$var$GlobalState.getDefault());
    }
    static getDefault() {
        return {
            loadedVolumeId: null,
            lastOpened: null
        };
    }
    load() {
        this.state = (0, $a6df9c40ba402dc9$export$11e63f7b0f3d9900)(this.key, $ce3de23872348272$var$GlobalState.getDefault);
    }
    save() {
        (0, $a6df9c40ba402dc9$export$a1544dad697b423d)(this.key, this.state);
    }
    reset() {
        this.state = null;
    }
}
class $ce3de23872348272$var$VolumeState {
    constructor(){
        this.key = null;
        this.state = null;
        this.fields = Object.keys($ce3de23872348272$var$VolumeState.getDefault());
    }
    static getDefault() {
        return {
            page_idx: 0,
            page2_idx: -1,
            lastOpened: null
        };
    }
    get(id) {
        return (0, $a6df9c40ba402dc9$export$11e63f7b0f3d9900)("mokuro/State/volume/" + id, $ce3de23872348272$var$VolumeState.getDefault);
    }
    load(id) {
        this.key = "mokuro/State/volume/" + id;
        this.state = (0, $a6df9c40ba402dc9$export$11e63f7b0f3d9900)(this.key, $ce3de23872348272$var$VolumeState.getDefault);
    }
    save() {
        (0, $a6df9c40ba402dc9$export$a1544dad697b423d)(this.key, this.state);
    }
    reset() {
        this.key = null;
        this.state = null;
    }
    delete(id) {
        localStorage.removeItem("mokuro/State/volume/" + id);
    }
}
const $ce3de23872348272$var$stateHandler = {
    get (target, prop, receiver) {
        if (target.fields.includes(prop)) return target.state[prop];
        return Reflect.get(...arguments);
    },
    set (target, prop, value) {
        if (target.fields.includes(prop)) {
            target.state[prop] = value;
            target.save();
            return true;
        }
        return Reflect.set(...arguments);
    }
};
const $ce3de23872348272$export$8e769ad4338a911e = new Proxy(new $ce3de23872348272$var$GlobalState(), $ce3de23872348272$var$stateHandler);
$ce3de23872348272$export$8e769ad4338a911e.load();
const $ce3de23872348272$export$7450780e9e8f7043 = new Proxy(new $ce3de23872348272$var$VolumeState(), $ce3de23872348272$var$stateHandler);


class $4436b3cc3fc4de73$var$Volume {
    static serializedFields = [
        "name",
        "mokuroData",
        "id",
        "imgStoredMap",
        "url"
    ];
    constructor(parentCatalog, parentTitle, name, mokuroData, id = null, imgStoredMap = null, url = null){
        this.id = id === null ? parentCatalog.getNewId() : id;
        this.parentCatalog = parentCatalog;
        this.parentTitle = parentTitle;
        this.name = name;
        this.mokuroData = mokuroData;
        this.URLs = {};
        this.imgStoredMap = imgStoredMap === null ? this.getImgStoredMap(mokuroData) : imgStoredMap;
        this.lastStoredPath = null;
        this.url = url; // if this is null, then the volume is stored locally
        parentCatalog.volumes[this.id] = this;
        parentTitle.volumes[this.id] = this;
    }
    async delete() {
        await (0, $816683f8c32a91e9$export$c8aa84257229cac8)(this.mokuroData.pages.map((pageJSON)=>this.getImgKey(pageJSON.img_path)));
        delete this.parentCatalog.volumes[this.id];
        delete this.parentTitle.volumes[this.id];
        await this.parentCatalog.save();
        (0, $ce3de23872348272$export$7450780e9e8f7043).delete(this.id);
    }
    toString() {
        return this.parentTitle.name + "/" + this.name;
    }
    serialize() {
        let x = {};
        for (let field of $4436b3cc3fc4de73$var$Volume.serializedFields)x[field] = this[field];
        return x;
    }
    static deserialize(x, parentCatalog, parentTitle) {
        return new $4436b3cc3fc4de73$var$Volume(parentCatalog, parentTitle, x.name, x.mokuroData, x.id, x.imgStoredMap, x.url);
    }
    getImgStoredMap(mokuroData) {
        let imgStoredMap = {};
        for (const page of mokuroData.pages)imgStoredMap[page.img_path.replace("\\", "/")] = false;
        return imgStoredMap;
    }
    getNumStoredImgs() {
        return Object.values(this.imgStoredMap).filter(Boolean).length;
    }
    isFullyStored() {
        if (this.url !== null) return true;
        return Object.values(this.imgStoredMap).every(Boolean);
    }
    getStatusString() {
        if (this.isFullyStored()) return "";
        else if (this.lastStoredPath === null) return "Loading...";
        else return "Loading... (" + this.getNumStoredImgs() + "/" + this.mokuroData.pages.length + ") " + this.lastStoredPath;
    }
    getImgKey(relativePath) {
        return "volume_" + this.id + "/" + relativePath.replace("\\", "/");
    }
    async addImg(imgFile, relativePath) {
        relativePath = relativePath.replace("\\", "/");
        if (relativePath in this.imgStoredMap) {
            await (0, $816683f8c32a91e9$export$adaa4cf7ef1b65be)(this.getImgKey(relativePath), imgFile);
            this.imgStoredMap[relativePath] = true;
            this.lastStoredPath = relativePath;
        } else console.log("Skipping adding file: " + relativePath);
    }
    async addImgs(imgFiles, relativePaths) {
        let keyvals = [];
        let relativePathsToStore = [];
        for(let i = 0; i < imgFiles.length; i++){
            let imgFile = imgFiles[i];
            let relativePath = relativePaths[i];
            relativePath = relativePath.replace("\\", "/");
            if (relativePath in this.imgStoredMap) {
                keyvals.push([
                    this.getImgKey(relativePath),
                    imgFile
                ]);
                relativePathsToStore.push(relativePath);
            } else console.log("Skipping adding file: " + relativePath);
        }
        await (0, $816683f8c32a91e9$export$daa0a5170277c7a8)(keyvals);
        for (const relativePath of relativePathsToStore){
            this.imgStoredMap[relativePath] = true;
            this.lastStoredPath = relativePath;
        }
    }
    async getImgURL(relativePath) {
        if (this.url !== null) return this.url + "/" + relativePath;
        let key = this.getImgKey(relativePath);
        if (key in this.URLs) return this.URLs[key];
        else {
            let imgFile = await (0, $816683f8c32a91e9$export$3988ae62b71be9a3)(key);
            if (imgFile === undefined) console.error("Missing image for volume " + this.toString() + ": " + relativePath);
            let imgURL = URL.createObjectURL(imgFile);
            this.URLs[key] = imgURL;
            return imgURL;
        }
    }
    clearURLs() {
        for (let url of Object.values(this.URLs))URL.revokeObjectURL(url);
        this.URLs = {};
    }
}
class $4436b3cc3fc4de73$var$Title {
    static serializedFields = [
        "name",
        "id"
    ];
    constructor(parentCatalog, name, id = null){
        this.id = id === null ? parentCatalog.getNewId() : id;
        this.parentCatalog = parentCatalog;
        this.name = name;
        this.volumes = {};
        parentCatalog.titles[this.id] = this;
    }
    async delete() {
        await Promise.all(Object.values(this.volumes).map(async (volume)=>{
            await volume.delete();
        }));
        delete this.parentCatalog.titles[this.id];
        await this.parentCatalog.save();
    }
    toString() {
        return this.name;
    }
    serialize() {
        let x = {};
        for (let field of $4436b3cc3fc4de73$var$Title.serializedFields)x[field] = this[field];
        x.volumes = [];
        for (let volume of Object.values(this.volumes))x.volumes.push(volume.serialize());
        return x;
    }
    static deserialize(x, parentCatalog) {
        let title = new $4436b3cc3fc4de73$var$Title(parentCatalog, x.name, x.id);
        for (let v of x.volumes)$4436b3cc3fc4de73$var$Volume.deserialize(v, parentCatalog, title);
        return title;
    }
    async addVolumeIfNotExists(mokuroData, name, id = null, url = null) {
        if (id !== null && id in this.volumes) return this.volumes[id];
        return new $4436b3cc3fc4de73$var$Volume(this.parentCatalog, this, name, mokuroData, id, null, url);
    }
    getVolumes() {
        return (0, $a6df9c40ba402dc9$export$3bf4e72ed1d44710)(Object.values(this.volumes), "name", true, true);
    }
}
class $4436b3cc3fc4de73$export$c401078f1496a453 {
    constructor(){
        this.titles = {};
        this.volumes = {};
        this.nextId = 0;
    }
    getNewId() {
        return this.nextId++;
    }
    async addTitleIfNotExists(name = null, id = null) {
        if (id !== null && id in this.titles) return this.titles[id];
        return new $4436b3cc3fc4de73$var$Title(this, name, id);
    }
    getTitles() {
        return (0, $a6df9c40ba402dc9$export$3bf4e72ed1d44710)(Object.values(this.titles), "name", true, true);
    }
    static async load() {
        let catalog = new $4436b3cc3fc4de73$export$c401078f1496a453();
        let c = await (0, $816683f8c32a91e9$export$3988ae62b71be9a3)("mokuroCatalog");
        if (c !== undefined) {
            catalog.nextId = c.nextId;
            for (let t of Object.values(c.titles))$4436b3cc3fc4de73$var$Title.deserialize(t, catalog);
            console.log("Loaded catalog");
        }
        return catalog;
    }
    async save() {
        let c = {
            nextId: this.nextId,
            titles: []
        };
        for (let title of Object.values(this.titles))c.titles.push(title.serialize());
        await (0, $816683f8c32a91e9$export$adaa4cf7ef1b65be)("mokuroCatalog", c).then(()=>console.log("Catalog saved")).catch((err)=>console.log("Error while saving catalog", err));
    }
}



var $fcae6622029addff$exports = {};
$fcae6622029addff$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m13.5 14.5-4-4 4-4M9.5 14.5l-4-4 4-4\"/></g></svg>";


var $ff43cb32a0cca1b1$exports = {};
$ff43cb32a0cca1b1$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m11.5 14.5-4-4 4-4\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";


var $0121c827634f3d65$exports = {};
$0121c827634f3d65$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.5 14.5 4-4-4-4M11.5 14.5l4-4-4-4\"/></g></svg>";


var $c07c56ac62b91c7e$exports = {};
$c07c56ac62b91c7e$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m9.5 14.5 4-4-4-4\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";


var $cb30bbd2ed51aa6f$exports = {};
$cb30bbd2ed51aa6f$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m15.5 15.5-10-10zM15.5 5.5l-10 10\"/></g></svg>";


var $6cf1cf788ce8e24c$exports = {};
$6cf1cf788ce8e24c$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18.5 7.5v-5h-5M18.5 2.5l-6 5.929M7.5 18.5l-5 .023V13.5M8.5 12.5l-6 6\"/></g></svg>";


var $0762111f3fa0aac2$exports = {};
$0762111f3fa0aac2$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5v16.021M19.5 2.5v16.021M13.507 14.515l4-4-4-4.015M7.507 14.515l-4-4 4-4.015M17.5 10.5h-14\"/></g></svg>";


var $9abcb702cc52a5ea$exports = {};
$9abcb702cc52a5ea$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18.5 7.5V2.522l-5.5.014M18.5 2.522l-6 5.907M13 18.521l5.5.002-.013-5.5M18.5 18.429l-6-5.907M2.5 7.5v-5H8M8.5 8.429l-6-5.907M8 18.516l-5.5.007V13.5M8.5 12.5l-6 6\"/></g></svg>";


var $3ce5c5686bd832a5$exports = {};
$3ce5c5686bd832a5$exports = "<svg width=\"21\" height=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 6.5h12M4.498 10.5h11.997M4.5 14.5h11.995\"/></g></svg>";


function $c2e8295866ad447b$export$5f2cc9974f97683b() {
    document.getElementById("buttonHideMenu").innerHTML = $cb30bbd2ed51aa6f$exports;
    document.getElementById("buttonLeftLeft").innerHTML = $fcae6622029addff$exports;
    document.getElementById("buttonLeft").innerHTML = $ff43cb32a0cca1b1$exports;
    document.getElementById("buttonRight").innerHTML = $c07c56ac62b91c7e$exports;
    document.getElementById("buttonRightRight").innerHTML = $0121c827634f3d65$exports;
    document.getElementById("dropbtn").innerHTML = $3ce5c5686bd832a5$exports;
    document.getElementById("menuFitToScreen").innerHTML = $6cf1cf788ce8e24c$exports;
    document.getElementById("menuFitToWidth").innerHTML = $0762111f3fa0aac2$exports;
    document.getElementById("menuFullScreen").innerHTML = $9abcb702cc52a5ea$exports;
    for (const el of document.getElementsByClassName("popupCloseButton"))el.innerHTML = $cb30bbd2ed51aa6f$exports;
}






class $480eb26aa317c74a$var$Option {
    constructor(id, label, description, defaultValue, inputType, isGlobal, selectOptions = null){
        this.id = id;
        this.label = label;
        this.description = description;
        this.defaultValue = defaultValue;
        this.inputType = inputType;
        this.isGlobal = isGlobal;
        this.selectOptions = selectOptions;
    }
}
const $480eb26aa317c74a$export$41c562ebe57d11e2 = [
    new $480eb26aa317c74a$var$Option("defaultZoomMode", "on page turn", "", "fit to screen", "select", true, [
        "fit to screen",
        "fit to width",
        "original size",
        "keep zoom level"
    ]),
    new $480eb26aa317c74a$var$Option("r2l", "Japanese reading (right to left)", "", true, "toggle", false),
    new $480eb26aa317c74a$var$Option("doublePageView", "display two pages", "", true, "toggle", false),
    new $480eb26aa317c74a$var$Option("hasCover", "first page is cover", "", false, "toggle", false),
    new $480eb26aa317c74a$var$Option("turnPagesWithArrows", "turn pages with arrow keys", "", false, "toggle", true),
    new $480eb26aa317c74a$var$Option("ctrlToPan", "ctrl+mouse to move", "", false, "toggle", true),
    new $480eb26aa317c74a$var$Option("altToZoom", "alt+scroll to zoom", "", false, "toggle", true),
    new $480eb26aa317c74a$var$Option("displayOCR", "OCR enabled", "", true, "toggle", true),
    new $480eb26aa317c74a$var$Option("textBoxBorders", "display boxes outlines", "", false, "toggle", true),
    new $480eb26aa317c74a$var$Option("editableText", "editable text", "", false, "toggle", true),
    new $480eb26aa317c74a$var$Option("toggleOCRTextBoxes", "toggle OCR text boxes on click", "", false, "toggle", true),
    new $480eb26aa317c74a$var$Option("fontSize", "font size:", "", "auto", "select", false, [
        "auto",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "18",
        "20",
        "24",
        "32",
        "40",
        "48",
        "60"
    ]),
    new $480eb26aa317c74a$var$Option("backgroundColor", "background color", "", "#C4C3D0", "color", true),
    new $480eb26aa317c74a$var$Option("eInkMode", "e-ink mode", "", false, "toggle", true)
];
class $480eb26aa317c74a$var$Settings {
    constructor(){
        this.loadGlobal();
        this.volume = null;
        this.fields = Object.keys($480eb26aa317c74a$var$Settings.getDefault());
    }
    static getDefault() {
        let x = {};
        for (let option of $480eb26aa317c74a$export$41c562ebe57d11e2)x[option.id] = option.defaultValue;
        return x;
    }
    static getDefaultVolume() {
        let x = {};
        for (let option of $480eb26aa317c74a$export$41c562ebe57d11e2)x[option.id] = null;
        return x;
    }
    loadGlobal() {
        let key = "mokuro/Settings/global";
        const handler = {
            set (target, prop, value) {
                target[prop] = value;
                (0, $a6df9c40ba402dc9$export$a1544dad697b423d)(key, target);
                return true;
            }
        };
        this.global = new Proxy((0, $a6df9c40ba402dc9$export$11e63f7b0f3d9900)(key, $480eb26aa317c74a$var$Settings.getDefault), handler);
    }
    loadVolume(id) {
        let key = "mokuro/Settings/volume/" + id;
        const handler = {
            set (target, prop, value) {
                target[prop] = value;
                (0, $a6df9c40ba402dc9$export$a1544dad697b423d)(key, target);
                return true;
            }
        };
        this.volume = new Proxy((0, $a6df9c40ba402dc9$export$11e63f7b0f3d9900)(key, $480eb26aa317c74a$var$Settings.getDefaultVolume), handler);
    }
    unloadVolume() {
        this.volume = null;
    }
    resetGlobal() {
        let state = $480eb26aa317c74a$var$Settings.getDefault();
        for (const k of Object.keys(state))this.global[k] = state[k];
    }
    resetVolume() {
        let state = $480eb26aa317c74a$var$Settings.getDefaultVolume();
        for (const k of Object.keys(state))this.volume[k] = state[k];
    }
}
const $480eb26aa317c74a$var$settingsHandler = {
    get (target, prop, receiver) {
        if (target.fields.includes(prop)) {
            if (target.volume === null || target.volume[prop] === null) return target.global[prop];
            return target.volume[prop];
        }
        return Reflect.get(...arguments);
    },
    set (target, prop, value) {
        if (target.fields.includes(prop)) throw new Error("Cannot set value directly in settings. Use settings.global or settings.volume instead.");
        return Reflect.set(...arguments);
    }
};
const $480eb26aa317c74a$export$a5a6e0b888b2c992 = new Proxy(new $480eb26aa317c74a$var$Settings(), $480eb26aa317c74a$var$settingsHandler);



let $f9dead489e99c245$var$statusBarTimeoutId = null;
function $f9dead489e99c245$export$6d6d0d6a78c06c7d(text) {
    document.getElementById("statusBarText").textContent = text;
}
function $f9dead489e99c245$export$47d12d3365eb902() {
    document.getElementById("statusBar").style.opacity = 1;
}
function $f9dead489e99c245$export$853c83aa798deaf7() {
    document.getElementById("statusBar").style.opacity = 0;
}
function $f9dead489e99c245$export$3bef5616bc7fe5f1(timeout) {
    $f9dead489e99c245$export$47d12d3365eb902();
    if ($f9dead489e99c245$var$statusBarTimeoutId !== null) clearTimeout($f9dead489e99c245$var$statusBarTimeoutId);
    $f9dead489e99c245$var$statusBarTimeoutId = setTimeout($f9dead489e99c245$export$853c83aa798deaf7, timeout);
}







var $f22fea531ee465de$exports = {};
"use strict";
var $ee3594ab38f6167c$exports = {};
/**
 * This module used to unify mouse wheel behavior between different browsers in 2014
 * Now it's just a wrapper around addEventListener('wheel');
 *
 * Usage:
 *  var addWheelListener = require('wheel').addWheelListener;
 *  var removeWheelListener = require('wheel').removeWheelListener;
 *  addWheelListener(domElement, function (e) {
 *    // mouse wheel event
 *  });
 *  removeWheelListener(domElement, function);
 */ $ee3594ab38f6167c$exports = $ee3594ab38f6167c$var$addWheelListener;
// But also expose "advanced" api with unsubscribe:
$ee3594ab38f6167c$exports.addWheelListener = $ee3594ab38f6167c$var$addWheelListener;
$ee3594ab38f6167c$exports.removeWheelListener = $ee3594ab38f6167c$var$removeWheelListener;
function $ee3594ab38f6167c$var$addWheelListener(element, listener, useCapture) {
    element.addEventListener("wheel", listener, useCapture);
}
function $ee3594ab38f6167c$var$removeWheelListener(element, listener, useCapture) {
    element.removeEventListener("wheel", listener, useCapture);
}


var $abd4e73c78068168$exports = {};
var $368e738781e188a9$exports = {};
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
var $368e738781e188a9$var$NEWTON_ITERATIONS = 4;
var $368e738781e188a9$var$NEWTON_MIN_SLOPE = 0.001;
var $368e738781e188a9$var$SUBDIVISION_PRECISION = 0.0000001;
var $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $368e738781e188a9$var$kSplineTableSize = 11;
var $368e738781e188a9$var$kSampleStepSize = 1.0 / ($368e738781e188a9$var$kSplineTableSize - 1.0);
var $368e738781e188a9$var$float32ArraySupported = typeof Float32Array === "function";
function $368e738781e188a9$var$A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function $368e738781e188a9$var$B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
}
function $368e738781e188a9$var$C(aA1) {
    return 3.0 * aA1;
}
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function $368e738781e188a9$var$calcBezier(aT, aA1, aA2) {
    return (($368e738781e188a9$var$A(aA1, aA2) * aT + $368e738781e188a9$var$B(aA1, aA2)) * aT + $368e738781e188a9$var$C(aA1)) * aT;
}
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function $368e738781e188a9$var$getSlope(aT, aA1, aA2) {
    return 3.0 * $368e738781e188a9$var$A(aA1, aA2) * aT * aT + 2.0 * $368e738781e188a9$var$B(aA1, aA2) * aT + $368e738781e188a9$var$C(aA1);
}
function $368e738781e188a9$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $368e738781e188a9$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $368e738781e188a9$var$SUBDIVISION_PRECISION && ++i < $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
}
function $368e738781e188a9$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $368e738781e188a9$var$NEWTON_ITERATIONS; ++i){
        var currentSlope = $368e738781e188a9$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $368e738781e188a9$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
function $368e738781e188a9$var$LinearEasing(x) {
    return x;
}
$368e738781e188a9$exports = function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error("bezier x values must be in [0, 1] range");
    if (mX1 === mY1 && mX2 === mY2) return $368e738781e188a9$var$LinearEasing;
    // Precompute samples table
    var sampleValues = $368e738781e188a9$var$float32ArraySupported ? new Float32Array($368e738781e188a9$var$kSplineTableSize) : new Array($368e738781e188a9$var$kSplineTableSize);
    for(var i = 0; i < $368e738781e188a9$var$kSplineTableSize; ++i)sampleValues[i] = $368e738781e188a9$var$calcBezier(i * $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $368e738781e188a9$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $368e738781e188a9$var$kSampleStepSize;
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $368e738781e188a9$var$kSampleStepSize;
        var initialSlope = $368e738781e188a9$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $368e738781e188a9$var$NEWTON_MIN_SLOPE) return $368e738781e188a9$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $368e738781e188a9$var$binarySubdivide(aX, intervalStart, intervalStart + $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    }
    return function BezierEasing(x) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0) return 0;
        if (x === 1) return 1;
        return $368e738781e188a9$var$calcBezier(getTForX(x), mY1, mY2);
    };
};


// Predefined set of animations. Similar to CSS easing functions
var $abd4e73c78068168$var$animations = {
    ease: $368e738781e188a9$exports(0.25, 0.1, 0.25, 1),
    easeIn: $368e738781e188a9$exports(0.42, 0, 1, 1),
    easeOut: $368e738781e188a9$exports(0, 0, 0.58, 1),
    easeInOut: $368e738781e188a9$exports(0.42, 0, 0.58, 1),
    linear: $368e738781e188a9$exports(0, 0, 1, 1)
};
$abd4e73c78068168$exports = $abd4e73c78068168$var$animate;
$abd4e73c78068168$exports.makeAggregateRaf = $abd4e73c78068168$var$makeAggregateRaf;
$abd4e73c78068168$exports.sharedScheduler = $abd4e73c78068168$var$makeAggregateRaf();
function $abd4e73c78068168$var$animate(source, target, options) {
    var start = Object.create(null);
    var diff = Object.create(null);
    options = options || {};
    // We let clients specify their own easing function
    var easing = typeof options.easing === "function" ? options.easing : $abd4e73c78068168$var$animations[options.easing];
    // if nothing is specified, default to ease (similar to CSS animations)
    if (!easing) {
        if (options.easing) console.warn("Unknown easing function in amator: " + options.easing);
        easing = $abd4e73c78068168$var$animations.ease;
    }
    var step = typeof options.step === "function" ? options.step : $abd4e73c78068168$var$noop;
    var done = typeof options.done === "function" ? options.done : $abd4e73c78068168$var$noop;
    var scheduler = $abd4e73c78068168$var$getScheduler(options.scheduler);
    var keys = Object.keys(target);
    keys.forEach(function(key) {
        start[key] = source[key];
        diff[key] = target[key] - source[key];
    });
    var durationInMs = typeof options.duration === "number" ? options.duration : 400;
    var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
    ;
    var previousAnimationId;
    var frame = 0;
    previousAnimationId = scheduler.next(loop);
    return {
        cancel: cancel
    };
    function cancel() {
        scheduler.cancel(previousAnimationId);
        previousAnimationId = 0;
    }
    function loop() {
        var t = easing(frame / durationInFrames);
        frame += 1;
        setValues(t);
        if (frame <= durationInFrames) {
            previousAnimationId = scheduler.next(loop);
            step(source);
        } else {
            previousAnimationId = 0;
            setTimeout(function() {
                done(source);
            }, 0);
        }
    }
    function setValues(t) {
        keys.forEach(function(key) {
            source[key] = diff[key] * t + start[key];
        });
    }
}
function $abd4e73c78068168$var$noop() {}
function $abd4e73c78068168$var$getScheduler(scheduler) {
    if (!scheduler) {
        var canRaf = typeof window !== "undefined" && window.requestAnimationFrame;
        return canRaf ? $abd4e73c78068168$var$rafScheduler() : $abd4e73c78068168$var$timeoutScheduler();
    }
    if (typeof scheduler.next !== "function") throw new Error("Scheduler is supposed to have next(cb) function");
    if (typeof scheduler.cancel !== "function") throw new Error("Scheduler is supposed to have cancel(handle) function");
    return scheduler;
}
function $abd4e73c78068168$var$rafScheduler() {
    return {
        next: window.requestAnimationFrame.bind(window),
        cancel: window.cancelAnimationFrame.bind(window)
    };
}
function $abd4e73c78068168$var$timeoutScheduler() {
    return {
        next: function(cb) {
            return setTimeout(cb, 1000 / 60);
        },
        cancel: function(id) {
            return clearTimeout(id);
        }
    };
}
function $abd4e73c78068168$var$makeAggregateRaf() {
    var frontBuffer = new Set();
    var backBuffer = new Set();
    var frameToken = 0;
    return {
        next: next,
        cancel: next,
        clearAll: clearAll
    };
    function clearAll() {
        frontBuffer.clear();
        backBuffer.clear();
        cancelAnimationFrame(frameToken);
        frameToken = 0;
    }
    function next(callback) {
        backBuffer.add(callback);
        renderNextFrame();
    }
    function renderNextFrame() {
        if (!frameToken) frameToken = requestAnimationFrame(renderFrame);
    }
    function renderFrame() {
        frameToken = 0;
        var t = backBuffer;
        backBuffer = frontBuffer;
        frontBuffer = t;
        frontBuffer.forEach(function(callback) {
            callback();
        });
        frontBuffer.clear();
    }
    function cancel(callback) {
        backBuffer.delete(callback);
    }
}


var $3f984ebf2aba86a9$exports = {};
$3f984ebf2aba86a9$exports = function eventify(subject) {
    $3f984ebf2aba86a9$var$validateSubject(subject);
    var eventsStorage = $3f984ebf2aba86a9$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
};
function $3f984ebf2aba86a9$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    var registeredEvents = Object.create(null);
    return {
        on: function(eventName, callback, ctx) {
            if (typeof callback !== "function") throw new Error("callback is expected to be a function");
            var handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function(eventName, callback) {
            var wantToRemoveAll = typeof eventName === "undefined";
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                var deleteAllCallbacksForEvent = typeof callback !== "function";
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    var callbacks = registeredEvents[eventName];
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function(eventName) {
            var callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            var fireArguments;
            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
            for(var i = 0; i < callbacks.length; ++i){
                var callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $3f984ebf2aba86a9$var$validateSubject(subject) {
    if (!subject) throw new Error("Eventify cannot use falsy object as events subject");
    var reservedWords = [
        "on",
        "fire",
        "off"
    ];
    for(var i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}


var $045989394badc850$exports = {};
/**
 * Allows smooth kinetic scrolling of the surface
 */ $045989394badc850$exports = $045989394badc850$var$kinetic;
function $045989394badc850$var$kinetic(getPoint, scroll, settings) {
    if (typeof settings !== "object") // setting could come as boolean, we should ignore it, and use an object.
    settings = {};
    var minVelocity = typeof settings.minVelocity === "number" ? settings.minVelocity : 5;
    var amplitude = typeof settings.amplitude === "number" ? settings.amplitude : 0.25;
    var cancelAnimationFrame1 = typeof settings.cancelAnimationFrame === "function" ? settings.cancelAnimationFrame : $045989394badc850$var$getCancelAnimationFrame();
    var requestAnimationFrame1 = typeof settings.requestAnimationFrame === "function" ? settings.requestAnimationFrame : $045989394badc850$var$getRequestAnimationFrame();
    var lastPoint;
    var timestamp;
    var timeConstant = 342;
    var ticker;
    var vx, targetX, ax;
    var vy, targetY, ay;
    var raf;
    return {
        start: start,
        stop: stop,
        cancel: dispose
    };
    function dispose() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
    }
    function start() {
        lastPoint = getPoint();
        ax = ay = vx = vy = 0;
        timestamp = new Date();
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        // we start polling the point position to accumulate velocity
        // Once we stop(), we will use accumulated velocity to keep scrolling
        // an object.
        ticker = requestAnimationFrame1(track);
    }
    function track() {
        var now = Date.now();
        var elapsed = now - timestamp;
        timestamp = now;
        var currentPoint = getPoint();
        var dx = currentPoint.x - lastPoint.x;
        var dy = currentPoint.y - lastPoint.y;
        lastPoint = currentPoint;
        var dt = 1000 / (1 + elapsed);
        // moving average
        vx = 0.8 * dx * dt + 0.2 * vx;
        vy = 0.8 * dy * dt + 0.2 * vy;
        ticker = requestAnimationFrame1(track);
    }
    function stop() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        var currentPoint = getPoint();
        targetX = currentPoint.x;
        targetY = currentPoint.y;
        timestamp = Date.now();
        if (vx < -minVelocity || vx > minVelocity) {
            ax = amplitude * vx;
            targetX += ax;
        }
        if (vy < -minVelocity || vy > minVelocity) {
            ay = amplitude * vy;
            targetY += ay;
        }
        raf = requestAnimationFrame1(autoScroll);
    }
    function autoScroll() {
        var elapsed = Date.now() - timestamp;
        var moving = false;
        var dx = 0;
        var dy = 0;
        if (ax) {
            dx = -ax * Math.exp(-elapsed / timeConstant);
            if (dx > 0.5 || dx < -0.5) moving = true;
            else dx = ax = 0;
        }
        if (ay) {
            dy = -ay * Math.exp(-elapsed / timeConstant);
            if (dy > 0.5 || dy < -0.5) moving = true;
            else dy = ay = 0;
        }
        if (moving) {
            scroll(targetX + dx, targetY + dy);
            raf = requestAnimationFrame1(autoScroll);
        }
    }
}
function $045989394badc850$var$getCancelAnimationFrame() {
    if (typeof cancelAnimationFrame === "function") return cancelAnimationFrame;
    return clearTimeout;
}
function $045989394badc850$var$getRequestAnimationFrame() {
    if (typeof requestAnimationFrame === "function") return requestAnimationFrame;
    return function(handler) {
        return setTimeout(handler, 16);
    };
}


var $f4e2629871e48550$exports = {};
/**
 * Disallows selecting text.
 */ $f4e2629871e48550$exports = $f4e2629871e48550$var$createTextSelectionInterceptor;
function $f4e2629871e48550$var$createTextSelectionInterceptor(useFake) {
    if (useFake) return {
        capture: $f4e2629871e48550$var$noop,
        release: $f4e2629871e48550$var$noop
    };
    var dragObject;
    var prevSelectStart;
    var prevDragStart;
    var wasCaptured = false;
    return {
        capture: capture,
        release: release
    };
    function capture(domObject) {
        wasCaptured = true;
        prevSelectStart = window.document.onselectstart;
        prevDragStart = window.document.ondragstart;
        window.document.onselectstart = $f4e2629871e48550$var$disabled;
        dragObject = domObject;
        dragObject.ondragstart = $f4e2629871e48550$var$disabled;
    }
    function release() {
        if (!wasCaptured) return;
        wasCaptured = false;
        window.document.onselectstart = prevSelectStart;
        if (dragObject) dragObject.ondragstart = prevDragStart;
    }
}
function $f4e2629871e48550$var$disabled(e) {
    e.stopPropagation();
    return false;
}
function $f4e2629871e48550$var$noop() {}


var $f22fea531ee465de$var$domTextSelectionInterceptor = $f4e2629871e48550$exports();
var $f22fea531ee465de$var$fakeTextSelectorInterceptor = $f4e2629871e48550$exports(true);
var $9f1de407a2889729$exports = {};
$9f1de407a2889729$exports = $9f1de407a2889729$var$Transform;
function $9f1de407a2889729$var$Transform() {
    this.x = 0;
    this.y = 0;
    this.scale = 1;
}


var $328194bd245b8736$exports = {};
$328194bd245b8736$exports = $328194bd245b8736$var$makeSvgController;
$328194bd245b8736$exports.canAttach = $328194bd245b8736$var$isSVGElement;
function $328194bd245b8736$var$makeSvgController(svgElement, options) {
    if (!$328194bd245b8736$var$isSVGElement(svgElement)) throw new Error("svg element is required for svg.panzoom to work");
    var owner = svgElement.ownerSVGElement;
    if (!owner) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
    if (!options.disableKeyboardInteraction) owner.setAttribute("tabindex", 0);
    var api = {
        getBBox: getBBox,
        getScreenCTM: getScreenCTM,
        getOwner: getOwner,
        applyTransform: applyTransform,
        initTransform: initTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        var bbox = svgElement.getBBox();
        return {
            left: bbox.x,
            top: bbox.y,
            width: bbox.width,
            height: bbox.height
        };
    }
    function getScreenCTM() {
        var ctm = owner.getCTM();
        if (!ctm) // This is likely firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=873106
        // The code below is not entirely correct, but still better than nothing
        return owner.getScreenCTM();
        return ctm;
    }
    function initTransform(transform) {
        var screenCTM = svgElement.getCTM();
        // The above line returns null on Firefox
        if (screenCTM === null) screenCTM = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix();
        transform.x = screenCTM.e;
        transform.y = screenCTM.f;
        transform.scale = screenCTM.a;
        owner.removeAttributeNS(null, "viewBox");
    }
    function applyTransform(transform) {
        svgElement.setAttribute("transform", "matrix(" + transform.scale + " 0 0 " + transform.scale + " " + transform.x + " " + transform.y + ")");
    }
}
function $328194bd245b8736$var$isSVGElement(element) {
    return element && element.ownerSVGElement && element.getCTM;
}


var $3ad745e165357d59$exports = {};
$3ad745e165357d59$exports = $3ad745e165357d59$var$makeDomController;
$3ad745e165357d59$exports.canAttach = $3ad745e165357d59$var$isDomElement;
function $3ad745e165357d59$var$makeDomController(domElement, options) {
    var elementValid = $3ad745e165357d59$var$isDomElement(domElement);
    if (!elementValid) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
    var owner = domElement.parentElement;
    domElement.scrollTop = 0;
    if (!options.disableKeyboardInteraction) owner.setAttribute("tabindex", 0);
    var api = {
        getBBox: getBBox,
        getOwner: getOwner,
        applyTransform: applyTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        // TODO: We should probably cache this?
        return {
            left: 0,
            top: 0,
            width: domElement.clientWidth,
            height: domElement.clientHeight
        };
    }
    function applyTransform(transform) {
        // TODO: Should we cache this?
        domElement.style.transformOrigin = "0 0 0";
        domElement.style.transform = "matrix(" + transform.scale + ", 0, 0, " + transform.scale + ", " + transform.x + ", " + transform.y + ")";
    }
}
function $3ad745e165357d59$var$isDomElement(element) {
    return element && element.parentElement && element.style;
}


var $f22fea531ee465de$var$defaultZoomSpeed = 1;
var $f22fea531ee465de$var$defaultDoubleTapZoomSpeed = 1.75;
var $f22fea531ee465de$var$doubleTapSpeedInMS = 300;
var $f22fea531ee465de$var$clickEventTimeInMS = 200;
$f22fea531ee465de$exports = $f22fea531ee465de$var$createPanZoom;
/**
 * Creates a new instance of panzoom, so that an object can be panned and zoomed
 *
 * @param {DOMElement} domElement where panzoom should be attached.
 * @param {Object} options that configure behavior.
 */ function $f22fea531ee465de$var$createPanZoom(domElement, options) {
    options = options || {};
    var panController = options.controller;
    if (!panController) {
        if ($328194bd245b8736$exports.canAttach(domElement)) panController = $328194bd245b8736$exports(domElement, options);
        else if ($3ad745e165357d59$exports.canAttach(domElement)) panController = $3ad745e165357d59$exports(domElement, options);
    }
    if (!panController) throw new Error("Cannot create panzoom for the current type of dom element");
    var owner = panController.getOwner();
    // just to avoid GC pressure, every time we do intermediate transform
    // we return this object. For internal use only. Never give it back to the consumer of this library
    var storedCTMResult = {
        x: 0,
        y: 0
    };
    var isDirty = false;
    var transform = new $9f1de407a2889729$exports();
    if (panController.initTransform) panController.initTransform(transform);
    var filterKey = typeof options.filterKey === "function" ? options.filterKey : $f22fea531ee465de$var$noop;
    // TODO: likely need to unite pinchSpeed with zoomSpeed
    var pinchSpeed = typeof options.pinchSpeed === "number" ? options.pinchSpeed : 1;
    var bounds = options.bounds;
    var maxZoom = typeof options.maxZoom === "number" ? options.maxZoom : Number.POSITIVE_INFINITY;
    var minZoom = typeof options.minZoom === "number" ? options.minZoom : 0;
    var boundsPadding = typeof options.boundsPadding === "number" ? options.boundsPadding : 0.05;
    var zoomDoubleClickSpeed = typeof options.zoomDoubleClickSpeed === "number" ? options.zoomDoubleClickSpeed : $f22fea531ee465de$var$defaultDoubleTapZoomSpeed;
    var beforeWheel = options.beforeWheel || $f22fea531ee465de$var$noop;
    var beforeMouseDown = options.beforeMouseDown || $f22fea531ee465de$var$noop;
    var speed = typeof options.zoomSpeed === "number" ? options.zoomSpeed : $f22fea531ee465de$var$defaultZoomSpeed;
    var transformOrigin = $f22fea531ee465de$var$parseTransformOrigin(options.transformOrigin);
    var textSelection = options.enableTextSelection ? $f22fea531ee465de$var$fakeTextSelectorInterceptor : $f22fea531ee465de$var$domTextSelectionInterceptor;
    $f22fea531ee465de$var$validateBounds(bounds);
    if (options.autocenter) autocenter();
    var frameAnimation;
    var lastTouchEndTime = 0;
    var lastTouchStartTime = 0;
    var pendingClickEventTimeout = 0;
    var lastMouseDownedEvent = null;
    var lastMouseDownTime = new Date();
    var lastSingleFingerOffset;
    var touchInProgress = false;
    // We only need to fire panstart when actual move happens
    var panstartFired = false;
    // cache mouse coordinates here
    var mouseX;
    var mouseY;
    // Where the first click has happened, so that we can differentiate
    // between pan and click
    var clickX;
    var clickY;
    var pinchZoomLength;
    var smoothScroll;
    if ("smoothScroll" in options && !options.smoothScroll) // If user explicitly asked us not to use smooth scrolling, we obey
    smoothScroll = $f22fea531ee465de$var$rigidScroll();
    else // otherwise we use forward smoothScroll settings to kinetic API
    // which makes scroll smoothing.
    smoothScroll = $045989394badc850$exports(getPoint, scroll, options.smoothScroll);
    var moveByAnimation;
    var zoomToAnimation;
    var multiTouch;
    var paused = false;
    listenForEvents();
    var api = {
        dispose: dispose,
        moveBy: internalMoveBy,
        moveTo: moveTo,
        smoothMoveTo: smoothMoveTo,
        centerOn: centerOn,
        zoomTo: publicZoomTo,
        zoomAbs: zoomAbs,
        smoothZoom: smoothZoom,
        smoothZoomAbs: smoothZoomAbs,
        showRectangle: showRectangle,
        pause: pause,
        resume: resume,
        isPaused: isPaused,
        getTransform: getTransformModel,
        getMinZoom: getMinZoom,
        setMinZoom: setMinZoom,
        getMaxZoom: getMaxZoom,
        setMaxZoom: setMaxZoom,
        getTransformOrigin: getTransformOrigin,
        setTransformOrigin: setTransformOrigin,
        getZoomSpeed: getZoomSpeed,
        setZoomSpeed: setZoomSpeed
    };
    $3f984ebf2aba86a9$exports(api);
    var initialX = typeof options.initialX === "number" ? options.initialX : transform.x;
    var initialY = typeof options.initialY === "number" ? options.initialY : transform.y;
    var initialZoom = typeof options.initialZoom === "number" ? options.initialZoom : transform.scale;
    if (initialX != transform.x || initialY != transform.y || initialZoom != transform.scale) zoomAbs(initialX, initialY, initialZoom);
    return api;
    function pause() {
        releaseEvents();
        paused = true;
    }
    function resume() {
        if (paused) {
            listenForEvents();
            paused = false;
        }
    }
    function isPaused() {
        return paused;
    }
    function showRectangle(rect) {
        // TODO: this duplicates autocenter. I think autocenter should go.
        var clientRect = owner.getBoundingClientRect();
        var size = transformToScreen(clientRect.width, clientRect.height);
        var rectWidth = rect.right - rect.left;
        var rectHeight = rect.bottom - rect.top;
        if (!Number.isFinite(rectWidth) || !Number.isFinite(rectHeight)) throw new Error("Invalid rectangle");
        var dw = size.x / rectWidth;
        var dh = size.y / rectHeight;
        var scale = Math.min(dw, dh);
        transform.x = -(rect.left + rectWidth / 2) * scale + size.x / 2;
        transform.y = -(rect.top + rectHeight / 2) * scale + size.y / 2;
        transform.scale = scale;
    }
    function transformToScreen(x, y) {
        if (panController.getScreenCTM) {
            var parentCTM = panController.getScreenCTM();
            var parentScaleX = parentCTM.a;
            var parentScaleY = parentCTM.d;
            var parentOffsetX = parentCTM.e;
            var parentOffsetY = parentCTM.f;
            storedCTMResult.x = x * parentScaleX - parentOffsetX;
            storedCTMResult.y = y * parentScaleY - parentOffsetY;
        } else {
            storedCTMResult.x = x;
            storedCTMResult.y = y;
        }
        return storedCTMResult;
    }
    function autocenter() {
        var w; // width of the parent
        var h; // height of the parent
        var left = 0;
        var top = 0;
        var sceneBoundingBox = getBoundingBox();
        if (sceneBoundingBox) {
            // If we have bounding box - use it.
            left = sceneBoundingBox.left;
            top = sceneBoundingBox.top;
            w = sceneBoundingBox.right - sceneBoundingBox.left;
            h = sceneBoundingBox.bottom - sceneBoundingBox.top;
        } else {
            // otherwise just use whatever space we have
            var ownerRect = owner.getBoundingClientRect();
            w = ownerRect.width;
            h = ownerRect.height;
        }
        var bbox = panController.getBBox();
        if (bbox.width === 0 || bbox.height === 0) // we probably do not have any elements in the SVG
        // just bail out;
        return;
        var dh = h / bbox.height;
        var dw = w / bbox.width;
        var scale = Math.min(dw, dh);
        transform.x = -(bbox.left + bbox.width / 2) * scale + w / 2 + left;
        transform.y = -(bbox.top + bbox.height / 2) * scale + h / 2 + top;
        transform.scale = scale;
    }
    function getTransformModel() {
        // TODO: should this be read only?
        return transform;
    }
    function getMinZoom() {
        return minZoom;
    }
    function setMinZoom(newMinZoom) {
        minZoom = newMinZoom;
    }
    function getMaxZoom() {
        return maxZoom;
    }
    function setMaxZoom(newMaxZoom) {
        maxZoom = newMaxZoom;
    }
    function getTransformOrigin() {
        return transformOrigin;
    }
    function setTransformOrigin(newTransformOrigin) {
        transformOrigin = $f22fea531ee465de$var$parseTransformOrigin(newTransformOrigin);
    }
    function getZoomSpeed() {
        return speed;
    }
    function setZoomSpeed(newSpeed) {
        if (!Number.isFinite(newSpeed)) throw new Error("Zoom speed should be a number");
        speed = newSpeed;
    }
    function getPoint() {
        return {
            x: transform.x,
            y: transform.y
        };
    }
    function moveTo(x, y) {
        transform.x = x;
        transform.y = y;
        keepTransformInsideBounds();
        triggerEvent("pan");
        makeDirty();
    }
    function moveBy(dx, dy) {
        moveTo(transform.x + dx, transform.y + dy);
    }
    function keepTransformInsideBounds() {
        var boundingBox = getBoundingBox();
        if (!boundingBox) return;
        var adjusted = false;
        var clientRect = getClientRect();
        var diff = boundingBox.left - clientRect.right;
        if (diff > 0) {
            transform.x += diff;
            adjusted = true;
        }
        // check the other side:
        diff = boundingBox.right - clientRect.left;
        if (diff < 0) {
            transform.x += diff;
            adjusted = true;
        }
        // y axis:
        diff = boundingBox.top - clientRect.bottom;
        if (diff > 0) {
            // we adjust transform, so that it matches exactly our bounding box:
            // transform.y = boundingBox.top - (boundingBox.height + boundingBox.y) * transform.scale =>
            // transform.y = boundingBox.top - (clientRect.bottom - transform.y) =>
            // transform.y = diff + transform.y =>
            transform.y += diff;
            adjusted = true;
        }
        diff = boundingBox.bottom - clientRect.top;
        if (diff < 0) {
            transform.y += diff;
            adjusted = true;
        }
        return adjusted;
    }
    /**
   * Returns bounding box that should be used to restrict scene movement.
   */ function getBoundingBox() {
        if (!bounds) return; // client does not want to restrict movement
        if (typeof bounds === "boolean") {
            // for boolean type we use parent container bounds
            var ownerRect = owner.getBoundingClientRect();
            var sceneWidth = ownerRect.width;
            var sceneHeight = ownerRect.height;
            return {
                left: sceneWidth * boundsPadding,
                top: sceneHeight * boundsPadding,
                right: sceneWidth * (1 - boundsPadding),
                bottom: sceneHeight * (1 - boundsPadding)
            };
        }
        return bounds;
    }
    function getClientRect() {
        var bbox = panController.getBBox();
        var leftTop = client(bbox.left, bbox.top);
        return {
            left: leftTop.x,
            top: leftTop.y,
            right: bbox.width * transform.scale + leftTop.x,
            bottom: bbox.height * transform.scale + leftTop.y
        };
    }
    function client(x, y) {
        return {
            x: x * transform.scale + transform.x,
            y: y * transform.scale + transform.y
        };
    }
    function makeDirty() {
        isDirty = true;
        frameAnimation = window.requestAnimationFrame(frame);
    }
    function zoomByRatio(clientX, clientY, ratio) {
        if ($f22fea531ee465de$var$isNaN(clientX) || $f22fea531ee465de$var$isNaN(clientY) || $f22fea531ee465de$var$isNaN(ratio)) throw new Error("zoom requires valid numbers");
        var newScale = transform.scale * ratio;
        if (newScale < minZoom) {
            if (transform.scale === minZoom) return;
            ratio = minZoom / transform.scale;
        }
        if (newScale > maxZoom) {
            if (transform.scale === maxZoom) return;
            ratio = maxZoom / transform.scale;
        }
        var size = transformToScreen(clientX, clientY);
        transform.x = size.x - ratio * (size.x - transform.x);
        transform.y = size.y - ratio * (size.y - transform.y);
        // TODO: https://github.com/anvaka/panzoom/issues/112
        if (bounds && boundsPadding === 1 && minZoom === 1) {
            transform.scale *= ratio;
            keepTransformInsideBounds();
        } else {
            var transformAdjusted = keepTransformInsideBounds();
            if (!transformAdjusted) transform.scale *= ratio;
        }
        triggerEvent("zoom");
        makeDirty();
    }
    function zoomAbs(clientX, clientY, zoomLevel) {
        var ratio = zoomLevel / transform.scale;
        zoomByRatio(clientX, clientY, ratio);
    }
    function centerOn(ui) {
        var parent = ui.ownerSVGElement;
        if (!parent) throw new Error("ui element is required to be within the scene");
        // TODO: should i use controller's screen CTM?
        var clientRect = ui.getBoundingClientRect();
        var cx = clientRect.left + clientRect.width / 2;
        var cy = clientRect.top + clientRect.height / 2;
        var container = parent.getBoundingClientRect();
        var dx = container.width / 2 - cx;
        var dy = container.height / 2 - cy;
        internalMoveBy(dx, dy, true);
    }
    function smoothMoveTo(x, y) {
        internalMoveBy(x - transform.x, y - transform.y, true);
    }
    function internalMoveBy(dx, dy, smooth) {
        if (!smooth) return moveBy(dx, dy);
        if (moveByAnimation) moveByAnimation.cancel();
        var from = {
            x: 0,
            y: 0
        };
        var to = {
            x: dx,
            y: dy
        };
        var lastX = 0;
        var lastY = 0;
        moveByAnimation = $abd4e73c78068168$exports(from, to, {
            step: function(v) {
                moveBy(v.x - lastX, v.y - lastY);
                lastX = v.x;
                lastY = v.y;
            }
        });
    }
    function scroll(x, y) {
        cancelZoomAnimation();
        moveTo(x, y);
    }
    function dispose() {
        releaseEvents();
    }
    function listenForEvents() {
        owner.addEventListener("mousedown", onMouseDown, {
            passive: false
        });
        owner.addEventListener("dblclick", onDoubleClick, {
            passive: false
        });
        owner.addEventListener("touchstart", onTouch, {
            passive: false
        });
        owner.addEventListener("keydown", onKeyDown, {
            passive: false
        });
        // Need to listen on the owner container, so that we are not limited
        // by the size of the scrollable domElement
        $ee3594ab38f6167c$exports.addWheelListener(owner, onMouseWheel, {
            passive: false
        });
        makeDirty();
    }
    function releaseEvents() {
        $ee3594ab38f6167c$exports.removeWheelListener(owner, onMouseWheel);
        owner.removeEventListener("mousedown", onMouseDown);
        owner.removeEventListener("keydown", onKeyDown);
        owner.removeEventListener("dblclick", onDoubleClick);
        owner.removeEventListener("touchstart", onTouch);
        if (frameAnimation) {
            window.cancelAnimationFrame(frameAnimation);
            frameAnimation = 0;
        }
        smoothScroll.cancel();
        releaseDocumentMouse();
        releaseTouches();
        textSelection.release();
        triggerPanEnd();
    }
    function frame() {
        if (isDirty) applyTransform();
    }
    function applyTransform() {
        isDirty = false;
        // TODO: Should I allow to cancel this?
        panController.applyTransform(transform);
        triggerEvent("transform");
        frameAnimation = 0;
    }
    function onKeyDown(e) {
        var x = 0, y = 0, z = 0;
        if (e.keyCode === 38) y = 1; // up
        else if (e.keyCode === 40) y = -1; // down
        else if (e.keyCode === 37) x = 1; // left
        else if (e.keyCode === 39) x = -1; // right
        else if (e.keyCode === 189 || e.keyCode === 109) // DASH or SUBTRACT
        z = 1; // `-` -  zoom out
        else if (e.keyCode === 187 || e.keyCode === 107) // EQUAL SIGN or ADD
        z = -1; // `=` - zoom in (equal sign on US layout is under `+`)
        if (filterKey(e, x, y, z)) // They don't want us to handle the key: https://github.com/anvaka/panzoom/issues/45
        return;
        if (x || y) {
            e.preventDefault();
            e.stopPropagation();
            var clientRect = owner.getBoundingClientRect();
            // movement speed should be the same in both X and Y direction:
            var offset = Math.min(clientRect.width, clientRect.height);
            var moveSpeedRatio = 0.05;
            var dx = offset * moveSpeedRatio * x;
            var dy = offset * moveSpeedRatio * y;
            // TODO: currently we do not animate this. It could be better to have animation
            internalMoveBy(dx, dy);
        }
        if (z) {
            var scaleMultiplier = getScaleMultiplier(z * 100);
            var offset = transformOrigin ? getTransformOriginOffset() : midPoint();
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
        }
    }
    function midPoint() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width / 2,
            y: ownerRect.height / 2
        };
    }
    function onTouch(e) {
        // let them override the touch behavior
        beforeTouch(e);
        clearPendingClickEventTimeout();
        if (e.touches.length === 1) return handleSingleFingerTouch(e, e.touches[0]);
        else if (e.touches.length === 2) {
            // handleTouchMove() will care about pinch zoom.
            pinchZoomLength = getPinchZoomLength(e.touches[0], e.touches[1]);
            multiTouch = true;
            startTouchListenerIfNeeded();
        }
    }
    function beforeTouch(e) {
        // TODO: Need to unify this filtering names. E.g. use `beforeTouch`
        if (options.onTouch && !options.onTouch(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/12
        return;
        e.stopPropagation();
        e.preventDefault();
    }
    function beforeDoubleClick(e) {
        clearPendingClickEventTimeout();
        // TODO: Need to unify this filtering names. E.g. use `beforeDoubleClick``
        if (options.onDoubleClick && !options.onDoubleClick(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/46
        return;
        e.preventDefault();
        e.stopPropagation();
    }
    function handleSingleFingerTouch(e) {
        lastTouchStartTime = new Date();
        var touch = e.touches[0];
        var offset = getOffsetXY(touch);
        lastSingleFingerOffset = offset;
        var point = transformToScreen(offset.x, offset.y);
        mouseX = point.x;
        mouseY = point.y;
        clickX = mouseX;
        clickY = mouseY;
        smoothScroll.cancel();
        startTouchListenerIfNeeded();
    }
    function startTouchListenerIfNeeded() {
        if (touchInProgress) // no need to do anything, as we already listen to events;
        return;
        touchInProgress = true;
        document.addEventListener("touchmove", handleTouchMove);
        document.addEventListener("touchend", handleTouchEnd);
        document.addEventListener("touchcancel", handleTouchEnd);
    }
    function handleTouchMove(e) {
        if (e.touches.length === 1) {
            e.stopPropagation();
            var touch = e.touches[0];
            var offset = getOffsetXY(touch);
            var point = transformToScreen(offset.x, offset.y);
            var dx = point.x - mouseX;
            var dy = point.y - mouseY;
            if (dx !== 0 && dy !== 0) triggerPanStart();
            mouseX = point.x;
            mouseY = point.y;
            internalMoveBy(dx, dy);
        } else if (e.touches.length === 2) {
            // it's a zoom, let's find direction
            multiTouch = true;
            var t1 = e.touches[0];
            var t2 = e.touches[1];
            var currentPinchLength = getPinchZoomLength(t1, t2);
            // since the zoom speed is always based on distance from 1, we need to apply
            // pinch speed only on that distance from 1:
            var scaleMultiplier = 1 + (currentPinchLength / pinchZoomLength - 1) * pinchSpeed;
            var firstTouchPoint = getOffsetXY(t1);
            var secondTouchPoint = getOffsetXY(t2);
            mouseX = (firstTouchPoint.x + secondTouchPoint.x) / 2;
            mouseY = (firstTouchPoint.y + secondTouchPoint.y) / 2;
            if (transformOrigin) {
                var offset = getTransformOriginOffset();
                mouseX = offset.x;
                mouseY = offset.y;
            }
            publicZoomTo(mouseX, mouseY, scaleMultiplier);
            pinchZoomLength = currentPinchLength;
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function clearPendingClickEventTimeout() {
        if (pendingClickEventTimeout) {
            clearTimeout(pendingClickEventTimeout);
            pendingClickEventTimeout = 0;
        }
    }
    function handlePotentialClickEvent(e) {
        // we could still be in the double tap mode, let's wait until double tap expires,
        // and then notify:
        if (!options.onClick) return;
        clearPendingClickEventTimeout();
        var dx = mouseX - clickX;
        var dy = mouseY - clickY;
        var l = Math.sqrt(dx * dx + dy * dy);
        if (l > 5) return; // probably they are panning, ignore it
        pendingClickEventTimeout = setTimeout(function() {
            pendingClickEventTimeout = 0;
            options.onClick(e);
        }, $f22fea531ee465de$var$doubleTapSpeedInMS);
    }
    function handleTouchEnd(e) {
        clearPendingClickEventTimeout();
        if (e.touches.length > 0) {
            var offset = getOffsetXY(e.touches[0]);
            var point = transformToScreen(offset.x, offset.y);
            mouseX = point.x;
            mouseY = point.y;
        } else {
            var now = new Date();
            if (now - lastTouchEndTime < $f22fea531ee465de$var$doubleTapSpeedInMS) {
                // They did a double tap here
                if (transformOrigin) {
                    var offset = getTransformOriginOffset();
                    smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
                } else // We want untransformed x/y here.
                smoothZoom(lastSingleFingerOffset.x, lastSingleFingerOffset.y, zoomDoubleClickSpeed);
            } else if (now - lastTouchStartTime < $f22fea531ee465de$var$clickEventTimeInMS) handlePotentialClickEvent(e);
            lastTouchEndTime = now;
            triggerPanEnd();
            releaseTouches();
        }
    }
    function getPinchZoomLength(finger1, finger2) {
        var dx = finger1.clientX - finger2.clientX;
        var dy = finger1.clientY - finger2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }
    function onDoubleClick(e) {
        beforeDoubleClick(e);
        var offset = getOffsetXY(e);
        if (transformOrigin) // TODO: looks like this is duplicated in the file.
        // Need to refactor
        offset = getTransformOriginOffset();
        smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
    }
    function onMouseDown(e) {
        clearPendingClickEventTimeout();
        // if client does not want to handle this event - just ignore the call
        if (beforeMouseDown(e)) return;
        lastMouseDownedEvent = e;
        lastMouseDownTime = new Date();
        if (touchInProgress) {
            // modern browsers will fire mousedown for touch events too
            // we do not want this: touch is handled separately.
            e.stopPropagation();
            return false;
        }
        // for IE, left click == 1
        // for Firefox, left click == 0
        var isLeftButton = e.button === 1 && window.event !== null || e.button === 0;
        if (!isLeftButton) return;
        smoothScroll.cancel();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        clickX = mouseX = point.x;
        clickY = mouseY = point.y;
        // We need to listen on document itself, since mouse can go outside of the
        // window, and we will loose it
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        textSelection.capture(e.target || e.srcElement);
        return false;
    }
    function onMouseMove(e) {
        // no need to worry about mouse events when touch is happening
        if (touchInProgress) return;
        triggerPanStart();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        var dx = point.x - mouseX;
        var dy = point.y - mouseY;
        mouseX = point.x;
        mouseY = point.y;
        internalMoveBy(dx, dy);
    }
    function onMouseUp() {
        var now = new Date();
        if (now - lastMouseDownTime < $f22fea531ee465de$var$clickEventTimeInMS) handlePotentialClickEvent(lastMouseDownedEvent);
        textSelection.release();
        triggerPanEnd();
        releaseDocumentMouse();
    }
    function releaseDocumentMouse() {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        panstartFired = false;
    }
    function releaseTouches() {
        document.removeEventListener("touchmove", handleTouchMove);
        document.removeEventListener("touchend", handleTouchEnd);
        document.removeEventListener("touchcancel", handleTouchEnd);
        panstartFired = false;
        multiTouch = false;
        touchInProgress = false;
    }
    function onMouseWheel(e) {
        // if client does not want to handle this event - just ignore the call
        if (beforeWheel(e)) return;
        smoothScroll.cancel();
        var delta = e.deltaY;
        if (e.deltaMode > 0) delta *= 100;
        var scaleMultiplier = getScaleMultiplier(delta);
        if (scaleMultiplier !== 1) {
            var offset = transformOrigin ? getTransformOriginOffset() : getOffsetXY(e);
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
            e.preventDefault();
        }
    }
    function getOffsetXY(e) {
        var offsetX, offsetY;
        // I tried using e.offsetX, but that gives wrong results for svg, when user clicks on a path.
        var ownerRect = owner.getBoundingClientRect();
        offsetX = e.clientX - ownerRect.left;
        offsetY = e.clientY - ownerRect.top;
        return {
            x: offsetX,
            y: offsetY
        };
    }
    function smoothZoom(clientX, clientY, scaleMultiplier) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: scaleMultiplier * fromValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $abd4e73c78068168$exports(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            },
            done: triggerZoomEnd
        });
    }
    function smoothZoomAbs(clientX, clientY, toScaleValue) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: toScaleValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $abd4e73c78068168$exports(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            }
        });
    }
    function getTransformOriginOffset() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width * transformOrigin.x,
            y: ownerRect.height * transformOrigin.y
        };
    }
    function publicZoomTo(clientX, clientY, scaleMultiplier) {
        smoothScroll.cancel();
        cancelZoomAnimation();
        return zoomByRatio(clientX, clientY, scaleMultiplier);
    }
    function cancelZoomAnimation() {
        if (zoomToAnimation) {
            zoomToAnimation.cancel();
            zoomToAnimation = null;
        }
    }
    function getScaleMultiplier(delta) {
        var sign = Math.sign(delta);
        var deltaAdjustedSpeed = Math.min(0.25, Math.abs(speed * delta / 128));
        return 1 - sign * deltaAdjustedSpeed;
    }
    function triggerPanStart() {
        if (!panstartFired) {
            triggerEvent("panstart");
            panstartFired = true;
            smoothScroll.start();
        }
    }
    function triggerPanEnd() {
        if (panstartFired) {
            // we should never run smooth scrolling if it was multiTouch (pinch zoom animation):
            if (!multiTouch) smoothScroll.stop();
            triggerEvent("panend");
        }
    }
    function triggerZoomEnd() {
        triggerEvent("zoomend");
    }
    function triggerEvent(name) {
        api.fire(name, api);
    }
}
function $f22fea531ee465de$var$parseTransformOrigin(options) {
    if (!options) return;
    if (typeof options === "object") {
        if (!$f22fea531ee465de$var$isNumber(options.x) || !$f22fea531ee465de$var$isNumber(options.y)) $f22fea531ee465de$var$failTransformOrigin(options);
        return options;
    }
    $f22fea531ee465de$var$failTransformOrigin();
}
function $f22fea531ee465de$var$failTransformOrigin(options) {
    console.error(options);
    throw new Error([
        "Cannot parse transform origin.",
        "Some good examples:",
        '  "center center" can be achieved with {x: 0.5, y: 0.5}',
        '  "top center" can be achieved with {x: 0.5, y: 0}',
        '  "bottom right" can be achieved with {x: 1, y: 1}'
    ].join("\n"));
}
function $f22fea531ee465de$var$noop() {}
function $f22fea531ee465de$var$validateBounds(bounds) {
    var boundsType = typeof bounds;
    if (boundsType === "undefined" || boundsType === "boolean") return; // this is okay
    // otherwise need to be more thorough:
    var validBounds = $f22fea531ee465de$var$isNumber(bounds.left) && $f22fea531ee465de$var$isNumber(bounds.top) && $f22fea531ee465de$var$isNumber(bounds.bottom) && $f22fea531ee465de$var$isNumber(bounds.right);
    if (!validBounds) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
}
function $f22fea531ee465de$var$isNumber(x) {
    return Number.isFinite(x);
}
// IE 11 does not support isNaN:
function $f22fea531ee465de$var$isNaN(value) {
    if (Number.isNaN) return Number.isNaN(value);
    return value !== value;
}
function $f22fea531ee465de$var$rigidScroll() {
    return {
        start: $f22fea531ee465de$var$noop,
        stop: $f22fea531ee465de$var$noop,
        cancel: $f22fea531ee465de$var$noop
    };
}
function $f22fea531ee465de$var$autoRun() {
    if (typeof document === "undefined") return;
    var scripts = document.getElementsByTagName("script");
    if (!scripts) return;
    var panzoomScript;
    for(var i = 0; i < scripts.length; ++i){
        var x = scripts[i];
        if (x.src && x.src.match(/\bpanzoom(\.min)?\.js/)) {
            panzoomScript = x;
            break;
        }
    }
    if (!panzoomScript) return;
    var query = panzoomScript.getAttribute("query");
    if (!query) return;
    var globalName = panzoomScript.getAttribute("name") || "pz";
    var started = Date.now();
    tryAttach();
    function tryAttach() {
        var el = document.querySelector(query);
        if (!el) {
            var now = Date.now();
            var elapsed = now - started;
            if (elapsed < 2000) {
                // Let's wait a bit
                setTimeout(tryAttach, 100);
                return;
            }
            // If we don't attach within 2 seconds to the target element, consider it a failure
            console.error("Cannot find the panzoom element", globalName);
            return;
        }
        var options = collectOptions(panzoomScript);
        console.log(options);
        window[globalName] = $f22fea531ee465de$var$createPanZoom(el, options);
    }
    function collectOptions(script) {
        var attrs = script.attributes;
        var options = {};
        for(var j = 0; j < attrs.length; ++j){
            var attr = attrs[j];
            var nameValue = getPanzoomAttributeNameValue(attr);
            if (nameValue) options[nameValue.name] = nameValue.value;
        }
        return options;
    }
    function getPanzoomAttributeNameValue(attr) {
        if (!attr.name) return;
        var isPanZoomAttribute = attr.name[0] === "p" && attr.name[1] === "z" && attr.name[2] === "-";
        if (!isPanZoomAttribute) return;
        var name = attr.name.substr(3);
        var value = JSON.parse(attr.value);
        return {
            name: name,
            value: value
        };
    }
}
$f22fea531ee465de$var$autoRun();


let $89727467ebfe0d15$var$pc = document.getElementById("pagesContainer");
function $89727467ebfe0d15$export$8adb0d4d56f5534c() {
    window.pz = (0, (/*@__PURE__*/$parcel$interopDefault($f22fea531ee465de$exports)))($89727467ebfe0d15$var$pc, {
        bounds: false,
        maxZoom: 10,
        minZoom: 0.1,
        zoomDoubleClickSpeed: 1,
        enableTextSelection: true,
        beforeMouseDown: function(e) {
            let shouldIgnore = $89727467ebfe0d15$var$disablePanzoomOnElement(e.target) || e.target.closest(".textBox") !== null || (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).ctrlToPan && !e.ctrlKey;
            return shouldIgnore;
        },
        beforeWheel: function(e) {
            let shouldIgnore = (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).altToZoom && !e.altKey || $89727467ebfe0d15$var$disablePanzoomOnElement(e.target);
            return shouldIgnore;
        },
        onTouch: function(e) {
            if ($89727467ebfe0d15$var$disablePanzoomOnElement(e.target)) {
                e.stopPropagation();
                return false;
            }
            if (e.touches.length > 1) return true;
            else return false;
        },
        filterKey: function(e) {
            if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).turnPagesWithArrows) {
                if (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "ArrowUp" || e.key === "ArrowDown") return true;
            }
        }
    });
    window.addEventListener("resize", function(event) {
        $89727467ebfe0d15$export$e69cdf5edcfb1256();
    }, true);
    window.pz.on("pan", (e)=>{
        keepInBounds();
    });
    window.pz.on("zoom", (e)=>{
        keepInBounds();
    });
    function keepInBounds() {
        let transform = window.pz.getTransform();
        let x = transform.x;
        let y = transform.y;
        let scale = transform.scale;
        let W = window.innerWidth;
        let H = window.innerHeight;
        let w = $89727467ebfe0d15$var$pc.offsetWidth * scale;
        let h = $89727467ebfe0d15$var$pc.offsetHeight * scale;
        let x_margin = W * 0.1;
        let y_margin = H * 0.1;
        let min_x = W - w - x_margin;
        let max_x = x_margin;
        let min_y = H - h - y_margin;
        let max_y = y_margin;
        if (w + 2 * x_margin <= W) {
            min_x = x_margin;
            max_x = W - w - x_margin;
        }
        if (h + 2 * y_margin <= H) {
            min_y = y_margin;
            max_y = H - h - y_margin;
        }
        if (x < min_x) transform.x = min_x;
        if (x > max_x) transform.x = max_x;
        if (y < min_y) transform.y = min_y;
        if (y > max_y) transform.y = max_y;
    }
    window.addEventListener("wheel", function(e) {
        if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).altToZoom) {
            const transforms = pz.getTransform();
            let dx = e.shiftKey ? e.deltaY : 0;
            let dy = e.shiftKey ? 0 : -e.deltaY;
            pz.moveTo(transforms.x + dx, transforms.y + dy);
        }
    }, {
        passive: true
    });
}
function $89727467ebfe0d15$var$disablePanzoomOnElement(element) {
    return document.getElementById("topMenu").contains(element);
}
function $89727467ebfe0d15$var$getOffsetLeft() {
    return 0;
}
function $89727467ebfe0d15$var$getOffsetTop() {
    let offset = 0;
    let menu = document.getElementById("topMenu");
    if (!menu.classList.contains("hidden")) offset += menu.getBoundingClientRect().bottom + 10;
    return offset;
}
function $89727467ebfe0d15$var$getOffsetRight() {
    return 0;
}
function $89727467ebfe0d15$var$getOffsetBottom() {
    return 0;
}
function $89727467ebfe0d15$var$getScreenWidth() {
    return window.innerWidth - $89727467ebfe0d15$var$getOffsetLeft() - $89727467ebfe0d15$var$getOffsetRight();
}
function $89727467ebfe0d15$var$getScreenHeight() {
    return window.innerHeight - $89727467ebfe0d15$var$getOffsetTop() - $89727467ebfe0d15$var$getOffsetBottom();
}
function $89727467ebfe0d15$var$panAlign(align_x, align_y) {
    let scale = window.pz.getTransform().scale;
    let x;
    let y;
    switch(align_x){
        case "left":
            x = $89727467ebfe0d15$var$getOffsetLeft();
            break;
        case "center":
            x = $89727467ebfe0d15$var$getOffsetLeft() + ($89727467ebfe0d15$var$getScreenWidth() - $89727467ebfe0d15$var$pc.offsetWidth * scale) / 2;
            break;
        case "right":
            x = $89727467ebfe0d15$var$getOffsetLeft() + ($89727467ebfe0d15$var$getScreenWidth() - $89727467ebfe0d15$var$pc.offsetWidth * scale);
            break;
    }
    switch(align_y){
        case "top":
            y = $89727467ebfe0d15$var$getOffsetTop();
            break;
        case "center":
            y = $89727467ebfe0d15$var$getOffsetTop() + ($89727467ebfe0d15$var$getScreenHeight() - $89727467ebfe0d15$var$pc.offsetHeight * scale) / 2;
            break;
        case "bottom":
            y = $89727467ebfe0d15$var$getOffsetTop() + ($89727467ebfe0d15$var$getScreenHeight() - $89727467ebfe0d15$var$pc.offsetHeight * scale);
            break;
    }
    window.pz.moveTo(x, y);
}
function $89727467ebfe0d15$export$4afa5795c6ff0190() {
    window.pz.moveTo(0, 0);
    window.pz.zoomTo(0, 0, 1 / window.pz.getTransform().scale);
    $89727467ebfe0d15$var$panAlign("center", "center");
}
function $89727467ebfe0d15$export$9801b4b24c80f370() {
    let scale = 1 / window.pz.getTransform().scale * ($89727467ebfe0d15$var$getScreenWidth() / $89727467ebfe0d15$var$pc.offsetWidth);
    window.pz.moveTo(0, 0);
    window.pz.zoomTo(0, 0, scale);
    $89727467ebfe0d15$var$panAlign("center", "top");
}
function $89727467ebfe0d15$export$b01a26907ad47277() {
    let scale_x = $89727467ebfe0d15$var$getScreenWidth() / $89727467ebfe0d15$var$pc.offsetWidth;
    let scale_y = $89727467ebfe0d15$var$getScreenHeight() / $89727467ebfe0d15$var$pc.offsetHeight;
    let scale = 1 / window.pz.getTransform().scale * Math.min(scale_x, scale_y);
    window.pz.moveTo(0, 0);
    window.pz.zoomTo(0, 0, scale);
    $89727467ebfe0d15$var$panAlign("center", "center");
}
function $89727467ebfe0d15$export$24b5fa69f2944279() {
    switch((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).defaultZoomMode){
        case "fit to screen":
            $89727467ebfe0d15$export$b01a26907ad47277();
            break;
        case "fit to width":
            $89727467ebfe0d15$export$9801b4b24c80f370();
            break;
        case "original size":
            $89727467ebfe0d15$export$4afa5795c6ff0190();
            break;
    }
}
function $89727467ebfe0d15$export$e69cdf5edcfb1256() {
    let minZoom, maxZoom;
    if ($89727467ebfe0d15$var$pc.offsetWidth === 0 || $89727467ebfe0d15$var$pc.offsetHeight === 0) {
        minZoom = 0.1;
        maxZoom = 10;
    } else {
        minZoom = Math.min(window.innerWidth / $89727467ebfe0d15$var$pc.offsetWidth * 0.75, window.innerHeight / $89727467ebfe0d15$var$pc.offsetHeight * 0.75);
        maxZoom = Math.max(window.innerWidth / $89727467ebfe0d15$var$pc.offsetWidth * 10, window.innerHeight / $89727467ebfe0d15$var$pc.offsetHeight * 10);
    }
    window.pz.setMinZoom(minZoom);
    window.pz.setMaxZoom(maxZoom);
}



let $06134f179bb411c5$var$pc = document.getElementById("pagesContainer");
let $06134f179bb411c5$var$r = document.querySelector(":root");
function $06134f179bb411c5$var$getPage(page_idx) {
    return document.getElementById("page" + page_idx);
}
function $06134f179bb411c5$var$isPageFirstOfPair(page_idx) {
    if (!(0, $480eb26aa317c74a$export$a5a6e0b888b2c992).doublePageView) return true;
    else {
        if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).hasCover) return page_idx === 0 || page_idx % 2 === 1;
        else return page_idx % 2 === 0;
    }
}
function $06134f179bb411c5$var$eInkRefresh() {
    $06134f179bb411c5$var$pc.classList.add("inverted");
    document.body.style.backgroundColor = "black";
    setTimeout(function() {
        $06134f179bb411c5$var$pc.classList.remove("inverted");
        document.body.style.backgroundColor = $06134f179bb411c5$var$r.style.getPropertyValue("--colorBackground");
    }, 300);
}
function $06134f179bb411c5$export$91e46f7d7a03a319(new_page_idx) {
    if (window.loadedVolume === null) return;
    if (new_page_idx === undefined) new_page_idx = (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx;
    new_page_idx = Math.min(Math.max(new_page_idx, 0), window.numPages - 1);
    $06134f179bb411c5$var$getPage((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx).style.display = "none";
    if ((0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx >= 0) $06134f179bb411c5$var$getPage((0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx).style.display = "none";
    if ($06134f179bb411c5$var$isPageFirstOfPair(new_page_idx)) (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx = new_page_idx;
    else (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx = new_page_idx - 1;
    $06134f179bb411c5$var$getPage((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx).style.display = "inline-block";
    $06134f179bb411c5$var$getPage((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx).style.order = 2;
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).doublePageView && (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx < window.numPages - 1 && !$06134f179bb411c5$var$isPageFirstOfPair((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx + 1)) {
        (0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx = (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx + 1;
        $06134f179bb411c5$var$getPage((0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx).style.display = "inline-block";
        if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l) $06134f179bb411c5$var$getPage((0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx).style.order = 1;
        else $06134f179bb411c5$var$getPage((0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx).style.order = 3;
    } else (0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx = -1;
    document.getElementById("pageIdxInput").value = (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx + 1;
    let page2_txt = (0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx >= 0 ? "," + ((0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx + 1) : "";
    document.getElementById("pageIdxDisplay").innerHTML = (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx + 1 + page2_txt + "/" + window.numPages;
    (0, $bb745140b5fd1d59$export$3105c960c5345d6d)(loadedVolume.id, Math.max((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx, (0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx) + 1, window.numPages);
    (0, $89727467ebfe0d15$export$e69cdf5edcfb1256)();
    (0, $89727467ebfe0d15$export$24b5fa69f2944279)();
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).eInkMode) $06134f179bb411c5$var$eInkRefresh();
}


let $e4d24202690ef467$var$pc = document.getElementById("pagesContainer");
let $e4d24202690ef467$var$r = document.querySelector(":root");
function $e4d24202690ef467$var$addSettingsToggle(parentElement, option, isVolume) {
    let div = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(parentElement, "div");
    div.classList.add("toggleOption");
    let values;
    let settings_key;
    if (isVolume) {
        values = [
            null,
            false,
            true
        ];
        settings_key = "volume";
    } else {
        values = [
            false,
            true
        ];
        settings_key = "global";
    }
    function listener() {
        let value;
        switch(this.value){
            case "false":
                value = false;
                break;
            case "true":
                value = true;
                break;
            default:
                value = null;
                break;
        }
        (0, $480eb26aa317c74a$export$a5a6e0b888b2c992)[settings_key][option.id] = value;
        $e4d24202690ef467$export$d6d42e8cf3bb7a8();
        (0, $06134f179bb411c5$export$91e46f7d7a03a319)();
    }
    for (let value of values){
        let input = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(div, "input");
        input.type = "radio";
        input.name = "settings_" + settings_key + "_" + option.id;
        input.id = input.name + "_" + value;
        input.value = value;
        if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992)[settings_key][option.id] === value) input.checked = true;
        input.addEventListener("change", listener, false);
        let labelText;
        switch(value){
            case false:
                labelText = "off";
                break;
            case true:
                labelText = "on";
                break;
            default:
                labelText = "default";
                break;
        }
        let label = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(div, "label", labelText);
        label.setAttribute("for", input.id);
    }
}
function $e4d24202690ef467$var$addSettingsSelect(parentElement, option, isVolume) {
    let div = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(parentElement, "div");
    div.classList.add("selectOption");
    let label = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(div, "label");
    let select = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(label, "select");
    let settingsGroup = isVolume ? "volume" : "global";
    if (isVolume) {
        let selectOption = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(select, "option", "default");
        selectOption.value = null;
    }
    for (let x of option.selectOptions){
        let selectOption = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(select, "option", x);
        selectOption.value = x;
    }
    select.value = (0, $480eb26aa317c74a$export$a5a6e0b888b2c992)[settingsGroup][option.id];
    select.addEventListener("change", (e)=>{
        let x = e.target.value;
        (0, $480eb26aa317c74a$export$a5a6e0b888b2c992)[settingsGroup][option.id] = x === "null" ? null : x;
        $e4d24202690ef467$export$d6d42e8cf3bb7a8();
        (0, $06134f179bb411c5$export$91e46f7d7a03a319)();
    });
}
function $e4d24202690ef467$var$addSettingsColor(parentElement, option, isVolume) {
    let div = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(parentElement, "div");
    div.classList.add("colorOption");
    let label = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(div, "label");
    let input = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(label, "input");
    input.type = "color";
    let settingsGroup = isVolume ? "volume" : "global";
    input.value = (0, $480eb26aa317c74a$export$a5a6e0b888b2c992)[settingsGroup][option.id];
    input.addEventListener("change", (e)=>{
        (0, $480eb26aa317c74a$export$a5a6e0b888b2c992)[settingsGroup][option.id] = e.target.value;
        $e4d24202690ef467$export$d6d42e8cf3bb7a8();
    });
}
function $e4d24202690ef467$var$addSettingsOption(parentElement, option, isVolume) {
    if (option.inputType === "toggle") $e4d24202690ef467$var$addSettingsToggle(parentElement, option, isVolume);
    else if (option.inputType === "select") $e4d24202690ef467$var$addSettingsSelect(parentElement, option, isVolume);
    else if (option.inputType === "color") $e4d24202690ef467$var$addSettingsColor(parentElement, option, isVolume);
}
function $e4d24202690ef467$var$addSettingsResetButton(parentElement, isVolume) {
    let div = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(parentElement, "div");
    div.classList.add("resetButton");
    let a = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(div, "a", "reset");
    a.href = "#";
    a.addEventListener("click", function() {
        if (isVolume) (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).resetVolume();
        else (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).resetGlobal();
        $e4d24202690ef467$export$b430ef56cf47809b();
        $e4d24202690ef467$export$d6d42e8cf3bb7a8();
        (0, $06134f179bb411c5$export$91e46f7d7a03a319)();
    }, false);
}
function $e4d24202690ef467$export$b430ef56cf47809b() {
    let settingsDisplay = document.getElementById("settingsDisplay");
    settingsDisplay.replaceChildren();
    let settingsTable = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(settingsDisplay, "table");
    let tr, td;
    tr = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(settingsTable, "tr");
    let left_col = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(tr, "th");
    left_col.classList.add("settingsLeftCol");
    let header = "default settings";
    if (window.loadedVolume !== null) header += " / settings for loaded volume";
    (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(tr, "th", header);
    for (let option of (0, $480eb26aa317c74a$export$41c562ebe57d11e2)){
        tr = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(settingsTable, "tr");
        let tdLabel = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(tr, "td", option.label);
        tdLabel.classList.add("alignright");
        td = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(tr, "td");
        $e4d24202690ef467$var$addSettingsOption(td, option, false);
        if (window.loadedVolume !== null) {
            if (!option.isGlobal) {
                let divider = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(td, "div", " / ");
                divider.classList.add("settingsDivider");
                $e4d24202690ef467$var$addSettingsOption(td, option, true);
            }
        }
    }
    tr = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(settingsTable, "tr");
    (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(tr, "td");
    td = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(tr, "td");
    $e4d24202690ef467$var$addSettingsResetButton(td, false);
    if (window.loadedVolume !== null) {
        let divider = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(td, "div", " / ");
        divider.classList.add("settingsDivider");
        $e4d24202690ef467$var$addSettingsResetButton(td, true);
    }
}
function $e4d24202690ef467$export$d6d42e8cf3bb7a8() {
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).textBoxBorders) $e4d24202690ef467$var$r.style.setProperty("--textBoxBorderHoverColor", "rgba(237, 28, 36, 0.3)");
    else $e4d24202690ef467$var$r.style.setProperty("--textBoxBorderHoverColor", "rgba(0, 0, 0, 0)");
    $e4d24202690ef467$var$pc.contentEditable = (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).editableText;
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).displayOCR) $e4d24202690ef467$var$r.style.setProperty("--textBoxDisplay", "initial");
    else $e4d24202690ef467$var$r.style.setProperty("--textBoxDisplay", "none");
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).fontSize === "auto") $e4d24202690ef467$var$pc.classList.remove("textBoxFontSizeOverride");
    else {
        $e4d24202690ef467$var$r.style.setProperty("--textBoxFontSize", (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).fontSize + "pt");
        $e4d24202690ef467$var$pc.classList.add("textBoxFontSizeOverride");
    }
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).eInkMode) document.getElementById("topMenu").classList.add("notransition");
    else document.getElementById("topMenu").classList.remove("notransition");
    $e4d24202690ef467$var$r.style.setProperty("--colorBackground", (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).backgroundColor);
}
function $e4d24202690ef467$export$d763c08db4890a86(settings_key, option_id, value) {
    if (settings_key === "volume" && window.loadedVolume === null) return;
    (0, $480eb26aa317c74a$export$a5a6e0b888b2c992)[settings_key][option_id] = value;
    $e4d24202690ef467$export$b430ef56cf47809b();
    $e4d24202690ef467$export$d6d42e8cf3bb7a8();
    (0, $06134f179bb411c5$export$91e46f7d7a03a319)();
}


let $1254bbba71b22eb7$var$popups = [];
function $1254bbba71b22eb7$export$c70811ece640d3a1(popupId, closeOthers = true) {
    if (closeOthers) $1254bbba71b22eb7$export$54303b0a281c5b45();
    else $1254bbba71b22eb7$var$popups = $1254bbba71b22eb7$var$popups.filter((x)=>x !== popupId);
    $1254bbba71b22eb7$var$popups.push(popupId);
    $1254bbba71b22eb7$export$348d584e223bdf1b(popupId);
}
function $1254bbba71b22eb7$export$e6889fb0929ccf91() {
    $1254bbba71b22eb7$var$popups.pop();
    if ($1254bbba71b22eb7$var$popups.length == 0) $1254bbba71b22eb7$export$c8744ab8d0e80f63();
    else $1254bbba71b22eb7$export$348d584e223bdf1b($1254bbba71b22eb7$var$popups.at(-1));
}
function $1254bbba71b22eb7$export$60212eb953f44d00(popupId) {
    if ($1254bbba71b22eb7$var$popups[$1254bbba71b22eb7$var$popups.length - 1] === popupId) $1254bbba71b22eb7$export$e6889fb0929ccf91();
    else $1254bbba71b22eb7$export$c70811ece640d3a1(popupId);
}
function $1254bbba71b22eb7$export$54303b0a281c5b45() {
    $1254bbba71b22eb7$var$popups = [];
    $1254bbba71b22eb7$export$c8744ab8d0e80f63();
}
function $1254bbba71b22eb7$export$348d584e223bdf1b(popupId) {
    $1254bbba71b22eb7$export$c8744ab8d0e80f63();
    document.getElementById(popupId).style.display = "block";
    document.getElementById("dimOverlay").style.display = "initial";
    window.pz.pause();
}
function $1254bbba71b22eb7$export$c8744ab8d0e80f63() {
    document.querySelectorAll(".popup").forEach(function(x) {
        x.style.display = "none";
    });
    document.getElementById("dimOverlay").style.display = "none";
    window.pz.resume();
}



let $592fe74d6221bed0$var$selectedBox = null;
function $592fe74d6221bed0$export$1146657848ae5582(textBox) {
    if (textBox !== $592fe74d6221bed0$var$selectedBox) {
        $592fe74d6221bed0$export$6456ab0d288ef170();
        textBox.classList.add("selected");
        $592fe74d6221bed0$var$selectedBox = textBox;
    }
}
function $592fe74d6221bed0$export$6456ab0d288ef170() {
    if ($592fe74d6221bed0$var$selectedBox !== null) $592fe74d6221bed0$var$selectedBox.classList.remove("selected");
    $592fe74d6221bed0$var$selectedBox = null;
}


let $d3be05650a2343a6$var$pc = document.getElementById("pagesContainer");
async function $d3be05650a2343a6$export$40a8bc4c5e0cfd05(id) {
    let volume;
    if (id !== null) {
        volume = window.catalog.volumes[id];
        if (!volume.isFullyStored()) return;
    }
    if (window.loadedVolume !== null) window.loadedVolume.clearURLs();
    $d3be05650a2343a6$var$pc.replaceChildren();
    if (id === null) {
        window.loadedVolume = null;
        (0, $ce3de23872348272$export$8e769ad4338a911e).loadedVolumeId = null;
        (0, $ce3de23872348272$export$7450780e9e8f7043).reset();
        (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).unloadVolume();
        (0, $f9dead489e99c245$export$6d6d0d6a78c06c7d)("No volume loaded");
    } else {
        let pages = volume.mokuroData.pages;
        window.numPages = pages.length;
        window.numPagesLoaded = 0;
        window.loadedVolume = volume;
        (0, $ce3de23872348272$export$8e769ad4338a911e).loadedVolumeId = volume.id;
        (0, $ce3de23872348272$export$7450780e9e8f7043).load(volume.id);
        (0, $ce3de23872348272$export$7450780e9e8f7043).lastOpened = Date.now();
        (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).loadVolume(volume.id);
        let promises = [];
        for(let pageIdx = (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx; pageIdx < window.numPages; pageIdx++)promises.push($d3be05650a2343a6$var$loadPage(volume, pageIdx));
        for(let pageIdx = 0; pageIdx < (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx; pageIdx++)promises.push($d3be05650a2343a6$var$loadPage(volume, pageIdx));
        await Promise.all(promises);
        (0, $f9dead489e99c245$export$6d6d0d6a78c06c7d)(volume.toString());
        (0, $f9dead489e99c245$export$3bef5616bc7fe5f1)(3000);
    }
    (0, $e4d24202690ef467$export$b430ef56cf47809b)();
    (0, $e4d24202690ef467$export$d6d42e8cf3bb7a8)();
}
async function $d3be05650a2343a6$var$loadPage(volume, pageIdx) {
    let pageJSON = volume.mokuroData.pages[pageIdx];
    let W = pageJSON.img_width;
    let H = pageJSON.img_height;
    let page = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)($d3be05650a2343a6$var$pc, "div");
    page.id = "page" + pageIdx;
    page.classList.add("page");
    let pageContainer = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(page, "div");
    pageContainer.classList.add("pageContainer");
    pageContainer.style.width = W;
    pageContainer.style.height = H;
    let imgURL = await volume.getImgURL(pageJSON.img_path);
    pageContainer.style.backgroundImage = 'url("' + imgURL + '")';
    let textBoxes = [];
    for (let blockJSON of pageJSON.blocks){
        let xmin, ymin, xmax, ymax, w, h;
        [xmin, ymin, xmax, ymax] = blockJSON.box;
        xmin = (0, $a6df9c40ba402dc9$export$e0b576e7a74416cd)(xmin, 0, W);
        ymin = (0, $a6df9c40ba402dc9$export$e0b576e7a74416cd)(ymin, 0, H);
        xmax = (0, $a6df9c40ba402dc9$export$e0b576e7a74416cd)(xmax, 0, W);
        ymax = (0, $a6df9c40ba402dc9$export$e0b576e7a74416cd)(ymax, 0, H);
        w = xmax - xmin;
        h = ymax - ymin;
        let area = w * h;
        let textBox = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(pageContainer, "div");
        textBox.classList.add("textBox");
        textBox.style.left = xmin;
        textBox.style.top = ymin;
        textBox.style.width = w;
        textBox.style.height = h;
        textBox.style.fontSize = blockJSON.font_size + "px";
        if (blockJSON.vertical) textBox.style.writingMode = "vertical-rl";
        for (let line of blockJSON.lines){
            let p = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(textBox, "p");
            p.appendChild(document.createTextNode(line));
        }
        textBox.addEventListener("click", function(e) {
            if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).toggleOCRTextBoxes || (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).editableText) (0, $592fe74d6221bed0$export$1146657848ae5582)(this);
        }, false);
        textBoxes.push({
            "textBox": textBox,
            "area": area
        });
    }
    // assign z-index ordering from largest to smallest boxes,
    // so that smaller boxes don't get hidden underneath larger ones
    textBoxes = (0, $a6df9c40ba402dc9$export$3bf4e72ed1d44710)(textBoxes, "area", false);
    for(let i = 0; i < textBoxes.length; i++)textBoxes[i].textBox.style.zIndex = 10 + i;
    window.numPagesLoaded += 1;
    (0, $f9dead489e99c245$export$6d6d0d6a78c06c7d)("Loading " + volume.toString() + " (" + window.numPagesLoaded + "/" + window.numPages + ")");
    (0, $f9dead489e99c245$export$3bef5616bc7fe5f1)(3000);
    if (pageIdx === (0, $ce3de23872348272$export$7450780e9e8f7043).page_idx) {
        (0, $06134f179bb411c5$export$91e46f7d7a03a319)();
        (0, $1254bbba71b22eb7$export$54303b0a281c5b45)();
    }
}




async function $bb745140b5fd1d59$var$deleteVolume(id) {
    let volume = window.catalog.volumes[id];
    let msg = 'Delete "' + volume.toString() + '"?\n\nThis will delete all data and reading progress associated with this volume from the browser storage.';
    if (confirm(msg)) {
        if (window.loadedVolume === volume) await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(null);
        await volume.delete();
        $bb745140b5fd1d59$export$598b47a92d61271();
    }
}
async function $bb745140b5fd1d59$var$deleteTitle(id) {
    let title = window.catalog.titles[id];
    let msg = 'Delete "' + title.name + '" containing ' + Object.keys(title.volumes).length + " volumes?\n\nThis will delete all data and reading progress associated with this title from the browser storage.";
    if (confirm(msg)) {
        if (window.loadedVolume !== null && window.loadedVolume.parentTitle === title) await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(null);
        await title.delete();
        $bb745140b5fd1d59$export$598b47a92d61271();
    }
}
function $bb745140b5fd1d59$export$598b47a92d61271() {
    let catalogDisplay = document.getElementById("catalogDisplay");
    catalogDisplay.replaceChildren();
    let titleList = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(catalogDisplay, "ul");
    let a;
    for (const title of window.catalog.getTitles()){
        if (title.id === "demo-title") continue;
        let titleListEl = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(titleList, "li");
        let titleItem = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(titleListEl, "span", title.name);
        titleItem.classList.add("catalogItem");
        a = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(titleItem, "a");
        a.classList.add("deleteCatalogItemButton");
        a.href = "#";
        a.addEventListener("click", async function() {
            await $bb745140b5fd1d59$var$deleteTitle(title.id);
        }, false);
        a.appendChild(document.createTextNode("x"));
        let volumeList = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(titleListEl, "ul");
        for (const volume of title.getVolumes()){
            let volumeListEl = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeList, "li");
            let volumeItem = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeListEl, "span");
            volumeItem.classList.add("catalogItem");
            if (volume.isFullyStored()) {
                a = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeItem, "a");
                a.href = "#";
                a.addEventListener("click", async function() {
                    await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(volume.id);
                }, false);
            } else a = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeItem, "span");
            a.appendChild(document.createTextNode(volume.name));
            let state = (0, $ce3de23872348272$export$7450780e9e8f7043).get(volume.id);
            let page_idx = Math.max(state.page_idx, state.page2_idx) + 1;
            let num_pages = volume.mokuroData.pages.length;
            let volumeStats = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeItem, "span", "(" + page_idx + "/" + num_pages + ")");
            volumeStats.id = "volumeStats" + volume.id;
            volumeStats.classList.add("volumeStats");
            let volumeStatus = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeItem, "span", volume.getStatusString());
            volumeStatus.id = "volumeStatus" + volume.id;
            volumeStatus.classList.add("volumeStatus");
            if (volume.url !== null) {
                let volumeUrl = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeItem, "a", "\u21AA");
                volumeUrl.classList.add("volumeUrl");
                volumeUrl.href = volume.url;
            }
            a = (0, $a6df9c40ba402dc9$export$f3bdc09b596b0e55)(volumeItem, "a");
            a.classList.add("deleteCatalogItemButton");
            a.href = "#";
            a.addEventListener("click", async function() {
                $bb745140b5fd1d59$var$deleteVolume(volume.id);
            }, false);
            a.appendChild(document.createTextNode("x"));
        }
    }
    let catalogStatus = document.getElementById("catalogStatus");
    if ("storage" in navigator && "estimate" in navigator.storage) navigator.storage.estimate().then(({ usage: usage, quota: quota })=>{
        catalogStatus.textContent = (0, $a6df9c40ba402dc9$export$e1a3971de07c83b5)(usage) + " / " + (0, $a6df9c40ba402dc9$export$e1a3971de07c83b5)(quota);
        if (usage > quota * 0.9 || quota - usage < 104857600) catalogStatus.classList.add("colorRed");
        else catalogStatus.classList.remove("colorRed");
    });
}
function $bb745140b5fd1d59$export$3105c960c5345d6d(volume_id, page_idx, num_pages) {
    let volumeStats = document.getElementById("volumeStats" + volume_id);
    if (volumeStats !== null) volumeStats.textContent = "(" + page_idx + "/" + num_pages + ")";
}
function $bb745140b5fd1d59$export$21b13eb913f4b5da(volume_id, text) {
    let volumeStatus = document.getElementById("volumeStatus" + volume_id);
    if (volumeStatus !== null) volumeStatus.textContent = text;
}
document.getElementById("resetCatalogButton").addEventListener("click", async function() {
    let msg = "Reset catalog?\n\nThis will delete all data and reading progress from the browser storage.";
    if (confirm(msg)) {
        await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(null);
        await (0, $816683f8c32a91e9$export$42ffd38884aecdac)();
        window.catalog = await (0, $4436b3cc3fc4de73$export$c401078f1496a453).load();
        $bb745140b5fd1d59$export$598b47a92d61271();
    }
}, false);





var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse('{"name":"mokuro","version":"0.1.0","dependencies":{"@codedread/bitjs":"^1.0.6","idb-keyval":"6.2.0","mime":"3.0.0","natsort":"^2.0.3","panzoom":"9.4.3"},"devDependencies":{"parcel":"^2.9.3","@parcel/config-default":"^2.9.3","@parcel/core":"^2.9.3","@parcel/service-worker":"^2.9.3","@parcel/transformer-inline-string":"^2.9.3","path-browserify":"^1.0.1","process":"^0.11.10","parcel-reporter-static-files-copy":"^1.5.0"},"alias":{"bitjs":"./lib/bitjs"},"staticFiles":{"staticPath":"./assets/demo","staticOutPath":"demo"}}');






function $95a7e585c928c714$export$224ec33f20c570b5() {
    (0, $06134f179bb411c5$export$91e46f7d7a03a319)(0);
}
function $95a7e585c928c714$export$ad257fef69e3ed2d() {
    (0, $06134f179bb411c5$export$91e46f7d7a03a319)(window.numPages - 1);
}
async function $95a7e585c928c714$export$c69f739c940da70d() {
    if ((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx === 0) {
        if (await $95a7e585c928c714$export$778ef8f8579bc876()) $95a7e585c928c714$export$ad257fef69e3ed2d();
    } else (0, $06134f179bb411c5$export$91e46f7d7a03a319)((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx - ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).doublePageView ? 2 : 1));
}
async function $95a7e585c928c714$export$4765883fd82fa203() {
    if (Math.max((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx, (0, $ce3de23872348272$export$7450780e9e8f7043).page2_idx) === window.numPages - 1) {
        if (await $95a7e585c928c714$export$6d653e802891af64()) $95a7e585c928c714$export$224ec33f20c570b5();
    } else (0, $06134f179bb411c5$export$91e46f7d7a03a319)((0, $ce3de23872348272$export$7450780e9e8f7043).page_idx + ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).doublePageView ? 2 : 1));
}
function $95a7e585c928c714$export$3aab30ada6ab6b9f() {
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l) $95a7e585c928c714$export$ad257fef69e3ed2d();
    else $95a7e585c928c714$export$224ec33f20c570b5();
}
async function $95a7e585c928c714$export$71c8c73475fc8f30() {
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l) await $95a7e585c928c714$export$4765883fd82fa203();
    else await $95a7e585c928c714$export$c69f739c940da70d();
}
async function $95a7e585c928c714$export$10aad5272b594441() {
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l) await $95a7e585c928c714$export$c69f739c940da70d();
    else await $95a7e585c928c714$export$4765883fd82fa203();
}
function $95a7e585c928c714$export$93eb63dc599163d6() {
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l) $95a7e585c928c714$export$224ec33f20c570b5();
    else $95a7e585c928c714$export$ad257fef69e3ed2d();
}
async function $95a7e585c928c714$export$778ef8f8579bc876() {
    if (window.loadedVolume !== null) {
        let volumes = window.loadedVolume.parentTitle.getVolumes();
        let i = volumes.indexOf(window.loadedVolume);
        if (i > 0) {
            await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(volumes[i - 1].id);
            return true;
        }
        return false;
    }
}
async function $95a7e585c928c714$export$6d653e802891af64() {
    if (window.loadedVolume !== null) {
        let volumes = window.loadedVolume.parentTitle.getVolumes();
        let i = volumes.indexOf(window.loadedVolume);
        if (i < volumes.length - 1) {
            await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(volumes[i + 1].id);
            return true;
        }
        return false;
    }
}
async function $95a7e585c928c714$export$e84f2743569f1488() {
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l) await $95a7e585c928c714$export$6d653e802891af64();
    else await $95a7e585c928c714$export$778ef8f8579bc876();
}
async function $95a7e585c928c714$export$3c5caec86028df0d() {
    if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l) await $95a7e585c928c714$export$778ef8f8579bc876();
    else await $95a7e585c928c714$export$6d653e802891af64();
}





/**
 * decompress.js
 *
 * Provides base functionality for unarchiving/decompression.
 *
 * Licensed under the MIT License
 *
 * Copyright(c) 2021 Google Inc.
 *
 */ /**
 * decompress-internal.js
 *
 * Provides base functionality for unarchiving, extracted here as an internal
 * module for unit testing. Import decompress.js instead.
 *
 * Licensed under the MIT License
 *
 * Copyright(c) 2021 Google Inc.
 */ /**
 * File Sniffer.
 * Makes an attempt to resolve a byte stream into a MIME type.
 *
 * Licensed under the MIT License
 *
 * Copyright(c) 2020 Google Inc.
 */ // A selection from https://en.wikipedia.org/wiki/List_of_file_signatures.
// Mapping of MIME type to magic numbers.  Each file type can have multiple signatures.
// '??' is used as a placeholder value.
const $a4dd509a6ed022ef$var$fileSignatures = {
    // Document formats.
    "application/pdf": [
        [
            0x25,
            0x50,
            0x44,
            0x46,
            0x2d
        ]
    ],
    // Archive formats:
    "application/x-tar": [
        [
            0x75,
            0x73,
            0x74,
            0x61,
            0x72,
            0x00,
            0x30,
            0x30
        ],
        [
            0x75,
            0x73,
            0x74,
            0x61,
            0x72,
            0x20,
            0x20,
            0x00
        ]
    ],
    // Compressed archive formats.
    "application/x-7z-compressed": [
        [
            0x37,
            0x7A,
            0xBC,
            0xAF,
            0x27,
            0x1C
        ]
    ],
    "application/x-bzip2": [
        [
            0x42,
            0x5A,
            0x68
        ]
    ],
    "application/x-rar-compressed": [
        [
            0x52,
            0x61,
            0x72,
            0x21,
            0x1A,
            0x07
        ]
    ],
    "application/zip": [
        [
            0x50,
            0x4B,
            0x03,
            0x04
        ],
        [
            0x50,
            0x4B,
            0x05,
            0x06
        ],
        [
            0x50,
            0x4B,
            0x07,
            0x08
        ]
    ],
    // Image formats.
    "image/bmp": [
        [
            0x42,
            0x4D
        ]
    ],
    "image/gif": [
        [
            0x47,
            0x49,
            0x46,
            0x38
        ]
    ],
    "image/jpeg": [
        [
            0xFF,
            0xD8,
            0xFF
        ]
    ],
    "image/png": [
        [
            0x89,
            0x50,
            0x4E,
            0x47,
            0x0D,
            0x0A,
            0x1A,
            0x0A
        ]
    ],
    "image/webp": [
        [
            0x52,
            0x49,
            0x46,
            0x46,
            "??",
            "??",
            "??",
            "??",
            0x57,
            0x45,
            0x42,
            0x50
        ]
    ],
    // Audio/Video formats.
    "application/ogg": [
        [
            0x4F,
            0x67,
            0x67,
            0x53
        ]
    ],
    "audio/mpeg": [
        [
            0xFF,
            0xFB
        ],
        [
            0xFF,
            0xF3
        ],
        [
            0xFF,
            0xF2
        ],
        [
            0x49,
            0x44,
            0x33
        ]
    ]
};
// TODO: Eventually add support for various container formats so that:
//   * an OGG container can be resolved to OGG Audio, OGG Video
//   * an HEIF container can be resolved to AVIF, HEIC
/**
 * Represents a single byte in the tree. If this node terminates a known MIME type (see magic
 * numbers above), then the mimeType field will be set.
 */ class $a4dd509a6ed022ef$var$Node {
    /** @type {string} */ mimeType;
    /** @type {Object<number, Node>} */ children = {};
    /** @param {number} value The byte that this Node points at. */ constructor(value){
        /** @type {number} */ this.value = value;
    }
}
/** Top-level node in the byte tree. */ let $a4dd509a6ed022ef$var$root = null;
/** The maximum depth of the byte tree. */ let $a4dd509a6ed022ef$var$maxDepth = 0;
function $a4dd509a6ed022ef$export$2a47f398eeff8b01() {
    $a4dd509a6ed022ef$var$root = new $a4dd509a6ed022ef$var$Node();
    // Construct the tree, erroring if overlapping mime types are possible.
    for(const mimeType in $a4dd509a6ed022ef$var$fileSignatures)for (const signature of $a4dd509a6ed022ef$var$fileSignatures[mimeType]){
        let curNode = $a4dd509a6ed022ef$var$root;
        let depth = 0;
        for (const byte of signature){
            if (curNode.children[byte] === undefined) {
                if (byte === "??" && !curNode.children["??"] && Object.keys(curNode.children).length > 0) throw "Cannot add a placeholder child to a node that has non-placeholder children";
                else if (byte !== "??" && curNode.children["??"]) throw "Cannot add a non-placeholder child to a node that has a placeholder child";
                curNode.children[byte] = new $a4dd509a6ed022ef$var$Node(byte);
            }
            depth++;
            curNode = curNode.children[byte];
        } // for each byte
        if ($a4dd509a6ed022ef$var$maxDepth < depth) $a4dd509a6ed022ef$var$maxDepth = depth;
        if (curNode.mimeType) throw `File signature collision:  ${curNode.mimeType} overlaps with ${mimeType}`;
        else if (Object.keys(curNode.children).length > 0) throw `${mimeType} signature is not unique, it collides with other mime types`;
        curNode.mimeType = mimeType;
    } // for each signature
}
function $a4dd509a6ed022ef$export$ed8d55a30951f390(ab) {
    if (!$a4dd509a6ed022ef$var$root) $a4dd509a6ed022ef$export$2a47f398eeff8b01();
    const depth = ab.byteLength < $a4dd509a6ed022ef$var$maxDepth ? ab.byteLength : $a4dd509a6ed022ef$var$maxDepth;
    const arr = new Uint8Array(ab).subarray(0, depth);
    let curNode = $a4dd509a6ed022ef$var$root;
    // Step through bytes, updating curNode as it walks down the byte tree.
    for (const byte of arr){
        // If this node has a placeholder child, just step into it.
        if (curNode.children["??"]) {
            curNode = curNode.children["??"];
            continue;
        }
        if (curNode.children[byte] === undefined) return undefined;
        curNode = curNode.children[byte];
        if (curNode.mimeType) return curNode.mimeType;
    }
}


const $1f4db8755861f0ed$export$e70ee7b71b25ee39 = {
    START: "start",
    APPEND: "append",
    PROGRESS: "progress",
    EXTRACT: "extract",
    FINISH: "finish",
    INFO: "info",
    ERROR: "error"
};
class $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    /**
   * @param {string} type The event type.
   */ constructor(type){
        /**
     * The event type.
     * @type {string}
     */ this.type = type;
    }
}
class $1f4db8755861f0ed$export$875e2fbd66ede5df extends $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    /**
   * @param {number} numBytes The number of bytes appended.
   */ constructor(numBytes){
        super($1f4db8755861f0ed$export$e70ee7b71b25ee39.APPEND);
        /**
     * The number of appended bytes.
     * @type {number}
     */ this.numBytes = numBytes;
    }
}
class $1f4db8755861f0ed$export$c8d01a73aac54cf4 extends $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    /**
   * @param {string} msg The info message.
   */ constructor(msg){
        super($1f4db8755861f0ed$export$e70ee7b71b25ee39.INFO);
        /**
     * The information message.
     * @type {string}
     */ this.msg = msg;
    }
}
class $1f4db8755861f0ed$export$f040bb2261abdc01 extends $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    /**
   * @param {string} msg The error message.
   */ constructor(msg){
        super($1f4db8755861f0ed$export$e70ee7b71b25ee39.ERROR);
        /**
     * The information message.
     * @type {string}
     */ this.msg = msg;
    }
}
class $1f4db8755861f0ed$export$e5338970c7bec5bc extends $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    constructor(){
        super($1f4db8755861f0ed$export$e70ee7b71b25ee39.START);
    }
}
class $1f4db8755861f0ed$export$1da7aac29b7ccdcc extends $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    /**
   * @param {Object} metadata A collection fo metadata about the archive file.
   */ constructor(metadata = {}){
        super($1f4db8755861f0ed$export$e70ee7b71b25ee39.FINISH);
        this.metadata = metadata;
    }
}
class $1f4db8755861f0ed$export$78c46974fc9b55e3 extends $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    /**
   * @param {string} currentFilename
   * @param {number} currentFileNumber
   * @param {number} currentBytesUnarchivedInFile
   * @param {number} currentBytesUnarchived
   * @param {number} totalUncompressedBytesInArchive
   * @param {number} totalFilesInArchive
   * @param {number} totalCompressedBytesRead
   */ constructor(currentFilename, currentFileNumber, currentBytesUnarchivedInFile, currentBytesUnarchived, totalUncompressedBytesInArchive, totalFilesInArchive, totalCompressedBytesRead){
        super($1f4db8755861f0ed$export$e70ee7b71b25ee39.PROGRESS);
        this.currentFilename = currentFilename;
        this.currentFileNumber = currentFileNumber;
        this.currentBytesUnarchivedInFile = currentBytesUnarchivedInFile;
        this.totalFilesInArchive = totalFilesInArchive;
        this.currentBytesUnarchived = currentBytesUnarchived;
        this.totalUncompressedBytesInArchive = totalUncompressedBytesInArchive;
        this.totalCompressedBytesRead = totalCompressedBytesRead;
    }
}
class $1f4db8755861f0ed$export$4ae46f700087fadf extends $1f4db8755861f0ed$export$a2dedeeab170f9cf {
    /**
   * @param {UnarchivedFile} unarchivedFile
   */ constructor(unarchivedFile){
        super($1f4db8755861f0ed$export$e70ee7b71b25ee39.EXTRACT);
        /**
     * @type {UnarchivedFile}
     */ this.unarchivedFile = unarchivedFile;
    }
}
class $1f4db8755861f0ed$export$75079721eca36b50 {
    /**
   * @param {ArrayBuffer} arrayBuffer The Array Buffer. Note that this ArrayBuffer must not be
   *     referenced once it is sent to the Unarchiver, since it is marked as Transferable and sent
   *     to the Worker.
   * @param {Function(string):Worker} createWorkerFn A function that creates a Worker from a script file.
   * @param {Object|string} options An optional object of options, or a string representing where
   *     the BitJS files are located.  The string version of this argument is deprecated.
   *     Available options:
   *       'pathToBitJS': A string indicating where the BitJS files are located.
   *       'debug': A boolean where true indicates that the archivers should log debug output.
   */ constructor(arrayBuffer, createWorkerFn, options = {}){
        if (typeof options === "string") {
            console.warn(`Deprecated: Don't send a raw string to Unarchiver()`);
            console.warn(`            send {'pathToBitJS':'${options}'} instead`);
            options = {
                "pathToBitJS": options
            };
        }
        /**
     * The ArrayBuffer object.
     * @type {ArrayBuffer}
     * @protected
     */ this.ab = arrayBuffer;
        /**
     * A factory method that creates a Worker that does the unarchive work.
     * @type {Function(string): Worker}
     * @private
     */ this.createWorkerFn_ = createWorkerFn;
        /**
     * The path to the BitJS files.
     * @type {string}
     * @private
     */ this.pathToBitJS_ = options.pathToBitJS || "/";
        /**
     * @orivate
     * @type {boolean}
     */ this.debugMode_ = !!options.debug;
        /**
     * A map from event type to an array of listeners.
     * @private
     * @type {Map.<string, Array>}
     */ this.listeners_ = {};
        for(let type in $1f4db8755861f0ed$export$e70ee7b71b25ee39)this.listeners_[$1f4db8755861f0ed$export$e70ee7b71b25ee39[type]] = [];
        /**
     * Private web worker initialized during start().
     * @private
     * @type {Worker}
     */ this.worker_ = null;
    }
    /**
   * This method must be overridden by the subclass to return the script filename.
   * @returns {string} The MIME type of the archive.
   * @protected.
   */ getMIMEType() {
        throw "Subclasses of Unarchiver must overload getMIMEType()";
    }
    /**
   * This method must be overridden by the subclass to return the script filename.
   * @returns {string} The script filename.
   * @protected.
   */ getScriptFileName() {
        throw "Subclasses of Unarchiver must overload getScriptFileName()";
    }
    /**
   * Adds an event listener for UnarchiveEvents.
   *
   * @param {string} Event type.
   * @param {function} An event handler function.
   */ addEventListener(type, listener) {
        if (type in this.listeners_) {
            if (this.listeners_[type].indexOf(listener) == -1) this.listeners_[type].push(listener);
        }
    }
    /**
   * Removes an event listener.
   *
   * @param {string} Event type.
   * @param {EventListener|function} An event listener or handler function.
   */ removeEventListener(type, listener) {
        if (type in this.listeners_) {
            const index = this.listeners_[type].indexOf(listener);
            if (index != -1) this.listeners_[type].splice(index, 1);
        }
    }
    /**
   * Create an UnarchiveEvent out of the object sent back from the Worker.
   * @param {Object} obj
   * @returns {UnarchiveEvent}
   * @private
   */ createUnarchiveEvent_(obj) {
        switch(obj.type){
            case $1f4db8755861f0ed$export$e70ee7b71b25ee39.START:
                return new $1f4db8755861f0ed$export$e5338970c7bec5bc();
            case $1f4db8755861f0ed$export$e70ee7b71b25ee39.PROGRESS:
                return new $1f4db8755861f0ed$export$78c46974fc9b55e3(obj.currentFilename, obj.currentFileNumber, obj.currentBytesUnarchivedInFile, obj.currentBytesUnarchived, obj.totalUncompressedBytesInArchive, obj.totalFilesInArchive, obj.totalCompressedBytesRead);
            case $1f4db8755861f0ed$export$e70ee7b71b25ee39.EXTRACT:
                return new $1f4db8755861f0ed$export$4ae46f700087fadf(obj.unarchivedFile);
            case $1f4db8755861f0ed$export$e70ee7b71b25ee39.FINISH:
                return new $1f4db8755861f0ed$export$1da7aac29b7ccdcc(obj.metadata);
            case $1f4db8755861f0ed$export$e70ee7b71b25ee39.INFO:
                return new $1f4db8755861f0ed$export$c8d01a73aac54cf4(obj.msg);
            case $1f4db8755861f0ed$export$e70ee7b71b25ee39.ERROR:
                return new $1f4db8755861f0ed$export$f040bb2261abdc01(obj.msg);
        }
    }
    /**
   * Receive an event and pass it to the listener functions.
   *
   * @param {Object} obj
   * @private
   */ handleWorkerEvent_(obj) {
        const type = obj.type;
        if (type && Object.values($1f4db8755861f0ed$export$e70ee7b71b25ee39).includes(type) && this.listeners_[obj.type] instanceof Array) {
            const evt = this.createUnarchiveEvent_(obj);
            this.listeners_[evt.type].forEach(function(listener) {
                listener(evt);
            });
            if (evt.type == $1f4db8755861f0ed$export$e70ee7b71b25ee39.FINISH) this.worker_.terminate();
        } else console.log(`Unknown object received from worker: ${obj}`);
    }
    /**
   * Starts the unarchive in a separate Web Worker thread and returns immediately.
   */ start() {
        const me = this;
        const scriptFileName = this.pathToBitJS_ + this.getScriptFileName();
        if (scriptFileName) {
            this.worker_ = this.createWorkerFn_(scriptFileName);
            this.worker_.onerror = function(e) {
                console.log("Worker error: message = " + e.message);
                throw e;
            };
            this.worker_.onmessage = function(e) {
                if (typeof e.data == "string") // Just log any strings the workers pump our way.
                console.log(e.data);
                else me.handleWorkerEvent_(e.data);
            };
            const ab = this.ab;
            this.worker_.postMessage({
                file: ab,
                logToConsole: this.debugMode_
            }, [
                ab
            ]);
            this.ab = null;
        }
    }
    // TODO: Create a startSync() method that does not use a worker for Node.
    /**
   * Adds more bytes to the unarchiver's Worker thread.
   * @param {ArrayBuffer} ab The ArrayBuffer with more bytes in it. If opt_transferable is
   *     set to true, this ArrayBuffer must not be referenced after calling update(), since it
   *     is marked as Transferable and sent to the Worker.
   * @param {boolean=} opt_transferable Optional boolean whether to mark this ArrayBuffer
   *     as a Tranferable object, which means it can no longer be referenced outside of
   *     the Worker thread.
   */ update(ab, opt_transferable = false) {
        const numBytes = ab.byteLength;
        if (this.worker_) {
            // Send the ArrayBuffer over, and mark it as a Transferable object if necessary.
            if (opt_transferable) this.worker_.postMessage({
                bytes: ab
            }, [
                ab
            ]);
            else this.worker_.postMessage({
                bytes: ab
            });
        }
        if (this.listeners_[$1f4db8755861f0ed$export$e70ee7b71b25ee39.APPEND]) {
            const evt = new $1f4db8755861f0ed$export$875e2fbd66ede5df(numBytes);
            this.listeners_[$1f4db8755861f0ed$export$e70ee7b71b25ee39.APPEND].forEach((listener)=>listener(evt));
        }
    }
    /**
   * Terminates the Web Worker for this Unarchiver and returns immediately.
   */ stop() {
        if (this.worker_) this.worker_.terminate();
    }
}
class $1f4db8755861f0ed$export$7a5ca1db5f8eebbc extends $1f4db8755861f0ed$export$75079721eca36b50 {
    constructor(arrayBuffer, createWorkerFn, options){
        super(arrayBuffer, createWorkerFn, options);
    }
    getMIMEType() {
        return "application/zip";
    }
    getScriptFileName() {
        return "archive/unzip.js";
    }
}
class $1f4db8755861f0ed$export$ba03ce19133397b3 extends $1f4db8755861f0ed$export$75079721eca36b50 {
    constructor(arrayBuffer, createWorkerFn, options){
        super(arrayBuffer, createWorkerFn, options);
    }
    getMIMEType() {
        return "application/x-rar-compressed";
    }
    getScriptFileName() {
        return "archive/unrar.js";
    }
}
class $1f4db8755861f0ed$export$1d74a15665e1f33b extends $1f4db8755861f0ed$export$75079721eca36b50 {
    constructor(arrayBuffer, createWorkerFn, options){
        super(arrayBuffer, createWorkerFn, options);
    }
    getMIMEType() {
        return "application/x-tar";
    }
    getScriptFileName() {
        return "archive/untar.js";
    }
}
function $1f4db8755861f0ed$export$461a4c995bf4f7ae(ab, createWorkerFn, options = {}) {
    if (ab.byteLength < 10) return null;
    let unarchiver = null;
    const mimeType = (0, $a4dd509a6ed022ef$export$ed8d55a30951f390)(ab);
    if (mimeType === "application/x-rar-compressed") unarchiver = new $1f4db8755861f0ed$export$ba03ce19133397b3(ab, createWorkerFn, options);
    else if (mimeType === "application/zip") unarchiver = new $1f4db8755861f0ed$export$7a5ca1db5f8eebbc(ab, createWorkerFn, options);
    else unarchiver = new $1f4db8755861f0ed$export$1d74a15665e1f33b(ab, createWorkerFn, options);
    return unarchiver;
}


var $153e6ba491d461cd$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $153e6ba491d461cd$var$url = new URL("unzip.3c697876.js", import.meta.url);
$153e6ba491d461cd$exports = $56b621a6dd25b2cb$exports($153e6ba491d461cd$var$url.toString(), $153e6ba491d461cd$var$url.origin, true);


/**
* All extracted files returned by an Unarchiver will implement
* the following interface:
*/ /**
 * @typedef UnarchivedFile
 * @property {string} filename
 * @property {Uint8Array} fileData
 */ /**
* The goal is to make this testable - send getUnarchiver() an array buffer of
* an archive, call start on the unarchiver, expect the returned result.
*
* Problem: It relies on Web Workers, and that won't work in a nodejs context.
* Solution: Make archive.js very thin, have it feed web-specific things into
*           an internal module that is isomorphic JavaScript.
*
* TODO:
* - write unit tests for archive-internal.js that use the nodejs Worker
*   equivalent.
* - maybe use @pgriess/node-webworker or @audreyt/node-webworker-threads or
*   just node's worker_threads ?
*/ const $74e6804c14a91db6$var$createWorkerFn = (scriptFilename)=>new Worker($153e6ba491d461cd$exports);
class $74e6804c14a91db6$export$b0c3d2e070472b31 extends (0, $1f4db8755861f0ed$export$7a5ca1db5f8eebbc) {
    constructor(ab, options){
        super(ab, $74e6804c14a91db6$var$createWorkerFn, options);
    }
}
class $74e6804c14a91db6$export$bb5e76b5037e7e07 extends (0, $1f4db8755861f0ed$export$ba03ce19133397b3) {
    constructor(ab, options){
        super(ab, $74e6804c14a91db6$var$createWorkerFn, options);
    }
}
class $74e6804c14a91db6$export$e09116b8e82f1e0e extends (0, $1f4db8755861f0ed$export$1d74a15665e1f33b) {
    constructor(ab, options){
        super(ab, $74e6804c14a91db6$var$createWorkerFn, options);
    }
}
function $74e6804c14a91db6$export$779d6e3e52e4743(ab, options = {}) {
    return (0, $1f4db8755861f0ed$export$461a4c995bf4f7ae)(ab, $74e6804c14a91db6$var$createWorkerFn, options);
}


var $a65ba90ada98487d$exports = {};
"use strict";
var $3457c470d238f95b$exports = {};
"use strict";
/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */ function $3457c470d238f95b$var$Mime() {
    this._types = Object.create(null);
    this._extensions = Object.create(null);
    for(let i = 0; i < arguments.length; i++)this.define(arguments[i]);
    this.define = this.define.bind(this);
    this.getType = this.getType.bind(this);
    this.getExtension = this.getExtension.bind(this);
}
/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */ $3457c470d238f95b$var$Mime.prototype.define = function(typeMap, force) {
    for(let type in typeMap){
        let extensions = typeMap[type].map(function(t) {
            return t.toLowerCase();
        });
        type = type.toLowerCase();
        for(let i = 0; i < extensions.length; i++){
            const ext = extensions[i];
            // '*' prefix = not the preferred type for this extension.  So fixup the
            // extension, and skip it.
            if (ext[0] === "*") continue;
            if (!force && ext in this._types) throw new Error('Attempt to change mapping for "' + ext + '" extension from "' + this._types[ext] + '" to "' + type + '". Pass `force=true` to allow this, otherwise remove "' + ext + '" from the list of extensions for "' + type + '".');
            this._types[ext] = type;
        }
        // Use first extension as default
        if (force || !this._extensions[type]) {
            const ext = extensions[0];
            this._extensions[type] = ext[0] !== "*" ? ext : ext.substr(1);
        }
    }
};
/**
 * Lookup a mime type based on extension
 */ $3457c470d238f95b$var$Mime.prototype.getType = function(path) {
    path = String(path);
    let last = path.replace(/^.*[/\\]/, "").toLowerCase();
    let ext = last.replace(/^.*\./, "").toLowerCase();
    let hasPath = last.length < path.length;
    let hasDot = ext.length < last.length - 1;
    return (hasDot || !hasPath) && this._types[ext] || null;
};
/**
 * Return file extension associated with a mime type
 */ $3457c470d238f95b$var$Mime.prototype.getExtension = function(type) {
    type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
    return type && this._extensions[type.toLowerCase()] || null;
};
$3457c470d238f95b$exports = $3457c470d238f95b$var$Mime;




$a65ba90ada98487d$exports = new $3457c470d238f95b$exports((parcelRequire("2XWkz")), (parcelRequire("lMmGq")));


var $3bfdb7183e8721d6$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $cfae44f0dfdf62c0$exports.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
$3bfdb7183e8721d6$exports = $3bfdb7183e8721d6$var$posix;




async function $bbee3159e52f04ae$export$dc1b7b81641b4e07(mokuro_url) {
    if (!mokuro_url.endsWith(".mokuro")) return;
    let volume_url = mokuro_url.slice(0, -7);
    let volumeName = decodeURI(volume_url.slice(volume_url.lastIndexOf("/") + 1) || volume_url);
    let response = await fetch(mokuro_url);
    let mokuroData = await response.json();
    let title = await window.catalog.addTitleIfNotExists(mokuroData.title, mokuroData.title_uuid);
    let volume = await title.addVolumeIfNotExists(mokuroData, volumeName, mokuroData.volume_uuid, encodeURI(volume_url));
    await window.catalog.save();
    (0, $bb745140b5fd1d59$export$598b47a92d61271)();
}
async function $bbee3159e52f04ae$export$54e434bdcdaa168a(url) {
    if (!url) return;
    if (url.endsWith(".mokuro")) {
        await $bbee3159e52f04ae$export$dc1b7b81641b4e07(decodeURI(url));
        return;
    }
    let fileUrls = await $bbee3159e52f04ae$var$scanUrlDir(url, "mokuro");
    await Promise.all(fileUrls.map($bbee3159e52f04ae$export$dc1b7b81641b4e07));
}
async function $bbee3159e52f04ae$var$scanUrlDir(url, extension) {
    let fileUrls = [];
    const response = await fetch(url);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const links = Array.from(doc.querySelectorAll("a"));
    for (let link of links){
        const href = link.getAttribute("href");
        const absoluteUrl = new URL(href, url).href;
        if (href.endsWith(`.${extension}`)) fileUrls.push(absoluteUrl);
    }
    return fileUrls;
}


let $e4517613231d656d$var$dropArea = document.getElementById("popupCatalog");
[
    "drag",
    "dragstart",
    "dragend",
    "dragover",
    "dragenter",
    "dragleave",
    "drop"
].forEach(function(type) {
    $e4517613231d656d$var$dropArea.addEventListener(type, function(e) {
        e.stopPropagation();
        e.preventDefault();
    }, false);
});
[
    "dragover",
    "dragenter"
].forEach(function(type) {
    $e4517613231d656d$var$dropArea.addEventListener(type, function(e) {
        $e4517613231d656d$var$dropArea.classList.add("isDragover");
    }, false);
});
[
    "dragleave",
    "dragend",
    "drop"
].forEach(function(type) {
    $e4517613231d656d$var$dropArea.addEventListener(type, function(e) {
        $e4517613231d656d$var$dropArea.classList.remove("isDragover");
    }, false);
});
$e4517613231d656d$var$dropArea.addEventListener("drop", async function(e) {
    const dt = e.dataTransfer;
    let text = e.dataTransfer.getData("text/plain");
    if (text) await (0, $bbee3159e52f04ae$export$54e434bdcdaa168a)(text);
    let filePromises = [];
    for (const item of dt.items)if (item.kind === "file") {
        let entry = item.webkitGetAsEntry();
        if (entry.isDirectory) filePromises.push($e4517613231d656d$var$scanFiles(entry));
        else filePromises.push(item.getAsFile());
    }
    let files = await Promise.all(filePromises).then((fileArrays)=>{
        return [].concat(...fileArrays);
    });
    await $e4517613231d656d$var$processFiles(files);
}, false);
function $e4517613231d656d$var$readAllEntries(directoryReader) {
    return new Promise((resolve, reject)=>{
        let entries = [];
        function readEntries() {
            directoryReader.readEntries((batch)=>{
                if (batch.length) {
                    entries = entries.concat(batch);
                    readEntries();
                } else resolve(entries);
            }, reject);
        }
        readEntries();
    });
}
function $e4517613231d656d$var$scanFiles(directoryEntry, path = directoryEntry.name) {
    return new Promise((resolve, reject)=>{
        let reader = directoryEntry.createReader();
        $e4517613231d656d$var$readAllEntries(reader).then((entries)=>{
            let filePromises = entries.map((entry)=>{
                let fullPath = path + "/" + entry.name;
                if (entry.isDirectory) return $e4517613231d656d$var$scanFiles(entry, fullPath);
                else return new Promise((resolve, reject)=>{
                    entry.file((file)=>{
                        file.fullPath = fullPath;
                        resolve(file);
                    }, reject);
                });
            });
            Promise.all(filePromises).then((fileArrays)=>{
                let files = [].concat(...fileArrays);
                resolve(files);
            }).catch(reject);
        }).catch(reject);
    });
}
async function $e4517613231d656d$export$452a1d4fe3be249() {
    let text = prompt("Enter URL to import:");
    await (0, $bbee3159e52f04ae$export$54e434bdcdaa168a)(text);
}
document.getElementById("uploadFile").addEventListener("change", async function() {
    await $e4517613231d656d$var$processFiles(this.files);
}, false);
document.getElementById("uploadDirectory").addEventListener("change", async function() {
    await $e4517613231d656d$var$processFiles(this.files);
}, false);
document.getElementById("uploadHelpButton").addEventListener("click", function() {
    (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupUploadHelp", false);
}, false);
function $e4517613231d656d$var$parsePath(file) {
    let filepath;
    if ("fullPath" in file) filepath = file.fullPath;
    else if ("webkitRelativePath" in file && file.webkitRelativePath) filepath = file.webkitRelativePath.replace("\\", "/");
    else if ("path_components" in file) filepath = file.path_components.replace("\\", "/");
    else filepath = file.name;
    let parsed_path = $3bfdb7183e8721d6$exports.parse(filepath);
    parsed_path.filepath = filepath;
    parsed_path.ext = parsed_path.ext.toLowerCase();
    parsed_path.path_no_ext = $3bfdb7183e8721d6$exports.join(parsed_path.dir, parsed_path.name).replace("\\", "/");
    parsed_path.mime = (0, (/*@__PURE__*/$parcel$interopDefault($a65ba90ada98487d$exports))).getType(filepath);
    return parsed_path;
}
async function $e4517613231d656d$var$processFiles(files) {
    let volumes_to_process = {};
    for (let file of files){
        let parsed_path = $e4517613231d656d$var$parsePath(file);
        if (parsed_path.ext === ".mokuro") {
            let mokuroData = await (0, $a6df9c40ba402dc9$export$ce30717759bc230c)(file);
            if (mokuroData.volume_uuid in catalog.volumes) {
                console.log("Skipping already loaded volume " + parsed_path.filepath);
                continue;
            }
            volumes_to_process[parsed_path.path_no_ext] = {
                mokuroData: mokuroData,
                volumeName: parsed_path.name,
                archiveFile: null,
                files: {}
            };
        }
    }
    for (let file of files){
        let parsed_path = $e4517613231d656d$var$parsePath(file);
        if (parsed_path.mime === "image/jpeg" || parsed_path.mime === "image/png") {
            for (const k of Object.keys(volumes_to_process))if (parsed_path.filepath.startsWith(k + "/")) volumes_to_process[k].files[$3bfdb7183e8721d6$exports.relative(k, parsed_path.filepath)] = file;
        } else if (parsed_path.ext === ".zip" || parsed_path.ext === ".cbz") {
            if (parsed_path.path_no_ext in volumes_to_process) volumes_to_process[parsed_path.path_no_ext].archiveFile = file;
        }
    }
    if (Object.keys(volumes_to_process).length > 0) await (0, $a6df9c40ba402dc9$export$f565b71ad023b7df)();
    let promises = [];
    for (const vtp of Object.values(volumes_to_process))promises.push($e4517613231d656d$var$processVolume(vtp));
    let results = await Promise.all(promises);
    let failed = results.filter((r)=>!r.loaded);
    if (failed.length) {
        let msg = "Failed to load volumes:\n";
        for (const f of failed){
            msg += f.volumeName;
            if (f.loadingFrom === "missing") msg += ": missing volume data";
            msg += "\n";
        }
        msg += "\nMake sure that each .mokuro file is uploaded together with corresponding volume data (images folder or cbz/zip archive).";
        msg += '\n\nClick "What to upload?" for more information.';
        alert(msg);
    }
    document.getElementById("uploadForm").reset();
    await window.catalog.save();
    (0, $bb745140b5fd1d59$export$598b47a92d61271)();
}
async function $e4517613231d656d$var$processVolume(volume_to_process) {
    let mokuroData = volume_to_process.mokuroData;
    let volumeName = volume_to_process.volumeName;
    let archiveFile = volume_to_process.archiveFile;
    let files = volume_to_process.files;
    let volumeLoadingStatus = {
        volumeName: volumeName,
        loadingFrom: null,
        loaded: false
    };
    if (Object.keys(files).length >= mokuroData.pages.length) {
        console.log('Loading volume "' + volumeName + '" from files');
        volumeLoadingStatus.loadingFrom = "files";
    } else if (archiveFile) {
        console.log('Loading volume "' + volumeName + '" from archive');
        volumeLoadingStatus.loadingFrom = "archive";
    } else {
        console.log('Skipping volume "' + volumeName + '" due to missing files');
        volumeLoadingStatus.loadingFrom = "missing";
        return volumeLoadingStatus;
    }
    let title = await window.catalog.addTitleIfNotExists(mokuroData.title, mokuroData.title_uuid);
    let volume = await title.addVolumeIfNotExists(mokuroData, volumeName, mokuroData.volume_uuid);
    await window.catalog.save();
    (0, $bb745140b5fd1d59$export$598b47a92d61271)();
    if (volumeLoadingStatus.loadingFrom === "archive") await $e4517613231d656d$var$loadVolumeFromArchive(volume, volumeName, archiveFile);
    else if (volumeLoadingStatus.loadingFrom === "files") await volume.addImgs(Object.values(files), Object.keys(files));
    else throw new Error("Unknown loadingFrom: " + volumeLoadingStatus.loadingFrom);
    volumeLoadingStatus.loaded = true;
    await window.catalog.save();
    (0, $bb745140b5fd1d59$export$598b47a92d61271)();
    return volumeLoadingStatus;
}
async function $e4517613231d656d$var$loadVolumeFromArchive(volume, volumeName, archiveFile) {
    let data = await archiveFile.arrayBuffer();
    const unzipper = new (0, $74e6804c14a91db6$export$b0c3d2e070472b31)(data);
    // unzipper.addEventListener('progress', function (e) {
    //     // e.currentFilename is the file currently being unarchived/scanned.
    //     // e.totalCompressedBytesRead has how many bytes have been unzipped so far
    // });
    unzipper.addEventListener("extract", async function(e) {
        // e.unarchivedFile.filename: string
        // e.unarchivedFile.fileData: Uint8Array
        let td;
        let relativePath;
        // try to decode filename in utf-8 and fallback to shift JIS if it fails
        try {
            td = new TextDecoder("utf-8", {
                fatal: true
            });
            relativePath = td.decode(e.unarchivedFile.filenameBytes);
        } catch (error) {
            td = new TextDecoder("sjis", {
                fatal: true
            });
            relativePath = td.decode(e.unarchivedFile.filenameBytes);
        }
        // console.log(relativePath);
        let mime_ = (0, (/*@__PURE__*/$parcel$interopDefault($a65ba90ada98487d$exports))).getType(relativePath);
        if (mime_ === "image/jpeg" || mime_ === "image/png") {
            if (relativePath.startsWith(volumeName + "/")) relativePath = relativePath.slice(volumeName.length + 1);
            let file = new File([
                e.unarchivedFile.fileData
            ], relativePath, {
                type: mime_
            });
            await volume.addImg(file, relativePath);
            (0, $bb745140b5fd1d59$export$21b13eb913f4b5da)(volume.id, volume.getStatusString());
            if (volume.isFullyStored()) {
                await window.catalog.save();
                (0, $bb745140b5fd1d59$export$598b47a92d61271)();
            }
        }
    });
    // unzipper.addEventListener('finish', async function (e) {
    //     await window.catalog.save();
    //     updateCatalogDisplay();
    // });
    unzipper.start();
}







window.catalog = null;
window.loadedVolume = null;
window.numPages = -1;
var $2857dc952d963d0e$exports = {};
$2857dc952d963d0e$exports = new URL("service-worker.js", import.meta.url).toString();


if ("serviceWorker" in navigator) navigator.serviceWorker.register($2857dc952d963d0e$exports, {
    scope: "/"
});
document.addEventListener("DOMContentLoaded", async function() {
    console.log("mokuro reader " + (0, $8f13b60c0ee5b277$exports.version));
    (0, $c2e8295866ad447b$export$5f2cc9974f97683b)();
    window.catalog = await (0, $4436b3cc3fc4de73$export$c401078f1496a453).load();
    (0, $bb745140b5fd1d59$export$598b47a92d61271)();
    (0, $89727467ebfe0d15$export$8adb0d4d56f5534c)();
    (0, $e4d24202690ef467$export$b430ef56cf47809b)();
    (0, $e4d24202690ef467$export$d6d42e8cf3bb7a8)();
    if ((0, $ce3de23872348272$export$8e769ad4338a911e).lastOpened === null) {
        await $3fba0bda95caa784$var$loadDemo();
        (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupAbout");
    } else if ((0, $ce3de23872348272$export$8e769ad4338a911e).loadedVolumeId === null) (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupCatalog");
    else await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)((0, $ce3de23872348272$export$8e769ad4338a911e).loadedVolumeId);
    // openPopup("popupHotkeys");
    // openPopup("popupCatalog");
    // openPopup("popupAbout");
    // openPopup("popupSettings");
    (0, $ce3de23872348272$export$8e769ad4338a911e).lastOpened = Date.now();
}, false);
async function $3fba0bda95caa784$var$loadDemo() {
    await (0, $bbee3159e52f04ae$export$dc1b7b81641b4e07)("demo/UchiNoNyan'sDiary.mokuro");
    await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)("demo-volume");
}
document.getElementById("versionDisplay").textContent = (0, $8f13b60c0ee5b277$exports.version);
document.getElementById("menuOriginalSize").addEventListener("click", (0, $89727467ebfe0d15$export$4afa5795c6ff0190), false);
document.getElementById("menuFitToWidth").addEventListener("click", (0, $89727467ebfe0d15$export$9801b4b24c80f370), false);
document.getElementById("menuFitToScreen").addEventListener("click", (0, $89727467ebfe0d15$export$b01a26907ad47277), false);
document.getElementById("menuFullScreen").addEventListener("click", (0, $a6df9c40ba402dc9$export$1cbfa025cd3d026b), false);
document.getElementById("menuAbout").addEventListener("click", function() {
    (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupAbout");
}, false);
document.getElementById("menuCatalog").addEventListener("click", function() {
    (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupCatalog");
}, false);
document.getElementById("menuCloseVolume").addEventListener("click", async function() {
    await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(null);
}, false);
document.getElementById("menuSettings").addEventListener("click", function() {
    (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupSettings");
}, false);
document.getElementById("chooseFilesButton").addEventListener("click", async function() {
    document.getElementById("uploadFile").click();
}, false);
document.getElementById("chooseDirectoryButton").addEventListener("click", async function() {
    document.getElementById("uploadDirectory").click();
}, false);
document.getElementById("importUrlButton").addEventListener("click", (0, $e4517613231d656d$export$452a1d4fe3be249), false);
document.querySelectorAll(".popupCloseButton").forEach(function(x) {
    x.addEventListener("click", (0, $1254bbba71b22eb7$export$e6889fb0929ccf91), false);
});
document.getElementById("dimOverlay").addEventListener("click", function() {
    (0, $1254bbba71b22eb7$export$e6889fb0929ccf91)();
}, false);
document.getElementById("pageIdxInput").addEventListener("change", (e)=>{
    (0, $06134f179bb411c5$export$91e46f7d7a03a319)(e.target.value - 1);
});
document.getElementById("openCatalogButton").addEventListener("click", function() {
    (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupCatalog", false);
}, false);
document.getElementById("hotkeysButton").addEventListener("click", function() {
    (0, $1254bbba71b22eb7$export$c70811ece640d3a1)("popupHotkeys", false);
}, false);
document.getElementById("loadDemoButton").addEventListener("click", function() {
    $3fba0bda95caa784$var$loadDemo();
}, false);
document.getElementById("buttonHideMenu").addEventListener("click", function() {
    document.getElementById("showMenuA").style.display = "inline-block";
    document.getElementById("topMenu").classList.add("hidden");
}, false);
document.getElementById("showMenuA").addEventListener("click", function() {
    document.getElementById("showMenuA").style.display = "none";
    document.getElementById("topMenu").classList.remove("hidden");
}, false);
document.getElementById("buttonLeftLeft").addEventListener("click", (0, $95a7e585c928c714$export$3aab30ada6ab6b9f), false);
document.getElementById("buttonLeft").addEventListener("click", (0, $95a7e585c928c714$export$71c8c73475fc8f30), false);
document.getElementById("buttonRight").addEventListener("click", (0, $95a7e585c928c714$export$10aad5272b594441), false);
document.getElementById("buttonRightRight").addEventListener("click", (0, $95a7e585c928c714$export$93eb63dc599163d6), false);
document.getElementById("leftAPage").addEventListener("click", (0, $95a7e585c928c714$export$71c8c73475fc8f30), false);
document.getElementById("leftAScreen").addEventListener("click", (0, $95a7e585c928c714$export$71c8c73475fc8f30), false);
document.getElementById("rightAPage").addEventListener("click", (0, $95a7e585c928c714$export$10aad5272b594441), false);
document.getElementById("rightAScreen").addEventListener("click", (0, $95a7e585c928c714$export$10aad5272b594441), false);
document.addEventListener("keydown", async function onEvent(e) {
    let activeElement = document.activeElement;
    if (activeElement.contentEditable === "true") return;
    switch(e.key){
        case "ArrowLeft":
            if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).turnPagesWithArrows) await (0, $95a7e585c928c714$export$71c8c73475fc8f30)();
            break;
        case "ArrowRight":
            if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).turnPagesWithArrows) await (0, $95a7e585c928c714$export$10aad5272b594441)();
            break;
        case "ArrowUp":
            if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).turnPagesWithArrows) await (0, $95a7e585c928c714$export$c69f739c940da70d)();
            break;
        case "ArrowDown":
            if ((0, $480eb26aa317c74a$export$a5a6e0b888b2c992).turnPagesWithArrows) await (0, $95a7e585c928c714$export$4765883fd82fa203)();
            break;
        case "PageUp":
            await (0, $95a7e585c928c714$export$c69f739c940da70d)();
            break;
        case "PageDown":
            await (0, $95a7e585c928c714$export$4765883fd82fa203)();
            break;
        case "Home":
            (0, $95a7e585c928c714$export$224ec33f20c570b5)();
            break;
        case "End":
            (0, $95a7e585c928c714$export$ad257fef69e3ed2d)();
            break;
        case " ":
            await (0, $95a7e585c928c714$export$4765883fd82fa203)();
            break;
        case "0":
            (0, $89727467ebfe0d15$export$24b5fa69f2944279)();
            break;
        case ",":
            await (0, $95a7e585c928c714$export$e84f2743569f1488)();
            break;
        case ".":
            await (0, $95a7e585c928c714$export$3c5caec86028df0d)();
            break;
        case "c":
            (0, $1254bbba71b22eb7$export$60212eb953f44d00)("popupCatalog");
            break;
        case "s":
            (0, $1254bbba71b22eb7$export$60212eb953f44d00)("popupSettings");
            break;
        case "Escape":
            (0, $1254bbba71b22eb7$export$e6889fb0929ccf91)();
            break;
        case "f":
            (0, $a6df9c40ba402dc9$export$1cbfa025cd3d026b)();
            break;
        case "h":
            (0, $1254bbba71b22eb7$export$60212eb953f44d00)("popupAbout");
            break;
        case "x":
            await (0, $d3be05650a2343a6$export$40a8bc4c5e0cfd05)(null);
            break;
        case "d":
            if (window.loadedVolume !== null) (0, $e4d24202690ef467$export$d763c08db4890a86)("volume", "doublePageView", !(0, $480eb26aa317c74a$export$a5a6e0b888b2c992).doublePageView);
            break;
        case "j":
            if (window.loadedVolume !== null) (0, $e4d24202690ef467$export$d763c08db4890a86)("volume", "r2l", !(0, $480eb26aa317c74a$export$a5a6e0b888b2c992).r2l);
            break;
        case "p":
            if (window.loadedVolume !== null) (0, $e4d24202690ef467$export$d763c08db4890a86)("volume", "hasCover", !(0, $480eb26aa317c74a$export$a5a6e0b888b2c992).hasCover);
            break;
        case "r":
            if (window.loadedVolume !== null) {
                (0, $480eb26aa317c74a$export$a5a6e0b888b2c992).resetVolume();
                (0, $e4d24202690ef467$export$b430ef56cf47809b)();
                (0, $e4d24202690ef467$export$d6d42e8cf3bb7a8)();
                (0, $06134f179bb411c5$export$91e46f7d7a03a319)();
            }
            break;
    }
});
document.addEventListener("click", function(e) {
    if (e.target.closest(".textBox") === null) (0, $592fe74d6221bed0$export$6456ab0d288ef170)();
}, false);


//# sourceMappingURL=index.53754596.js.map
